/* eslint-disable prettier/prettier */

import DarkMode from '@mui/icons-material/DarkMode'

export const tokens = {
  common: {
    welcome: 'common.welcome',
    welcomeLogin: 'common.welcomeLogin',
    welcomeLoginText: 'common.welcomeLoginText',
    nabuLogo: 'common.nabuLogo',
    yes: 'common.yes',
    login: 'common.login',
    clear: 'common.clear',
    createdAt: 'common.createdAt',
    created: 'common.created',
    step: 'common.step',
    updatedAt: 'common.updatedAt',
    loginError: 'common.loginError',
    unknownError: 'common.unknownError',
    emailSendError: 'common.emailSendError',
    selectUser: 'common.selectUser',
    notes: 'common.notes',
    none: 'common.none',
    returnToLoginPage: 'common.returnToLoginPage',
    unknownUser: 'common.unknownUser',
    theActionWasSuccessful: 'common.theActionWasSuccessful',
    clientOrganization: 'common.clientOrganization',
    logout: 'common.logout',
    impersonatingAs: 'common.impersonatingAs',
    stopImpersonation: 'common.stopImpersonation',
    impersonationTimeLeft: 'common.impersonationTimeLeft',
    impersonationExpired: 'common.impersonationExpired',
    impersonationClosed: 'common.impersonationClosed',
    impersonationOpening: 'common.impersonationOpening',
    impersonationLinkInvalid: 'common.impersonationLinkInvalid',
    smartPreparationAnnouncement: 'common.smartPreparationAnnouncement',
    smartPreparationBadge: 'common.smartPreparationBadge',
    smartPreparationTry: 'common.smartPreparationTry',
    smartPreparationLearnMore: 'common.smartPreparationLearnMore',
    search: 'common.search',
    noAccount: 'common.noAccount',
    needAccountHelp: 'common.needAccountHelp',
    anErrorOccurred: 'store.anErrorOccurred',
    updateDeclarationOwner: 'common.updateDeclarationOwner',
    changeOwnerForCurrentDeclaration: 'common.changeOwnerForCurrentDeclaration',
    declarationOwner: 'common.declarationOwner',
    questionForgotPassword: 'common.questionForgotPassword',
    forgotPasswordText: 'common.forgotPasswordText',
    forgotPassword: 'common.forgotPassword',
    enterNewPassword: 'common.enterNewPassword',
    passwordConfirmation: 'common.passwordConfirmation',
    oldPasswordRequired: 'common.oldPasswordRequired',
    newPasswordRequired: 'common.newPasswordRequired',
    warningRulesForNewPassword: 'common.warningRulesForNewPassword',
    emailSent: 'common.emailSent',
    passwordResetEmailConfirmTitle: 'common.passwordResetEmailConfirmTitle',
    passwordResetEmailConfirmDescription:
      'common.passwordResetEmailConfirmDescription',
    passwordChangedSuccessTitle: 'common.passwordChangedSuccessTitle',
    passwordChangedSuccessDescription:
      'common.passwordChangedSuccessDescription',
    recoveryLinkInvalidTitle: 'common.recoveryLinkInvalidTitle',
    recoveryLinkInvalidDescription: 'common.recoveryLinkInvalidDescription',
    requestNewLink: 'common.requestNewLink',
    exportTypeRequired: 'common.exportTypeRequired',
    exportTypeUnknown: 'common.exportTypeUnknown',
    send: 'common.send',
    contactUs: 'common.contactUs',
    confirm: 'common.confirm',
    validate: 'common.validate',
    currentOwner: 'common.currentOwner',
    currentGroup: 'common.currentGroup',
    delete: 'common.delete',
    cancel: 'common.cancel',
    errorRenameModelName: 'common.errorRenameModelName',
    continue: 'common.continue',
    next: 'common.next',
    back: 'common.back',
    close: 'common.close',
    create: 'common.create',
    upload: 'common.upload',
    sentDocuments: 'common.sentDocuments',
    sentFolders: 'common.sentFolders',
    tableConsolidated: 'common.tableConsolidated',
    tableNotConsolidated: 'common.tableNotConsolidated',
    numberofLinesSent: 'common.numberofLinesSent',
    add: 'common.add',
    languageChanged: 'common.languageChanged',
    manager: 'common.manager',
    guest: 'common.guest',
    admin: 'common.admin',
    selectAGroup: 'common.selectAGroup',
    selectAConfiguration: 'common.selectAConfiguration',
    user: 'common.user',
    superadmin: 'common.superadmin',
    mail: 'common.mail',
    email: 'common.email',
    mailHook: 'common.mailHook',
    regenerateMailHook: 'common.regenerateMailHook',
    mailHookDescription: 'common.mailHookDescription',
    copy: 'common.copy',
    holdToConfirmNudge: 'common.holdToConfirmNudge',
    holdToConfirmHint: 'common.holdToConfirmHint',
    confirmed: 'common.confirmed',
    copied: 'common.copied',
    copyFailed: 'common.copyFailed',
    name: 'common.name',
    role: 'common.role',
    date: 'common.date',
    classification: 'common.classification',
    member: 'common.member',
    members: 'common.members',
    administrator: 'common.administrator',
    administrators: 'common.administrators',
    sendInvite: 'common.sendInvite',
    inviteMember: 'common.inviteMember',
    inviteMembers: 'common.inviteMembers',
    inviteAdministrator: 'common.inviteAdministrator',
    inviteAdministrators: 'common.inviteAdministrators',
    inviteSomeAdministrators: 'common.inviteSomeAdministrators',
    atLeastOneInvitedPeople: 'common.atLeastOneInvitedPeople',
    maxOneInvitedPeople: 'common.maxOneInvitedPeople',
    sendInvitation: 'common.sendInvitation',
    deleteInvitation: 'common.deleteInvitation',
    socialName: 'common.socialName',
    registrationNumber: 'common.registrationNumber',
    country: 'common.country',
    organization: 'common.organization',
    organizationAndEstablishments: 'common.organizationAndEstablishments',
    somethingWentWrong: 'common.somethingWentWrong',
    general: 'common.general',
    lastName: 'common.lastName',
    firstName: 'common.firstName',
    function: 'common.function',
    preferences: 'common.preferences',
    password: 'common.password',
    position: 'common.position',
    language: 'common.language',
    help: 'common.help',
    helpAndSupport: 'common.helpAndSupport',
    supportChat: 'common.supportChat',
    supportChatUnread: 'common.supportChatUnread',
    supportChatMoveHint: 'common.supportChatMoveHint',
    active: 'common.active',
    group: 'common.group',
    groups: 'common.groups',
    export: 'common.export',
    import: 'common.import',
    transit: 'common.transit',
    groupSettings: 'common.groupSettings',
    selectGroup: 'common.selectGroup',
    userSettings: 'common.userSettings',
    collaborators: 'common.collaborators',
    update: 'common.update',
    parameters: 'common.parameters',
    external: 'common.external',
    validEmail: 'common.validEmail',
    required: 'common.required',
    emailRequired: 'common.emailRequired',
    passwordRequired: 'common.passwordRequired',
    passwordConfirmationRequired: 'common.passwordConfirmationRequired',
    matchPasswordsRequired: 'common.matchPasswordsRequired',
    passwordRuleLowercase: 'common.passwordRuleLowercase',
    passwordRuleUppercase: 'common.passwordRuleUppercase',
    passwordRuleDigit: 'common.passwordRuleDigit',
    passwordRuleSpecial: 'common.passwordRuleSpecial',
    passwordRuleLength: 'common.passwordRuleLength',
    firstNameRequired: 'common.firstNameRequired',
    lastNameRequired: 'common.lastNameRequired',
    roleRequired: 'common.roleRequired',
    languageRequired: 'common.languageRequired',
    organizationRequired: 'common.organizationRequired',
    groupRequired: 'common.groupRequired',
    socialNameRequired: 'common.socialNameRequired',
    registrationNumberRequired: 'common.registrationNumberRequired',
    countryRequired: 'common.countryRequired',
    affiliatedGroup: 'common.affiliatedGroup',
    share: 'common.share',
    registeredCustomsRepresentative: 'common.registeredCustomsRepresentative',
    customsManager: 'common.customsManager',
    customsTeamManager: 'common.customsTeamManager',
    informationSystemsManager: 'common.informationSystemsManager',
    nabuAdministrator: 'common.nabuAdministrator',
    french: 'common.french',
    english: 'common.english',
    german: 'common.german',
    basicInformation: 'common.basicInformation',
    personalInformation: 'common.personalInformation',
    companyInformation: 'common.companyInformation',
    organizationAndGroups: 'common.organizationAndGroups',
    establishmentsAndGroups: 'common.establishmentsAndGroups',
    settings: 'common.settings',
    save: 'common.save',
    saving: 'common.saving',
    saved: 'common.saved',
    changePassword: 'common.changePassword',
    oldPassword: 'common.oldPassword',
    newPassword: 'common.newPassword',
    passwordChangeSuccess: 'common.passwordChangeSuccess',
    passwordChangeError: 'common.passwordChangeError',
    fileName: 'common.fileName',
    generalInformation: 'common.generalInformation',
    offices: 'common.offices',
    edit: 'common.edit',
    accessInformations: 'common.accessInformations',
    deleteAccount: 'common.deleteAccount',
    deleteAccountWarning: 'common.deleteAccountWarning',
    client: 'common.client',
    status: 'common.status',
    actions: 'common.actions',
    option10: 'common.option10',
    option20: 'common.option20',
    option50: 'common.option50',
    searchByCaseName: 'common.searchByCaseName',
    all: 'common.all',
    noOptions: 'common.noOptions',
    pending: 'common.pending',
    from: 'common.from',
    to: 'common.to',
    view: 'common.view',
    folder: 'common.folder',
    declaration: 'common.declaration',
    customDeclaration: 'common.customDeclaration',
    billOfLading: 'common.billOfLading',
    exported: 'common.exported',
    toTreat: 'common.toTreat',
    archived: 'common.archived',
    inProgress: 'common.inProgress',
    category: 'common.category',
    noOptionAvailable: 'common.noOptionAvailable',
    searchByName: 'common.searchByName',
    layerName: 'common.layerName',
    modelName: 'common.modelName',
    modelSearchPlaceholder: 'common.modelSearchPlaceholder',
    modelTabName: 'common.modelTabName',
    modelTabType: 'common.modelTabType',
    declarationType: 'common.declarationType',
    flowTabExporter: 'common.flowTabExporter',
    flowTabCreatedBy: 'common.flowTabCreatedBy',
    flowTabDate: 'common.flowTabDate',
    modelDeleteOneTitle: 'common.modelDeleteOneTitle',
    modelDeleteMultipleTitle: 'common.modelDeleteMultipleTitle',
    modelDeleteOneText: 'common.modelDeleteOneText',
    modelDeleteMultipleText: 'common.modelDeleteMultipleText',
    modelHasBeenDeleted: 'common.modelHasBeenDeleted',
    modelHasNotBeenDeleted: 'common.modelHasNotBeenDeleted',
    modelShareToOtherGroup: 'common.modelShareToOtherGroup',
    modelShareToOtherGroupText: 'common.modelShareToOtherGroupText',
    team: 'common.team',
    profil: 'common.profil',
    teamName: 'common.teamName',
    office: 'common.office',
    loggedIn: 'common.loggedIn',
    permissionError: 'common.permissionError',
    permissionAndAccess: 'common.permissionAndAccess',
    fieldNotFound: 'common.fieldNotFound',
    failToSave: 'common.failToSAve',
    security: 'common.security',
    metrics: 'common.metrics',
    copiedToClipBoard: 'common.copiedToClipBoard',
    setup: 'common.setup',
    setups: 'common.setups',
    addSetup: 'common.addSetup',
    noItemFound: 'common.noItemFound',
    noSetup: 'common.noSetup',
    noSetupGroup: 'common.noSetupGroup',
    editSetup: 'common.editSetup',
    createSetup: 'common.createSetup',
    download: 'common.download',
    file: 'common.file',
    files: 'common.files',
    regularCustomer: 'common.regularCustomer',
    punctualCustomer: 'common.punctualCustomer',
    creationOfNewFolder: 'common.creationOfNewFolder',
    folderCreationInProgress: 'common.folderCreationInProgress',
    emailFrom: 'common.emailFrom',
    workInProgress: 'common.workInProgress',
    document: 'common.document',
    model: 'common.model',
    models: 'common.models',
    information: 'common.information',
    exportConfiguration: 'common.exportConfiguration',
    confirmationRequired: 'common.confirmationRequired',
    rowsPerPage: 'common.rowsPerPage',
    displayedRows: 'common.displayedRows',
    details: 'common.details',
    backToHome: 'common.backToHome',
    message401: 'common.message401',
    message404: 'common.message404',
    message500: 'common.message500',
    titleErrorPage: 'common.titleErrorPage',
    messageErrorPage: 'common.messageErrorPage',
    key: 'common.key',
    configurations: 'commmon.configurations',
    configuration: 'commmon.configuration',
    userSettingsNoParameter: 'common.userSettingsNoParameter',
    commonError: 'common.commonError',
    author: 'common.author',
    noFiles: 'common.noFiles',
    notification: 'common.notification',
    createdBy: 'common.createdBy',
    sendBy: 'common.sendBy',
    updateSucceeded: 'common.updateSucceeded',
    updateFailed: 'common.updateFailed',
    filesDropInputWrongFormat: 'common.filesDropInputWrongFormat',
    hintMessageFirstText: 'common.hintMessageFirstText',
    hintMessageSecondText: 'common.hintMessageSecondText',
    hintMessageThirdText: 'common.hintMessageThirdText',
    hintMessageFourthText: 'common.hintMessageFourthText',
    thisActionCannotBeUndone: 'common.thisActionCannotBeUndone',
    remove: 'common.remove',
    unknown: 'common.unknown',
    selectAction: 'common.selectAction',
    deselect: 'common.deselect',
    expandAll: 'common.expandAll',
    collapseAll: 'common.collapseAll',
    week: 'common.week',
    month: 'common.month',
    validated: 'common.validated',
    seeDetails: 'common.seeDetails',
    hideDetails: 'common.hideDetails',
    start: 'common.start',
    end: 'common.end',
    clearAll: 'common.clearAll',
    noCustomersSelected: 'common.noCustomersSelected',
    articles: 'common.articles',
    commodityCodesFilled: 'common.commodityCodesFilled',
    dossierDrawerPosition: 'common.dossierDrawerPosition',
    dossierDrawerPrevious: 'common.dossierDrawerPrevious',
    dossierDrawerNext: 'common.dossierDrawerNext',
    dossierDrawerCopyReference: 'common.dossierDrawerCopyReference',
    dossierDrawerOverview: 'common.dossierDrawerOverview',
    dossierDrawerActivity: 'common.dossierDrawerActivity',
    dossierDrawerPreparation: 'common.dossierDrawerPreparation',
    dossierDrawerStepReceived: 'common.dossierDrawerStepReceived',
    dossierDrawerStepPrefilled: 'common.dossierDrawerStepPrefilled',
    dossierDrawerStepToTreat: 'common.dossierDrawerStepToTreat',
    dossierDrawerStepCompleted: 'common.dossierDrawerStepCompleted',
    dossierDrawerParties: 'common.dossierDrawerParties',
    dossierDrawerDetails: 'common.dossierDrawerDetails',
    dossierDrawerComplete: 'common.dossierDrawerComplete',
    dossierDrawerAddTag: 'common.dossierDrawerAddTag',
    dossierDrawerNoFiles: 'common.dossierDrawerNoFiles',
    dossierDrawerNoActivity: 'common.dossierDrawerNoActivity',
    inlineEditSaveFailed: 'common.inlineEditSaveFailed',
    inlineEditRetry: 'common.inlineEditRetry',
    inlineEditCancel: 'common.inlineEditCancel',
    inlineEditHintDisplay: 'common.inlineEditHintDisplay',
    inlineEditHintEdit: 'common.inlineEditHintEdit',
    inlineEditHintEditMultiline: 'common.inlineEditHintEditMultiline',
    inlineEditSaving: 'common.inlineEditSaving',
    inlineEditSaved: 'common.inlineEditSaved',
    dossierDrawerNameLabel: 'common.dossierDrawerNameLabel',
    dossierNameRequired: 'common.dossierNameRequired',
    mode: 'common.mode',
    delivered: 'common.delivered',
    lastModified: 'common.lastModified',
    lastModifiedAt: 'common.lastModifiedAt',
    tags: 'common.tags',
    type: 'common.type',
    downloadArchive: 'common.downloadArchive',
    downloadValueDetail: 'common.downloadValueDetail',
    viewDetail: 'common.viewDetail',
    show: 'common.show',
    hide: 'common.hide',
    noteSucccessfullySaved: 'common.noteSucccessfullySaved',
    errorOccuredWhileSavingNote: 'common.errorOccuredWhileSavingNote',
    offline: 'common.offline',
    online: 'common.online',
    maintenanceTitle: 'common.maintenanceTitle',
    maintenanceUntil: 'common.maintenanceUntil',
    maintenanceNoEnd: 'common.maintenanceNoEnd',
    maintenanceSessionKept: 'common.maintenanceSessionKept',
    newVersionAvailableMessage: 'common.newVersionAvailableMessage',
    refreshPageForNewVersion: 'common.refreshPageForNewVersion',
    noTags: 'common.noTags',
    declarant: 'common.declarant',
    editComment: 'common.editComment',
    deleteComment: 'common.deleteComment',
    addAComment: 'common.addAComment',
    areYouSureYouWantToDeleteThisComment:
      'common.areYouSureYouWantToDeleteThisComment',
    urgent: 'common.urgent',
    sendUrgent: 'common.sendUrgent',
    putFileErrorStatus: 'common.putFileErrorStatus',
    subscribers: 'common.subscribers',
    typeAnEmailAndPressEnter: 'common.typeAnEmailAndPressEnter',
    autoMode: 'common.autoMode',
    darkMode: 'common.darkMode',
    lightMode: 'common.lightMode',
    theme: 'common.theme',
    themePressToCycle: 'common.themePressToCycle',
  },

  events: {
    declarationReceivedBy: 'events.declarationReceivedBy',
    creationAndExtractionOfDeclaration:
      'events.creationAndExtractionOfDeclaration',
    missingDataIdentified: 'events.missingDataIdentified',
    missingDataAddedFromDataLibrary: 'events.missingDataAddedFromDataLibrary',
    informationRequested: 'events.informationRequested',
    informationReceived: 'events.informationReceived',
    declarationValidationsCompleted: 'events.declarationValidationsCompleted',
    declarationFinalized: 'events.declarationFinalized',
    declarationFinalizedBy: 'events.declarationFinalizedBy',
    declarationSent: 'events.declarationSent',
    processingStopped: 'events.processingStopped',
  },

  batchImportHistory: {
    historyDrawerTitle: 'batchImportHistory.historyDrawerTitle',
    historyOpenTooltip: 'batchImportHistory.historyOpenTooltip',
    historySearchPlaceholder: 'batchImportHistory.historySearchPlaceholder',
    historySearchEmpty: 'batchImportHistory.historySearchEmpty',
    historyEmpty: 'batchImportHistory.historyEmpty',
    historyLoadError: 'batchImportHistory.historyLoadError',
    historyRetry: 'batchImportHistory.historyRetry',
    historyExpand: 'batchImportHistory.historyExpand',
    historyCollapse: 'batchImportHistory.historyCollapse',
    historyActorSystem: 'batchImportHistory.historyActorSystem',
    historyActorUnknownUser: 'batchImportHistory.historyActorUnknownUser',
    historyFieldsCount: 'batchImportHistory.historyFieldsCount',
    historyFieldsCount_other: 'batchImportHistory.historyFieldsCount_other',
    historyReplacedFields: 'batchImportHistory.historyReplacedFields',
    historyEmptyValue: 'batchImportHistory.historyEmptyValue',
    historyRowSuffix: 'batchImportHistory.historyRowSuffix',
    historyActionDeclarationModified:
      'batchImportHistory.historyActionDeclarationModified',
    historyActionDeclarationCreated:
      'batchImportHistory.historyActionDeclarationCreated',
    historyActionDeclarationSent:
      'batchImportHistory.historyActionDeclarationSent',
    historyActionAutomationRun: 'batchImportHistory.historyActionAutomationRun',
    historyActionExtractionRerun:
      'batchImportHistory.historyActionExtractionRerun',
    historyActionClassificationRerun:
      'batchImportHistory.historyActionClassificationRerun',
    historyActionMerge: 'batchImportHistory.historyActionMerge',
    historyActionMergeColumnsTitle:
      'batchImportHistory.historyActionMergeColumnsTitle',
    historyActionMergeBatchImportsTitle:
      'batchImportHistory.historyActionMergeBatchImportsTitle',
    historyActionMarkedError: 'batchImportHistory.historyActionMarkedError',
    historyActionTagAdded: 'batchImportHistory.historyActionTagAdded',
    historyActionClientChanged: 'batchImportHistory.historyActionClientChanged',
    historyActionRowDeleted: 'batchImportHistory.historyActionRowDeleted',
    historyActionFileAdded: 'batchImportHistory.historyActionFileAdded',
    historyFilesCount: 'batchImportHistory.historyFilesCount',
    historyFilesCount_other: 'batchImportHistory.historyFilesCount_other',
    historyDeletedRowValues: 'batchImportHistory.historyDeletedRowValues',
    historyRowLabel: 'batchImportHistory.historyRowLabel',
    historyDocumentsCount: 'batchImportHistory.historyDocumentsCount',
    historyDocumentsCount_other:
      'batchImportHistory.historyDocumentsCount_other',
    historyMergeColumns: 'batchImportHistory.historyMergeColumns',
    historyMergeColumns_other: 'batchImportHistory.historyMergeColumns_other',
    historyMergeBatchImports: 'batchImportHistory.historyMergeBatchImports',
    historyMergeBatchImports_other:
      'batchImportHistory.historyMergeBatchImports_other',
    historyMarkedErrorManual: 'batchImportHistory.historyMarkedErrorManual',
    historyMarkedErrorUploadFailed:
      'batchImportHistory.historyMarkedErrorUploadFailed',
    historyMarkedErrorMissingSuffix:
      'batchImportHistory.historyMarkedErrorMissingSuffix',
    historyFilterAll: 'batchImportHistory.historyFilterAll',
    historyFilterCorrections: 'batchImportHistory.historyFilterCorrections',
    historyUndoCorrection: 'batchImportHistory.historyUndoCorrection',
    historyRedoCorrection: 'batchImportHistory.historyRedoCorrection',
    historyRevertedAt: 'batchImportHistory.historyRevertedAt',
    historyCorrectionSet: 'batchImportHistory.historyCorrectionSet',
    historyCorrectionClear: 'batchImportHistory.historyCorrectionClear',
    historyCorrectionValidate: 'batchImportHistory.historyCorrectionValidate',
    historyCorrectionReviewConfirmed:
      'batchImportHistory.historyCorrectionReviewConfirmed',
    historyCorrectionReviewReopened:
      'batchImportHistory.historyCorrectionReviewReopened',
    historyCorrectionAddTuple: 'batchImportHistory.historyCorrectionAddTuple',
    historyCorrectionRemoveTuple:
      'batchImportHistory.historyCorrectionRemoveTuple',
    historyCorrectionClearColumn:
      'batchImportHistory.historyCorrectionClearColumn',
    historyCorrectionSetColumn: 'batchImportHistory.historyCorrectionSetColumn',
    historyCorrectionAddLine: 'batchImportHistory.historyCorrectionAddLine',
    historyCorrectionRemoveLine:
      'batchImportHistory.historyCorrectionRemoveLine',
    historyCorrectionUnvalidate:
      'batchImportHistory.historyCorrectionUnvalidate',
    historyCorrectionAbandonRevision:
      'batchImportHistory.historyCorrectionAbandonRevision',
  },

  configuration: {
    configurationNameWarning: 'configurationNameWarning',
    addAField: 'addAField',
    typeTransportWarning: 'typeTransportWarning',
    nameTransportWarning: 'nameTransportWarning',
    addressTransportWarning: 'addressTransportWarning',
    portTransportWarning: 'portTransportWarning',
    emailAuthenticationTransportWarning: 'emailAuthenticationTransportWarning',
    passwordAuthenticationTransportWarning:
      'passwordAuthenticationTransportWarning',
    configurationSaved: 'configurationSaved',
    configurationName: 'configurationName',
    softwareName: 'softwareName',
    typeTransport: 'typeTransport',
    addressTransport: 'addressTransport',
    portTransport: 'portTransport',
    emailAuthenticationTransport: 'emailAuthenticationTransport',
    passwordAuthenticationTransport: 'passwordAuthenticationTransport',
    pleaseChooseAGroupAndAConfiguration:
      'configuration.pleaseChooseAGroupAndAConfiguration',
    pleaseChooseAConfiguration: 'configuration.pleaseChooseAConfiguration',
    noSettingsFoundForConfiguration:
      'configuration.noSettingsFoundForConfiguration',
    noSettingsAvailableForConfiguration:
      'configuration.noSettingsAvailableForConfiguration',
    availableSettingKeys: 'configuration.availableSettingKeys',
    youHaveUnsavedConfigurationChanges:
      'configuration.youHaveUnsavedConfigurationChanges',
    cannotRemoveLastTupleItem: 'configuration.cannotRemoveLastTupleItem',
  },

  upload: {
    exportService: 'upload.exportService',
    declarationType: 'upload.declarationType',
    model: 'upload.model',
    dropText: 'upload.dropText',
    emailHookText: 'upload.emailHookText',
    atLeastOneFileRequired: 'upload.atLeastOneFileRequired',
    warningOnNumberFilesMinimum: 'upload.warningOnNumberFilesMinimum',
    warningOnNumberFilesMaximum: 'upload.warningOnNumberFilesMaxiumum',
    requiredFiles: 'upload.requiredFiles',
    requiredCustomerType: 'upload.requiredCustomerType',
    requiredRecordName: 'upload.requiredRecordName',
    warningOnRecordNameLength: 'upload.warningOnRecordNameLength',
    requiredExportConfiguration: 'upload.requiredExportCOnfiguration',
    requiredDeclarationType: 'upload.requiredDeclarationType',
    requiredModelConfiguration: 'upload.requiredModelConfiguration',
    requiredGroup: 'upload.requiredGroup',
    noModelFound: 'upload.noModelFound',
    modelWarning: 'upload.modelWarning',
    agenticLabel: 'upload.agenticLabel',
    nfRequired: 'upload.nfRequired',
    wizardStepFilesLabel: 'upload.wizardStepFilesLabel',
    wizardStepFilesSubtitle: 'upload.wizardStepFilesSubtitle',
    wizardStepFolderLabel: 'upload.wizardStepFolderLabel',
    wizardStepFolderSubtitle: 'upload.wizardStepFolderSubtitle',
    wizardPreparationSectionTitle: 'upload.wizardPreparationSectionTitle',
    wizardPreparationModeStandardTitle: 'upload.wizardPreparationModeStandardTitle',
    wizardPreparationModeStandardDescription:
      'upload.wizardPreparationModeStandardDescription',
    wizardPreparationModeIntelligentTitle:
      'upload.wizardPreparationModeIntelligentTitle',
    wizardPreparationModeIntelligentDescription:
      'upload.wizardPreparationModeIntelligentDescription',
    wizardPreparationModeNewBadge: 'upload.wizardPreparationModeNewBadge',
    wizardFilesStepGuidance: 'upload.wizardFilesStepGuidance',
    wizardFilesStepGuidanceClassic: 'upload.wizardFilesStepGuidanceClassic',
    wizardStepCounter: 'upload.wizardStepCounter',
    wizardCompleteRequiredFields: 'upload.wizardCompleteRequiredFields',
    wizardAddAtLeastOneFile: 'upload.wizardAddAtLeastOneFile',
    wizardSubmitting: 'upload.wizardSubmitting',
    wizardCreating: 'upload.wizardCreating',
    wizardCreated: 'upload.wizardCreated',
    wizardDropTitle: 'upload.wizardDropTitle',
    wizardDropTitleActive: 'upload.wizardDropTitleActive',
    wizardDropSubtitle: 'upload.wizardDropSubtitle',
    wizardAddFiles: 'upload.wizardAddFiles',
    wizardRemoveFile: 'upload.wizardRemoveFile',
    wizardFilesCount: 'upload.wizardFilesCount',
    wizardFilesCount_other: 'upload.wizardFilesCount_other',
    wizardFolderNamePlaceholder: 'upload.wizardFolderNamePlaceholder',
    wizardFolderNameSuggested: 'upload.wizardFolderNameSuggested',
    wizardAgencyLabel: 'upload.wizardAgencyLabel',
    wizardAgencyHint: 'upload.wizardAgencyHint',
    wizardAgencyOrganizationBadge: 'upload.wizardAgencyOrganizationBadge',
    wizardAgencyClearToOrganization: 'upload.wizardAgencyClearToOrganization',
    wizardNoAgencyOption: 'upload.wizardNoAgencyOption',
    wizardTypePlaceholder: 'upload.wizardTypePlaceholder',
    wizardTypePrefilledHint: 'upload.wizardTypePrefilledHint',
    wizardTypeTooltip: 'upload.wizardTypeTooltip',
    wizardChooseGroupFirst: 'upload.wizardChooseGroupFirst',
    wizardWorkflowLabel: 'upload.wizardWorkflowLabel',
    wizardWorkflowHint: 'upload.wizardWorkflowHint',
    wizardWorkflowTooltip: 'upload.wizardWorkflowTooltip',
    wizardWorkflowPlaceholder: 'upload.wizardWorkflowPlaceholder',
    wizardNoWorkflowForCombination: 'upload.wizardNoWorkflowForCombination',
    wizardClientHint: 'upload.wizardClientHint',
    wizardClientSearchPlaceholder: 'upload.wizardClientSearchPlaceholder',
    wizardNoClientOption: 'upload.wizardNoClientOption',
    wizardNoClientFound: 'upload.wizardNoClientFound',
    wizardNoWorkflowFound: 'upload.wizardNoWorkflowFound',
    wizardOptionsLoading: 'upload.wizardOptionsLoading',
    wizardTagsHint: 'upload.wizardTagsHint',
    wizardTagsPlaceholder: 'upload.wizardTagsPlaceholder',
    wizardOptionsButton: 'upload.wizardOptionsButton',
    wizardQuickCreateButton: 'upload.wizardQuickCreateButton',
    wizardQuickCreateButtonInAgency: 'upload.wizardQuickCreateButtonInAgency',
    wizardQuickCreateTooltip: 'upload.wizardQuickCreateTooltip',
    wizardCreateFolderButton: 'upload.wizardCreateFolderButton',
  },

  documents: {
    creationWindowRecent: 'documents.creationWindowRecent',
    creationWindowAll: 'documents.creationWindowAll',
    creationWindowShowAll: 'documents.creationWindowShowAll',
    creationWindowShowRecent: 'documents.creationWindowShowRecent',
    collaborators: 'documents.collaborators',
    statusExported: 'documents.statusExported',
    statusToRead: 'documents.statusToRead',
    statusExtraction: 'documents.statusExtraction',
    statusToTreat: 'documents.statusToTreat',
    createNewFlowFromThisDeclaration:
      'documents.createNewFlowFromThisDeclaration',
    statusError: 'documents.statusError',
    statusAbandoned: 'documents.statusAbandoned',
    statusExportFailed: 'documents.statusExportFailed',
    batchImportErrorTitle: 'documents.batchImportErrorTitle',
    batchImportAbandonedTitle: 'documents.batchImportAbandonedTitle',
    batchImportAbandonedWhatToDo: 'documents.batchImportAbandonedWhatToDo',
    batchImportErrorReasonProcessingTimeout: 'documents.batchImportErrorReasonProcessingTimeout',
    batchImportErrorReasonWorkflowLost: 'documents.batchImportErrorReasonWorkflowLost',
    batchImportErrorReasonWorkflowStuck: 'documents.batchImportErrorReasonWorkflowStuck',
    batchImportErrorReasonFilesTimeout: 'documents.batchImportErrorReasonFilesTimeout',
    batchImportErrorReasonHumanTimeout: 'documents.batchImportErrorReasonHumanTimeout',
    batchImportErrorReasonNoUsableDocument: 'documents.batchImportErrorReasonNoUsableDocument',
    batchImportErrorReasonStepFailed: 'documents.batchImportErrorReasonStepFailed',
    batchImportErrorReasonNoTypedDocument: 'documents.batchImportErrorReasonNoTypedDocument',
    batchImportErrorReasonNoGroupConfiguration: 'documents.batchImportErrorReasonNoGroupConfiguration',
    batchImportErrorReasonBlockingDiagnostic: 'documents.batchImportErrorReasonBlockingDiagnostic',
    batchImportErrorReasonEmptyDeclaration: 'documents.batchImportErrorReasonEmptyDeclaration',
    batchImportErrorReasonRepeatedBlock: 'documents.batchImportErrorReasonRepeatedBlock',
    batchImportErrorReasonUnknown: 'documents.batchImportErrorReasonUnknown',
    batchImportErrorStoppedAt: 'documents.batchImportErrorStoppedAt',
    batchImportErrorStoppedAtStep: 'documents.batchImportErrorStoppedAtStep',
    batchImportErrorStoppedAtTime: 'documents.batchImportErrorStoppedAtTime',
    batchImportErrorEarlierStepsSucceeded: 'documents.batchImportErrorEarlierStepsSucceeded',
    batchImportErrorStepAwaitingUploads: 'documents.batchImportErrorStepAwaitingUploads',
    batchImportErrorStepFileProcessing: 'documents.batchImportErrorStepFileProcessing',
    batchImportErrorStepExtraction: 'documents.batchImportErrorStepExtraction',
    batchImportErrorStepMapping: 'documents.batchImportErrorStepMapping',
    batchImportErrorWhatToDo: 'documents.batchImportErrorWhatToDo',
    batchImportErrorWhatToDoFilesMissing: 'documents.batchImportErrorWhatToDoFilesMissing',
    batchImportErrorContactSupport: 'documents.batchImportErrorContactSupport',
    batchImportErrorContactButton: 'documents.batchImportErrorContactButton',
    batchImportErrorSupportMessage: 'documents.batchImportErrorSupportMessage',
    batchImportErrorRecreate: 'documents.batchImportErrorRecreate',
    batchImportErrorRetryButton: 'documents.batchImportErrorRetryButton',
    batchImportErrorRetryFailed: 'documents.batchImportErrorRetryFailed',
    batchImportErrorNotified: 'documents.batchImportErrorNotified',
    statusToSend: 'documents.statusToSend',
    statusSent: 'document.statusSent',
    visualizeDocuments: 'document.visualizeDocuments',
    downloadDeclarationXML: 'document.downloadDeclarationXML',
    downloadDetailValue: 'document.downloadDetailValue',
    downloadOrginalDocuments: 'document.downloadOrginalDocuments',
    declarationExportNotFound: 'documents.declarationExportNotFound',
    valueDetailExportNotFound: 'documents.valueDetailExportNotFound',
    typeDocument: 'document.typeDocument',
    nameDocument: 'document.nameDocument',
    statusInProgress: 'documents.statusInProgress',
    statusArchived: 'documents.statusArchived',
    statusUploaded: 'documents.statusUploaded',
    statusUnknown: 'documents.statusUnknown',
    removeRecordTitle: 'documents.removeRecordTitle',
    removeRecordsTitle: 'documents.removeRecordsTitle',
    removeRecordText: 'documemts.removeRecordText',
    removeRecordsText: 'documemts.removeRecordsText',
    deleteFolderTitle: 'documents.deleteFolderTitle',
    deleteFolderUnnamedTitle: 'documents.deleteFolderUnnamedTitle',
    deleteFoldersTitle: 'documents.deleteFoldersTitle',
    deleteFolderText: 'documents.deleteFolderText',
    deleteFoldersText: 'documents.deleteFoldersText',
    deleteFoldersUnnamedText: 'documents.deleteFoldersUnnamedText',
    deleteFoldersOthers: 'documents.deleteFoldersOthers',
    deleteFoldersOthers_other: 'documents.deleteFoldersOthers_other',
    deleteFolderQuotedName: 'documents.deleteFolderQuotedName',
    deleteFolderConfirm: 'documents.deleteFolderConfirm',
    removePendingRecordTitle: 'documents.removePendingRecordTitle',
    removePendingRecordsTitle: 'documents.removePendingRecordsTitle',
    removePendingRecordText: 'documemts.removePendingRecordText',
    removePendingRecordsText: 'documemts.removePendingRecordsText',
    documentHasBeenDeleted: 'documents.documentHasBeenDeleted',
    documentHasNotBeenDeleted: 'documents.documentHasNotBeenDeleted',
    documentHasBeenDeleted_other: 'documents.documentHasBeenDeleted_other',
    documentHasNotBeenDeleted_other:
      'documents.documentHasNotBeenDeleted_other',
    documentHasBeenUpdated: 'documents.documentHasBeenUpdated',
    noDocumentFound: 'documents.noDocumentFound',
    starting: 'documents.starting',
    bulkSelectedCount: 'documents.bulkSelectedCount',
    bulkSelectedCount_other: 'documents.bulkSelectedCount_other',
    bulkDuplicate: 'documents.bulkDuplicate',
    bulkApplyTag: 'documents.bulkApplyTag',
    bulkDownloadDocuments: 'documents.bulkDownloadDocuments',
    bulkDelete: 'documents.bulkDelete',
    foldersDuplicated: 'documents.foldersDuplicated',
    foldersDuplicated_other: 'documents.foldersDuplicated_other',
    foldersNotDuplicated: 'documents.foldersNotDuplicated',
    foldersNotDuplicated_other: 'documents.foldersNotDuplicated_other',
    tagsAppliedToFolders: 'documents.tagsAppliedToFolders',
    tagsAppliedToFolders_other: 'documents.tagsAppliedToFolders_other',
    bulkDownloadStarted: 'documents.bulkDownloadStarted',
    bulkDownloadError: 'documents.bulkDownloadError',
    bulkDownloadOutputFiles: 'documents.bulkDownloadOutputFiles',
    bulkDownloadOutputFilesPartial: 'documents.bulkDownloadOutputFilesPartial',
    bulkDownloadOutputFilesPartial_other: 'documents.bulkDownloadOutputFilesPartial_other',
    bulkDownloadOutputFilesNone: 'documents.bulkDownloadOutputFilesNone',
    bulkDownloadOutputFilesError: 'documents.bulkDownloadOutputFilesError',
    attachmentCount: 'documents.attachmentCount',
    revisionInProgress: 'documents.revisionInProgress',
  },

  export: {
    confirmExportTitle: 'export.confirmExportTitle',
    confirmExportText: 'export.confirmExportText',
    confirmExport: 'export.confirmExport',
    successToExport: 'export.successToExport',
    notExtracted: 'export.notExtracted',
  },

  teams: {
    teamName: 'teams.teamName',
    removeFromGroup: 'teams.removeFromGroup',
    youHaveNoTeam: 'teams.youHaveNoTeam',
    createATeam: 'teams.createATeam',
    noRole: 'teams.noRole',
  },

  activity: {
    lastActivity: 'activity.lastActivity',
    subTitleLastActivity: 'activity.subTitleLastActivity',
    seeSentDocuments: 'activity.seeSentDocuments',
    seeDocumentsToManage: 'activity.seeDocumentsToManage',
    seeDocuments: 'activity.seeDocuments',
    exportedDocuments: 'activity.exportedDocuments',
  },

  nav: {
    account: 'nav.account',
    settings: 'nav.settings',
    managementConsole: 'nav.managementConsole',
    analytics: 'nav.analytics',
    auth: 'nav.auth',
    browse: 'nav.browse',
    contact: 'nav.contact',
    create: 'nav.create',
    customers: 'nav.customers',
    dashboard: 'nav.dashboard',
    gobackToDeclaration: 'nav.gobackToDeclaration',
    backoffice: 'nav.backoffice',
    database: 'nav.database',
    customerFlow: 'nav.customerFlow',
    customer: 'nav.customer',
    data: 'nav.data',
    models: 'nav.models',
    referentials: 'nav.referentials',
    automation: 'nav.automation',
    workflows: 'nav.workflows',
    details: 'nav.details',
    edit: 'nav.edit',
    error: 'nav.error',
    feed: 'nav.feed',
    fileManager: 'nav.fileManager',
    files: 'nav.files',
    forgotPassword: 'nav.forgotPassword',
    list: 'nav.list',
    login: 'nav.login',
    mcpConsent: 'nav.mcpConsent',
    impersonate: 'nav.impersonate',
    mail: 'nav.mail',
    management: 'nav.management',
    orderList: 'nav.orders',
    overview: 'nav.overview',
    organizations: 'nav.organizations',
    pages: 'nav.pages',
    postCreate: 'nav.postCreate',
    postDetails: 'nav.postDetails',
    postList: 'nav.postList',
    pricing: 'nav.pricing',
    productList: 'nav.products',
    fieldList: 'nav.fields',
    fieldToRead: 'nav.fieldsToRead',
    fieldToManage: 'nav.fieldsToManage',
    pendingField: 'nav.pendingField',
    fieldExported: 'nav.fieldsExported',
    fieldDeleted: 'nav.fieldDeleted',
    pendingDocuments: 'nav.pendingDocuments',
    sentDocuments: 'nav.sentDocuments',
    removedDocuments: 'nav.removedDocuments',
    profile: 'nav.profile',
    register: 'nav.register',
    resetPassword: 'nav.resetPassword',
    connectors: 'nav.connectors',
    users: 'nav.users',
    expandSideNav: 'nav.expandSideNav',
    collapseSideNav: 'nav.collapseSideNav',
    accountMenuTooltip: 'nav.accountMenuTooltip',
  },

  backoffice: {
    createUser: 'backoffice.createUser',
    deleteUser: 'backoffice.deleteUser',
    successSendEmailMessage: 'backoffice.successSendEmailMessage',
    users: 'backoffice.users',
    importLayer: 'backoffice.importLayer',
    chooseLayerName: 'backoffice.chooseLayerName',
    selectDocumentType: 'backoffice.selectDocumentType',
    onlyFirstPage: 'backoffice.onlyFirstPage',
    acceptedFormats: 'backoffice.acceptedFormats',
    maxSize: 'backoffice.maxSize',
    exportConfig: 'backoffice.exportConfig',
    layerNameIsRequired: 'backoffice.layerNameIsRequired',
    documentTypeIsRequired: 'backoffice.documentTypeIsRequired',
    exportConfigurationIsRequired: 'backoffice.exportConfigurationIsRequired',
    deleteOrganization: 'backoffice.deleteOrganization',
  },

  organizations: {
    organizationsTitle: 'organizations.organizationsTitle',
    organizationTitle: 'organizations.organizationTitle',
  },

  dashboard: {
    all: 'dashboard.all',
    pending: 'dashboard.pending',
    toBeProcessed: 'dashboard.toBeProcessed',
    inProgress: 'dashboard.inProgress',
    completed: 'dashboard.completed',
    error: 'dashboard.error',
    abandoned: 'dashboard.abandoned',
    canceled: 'dashboard.canceled',
    rejected: 'dashboard.rejected',
    returned: 'dashboard.returned',
    uploading: 'dashboard.uploading',
    extracting: 'dashboard.extracting',
    batchImport: 'dashboard.batchImport',
    pendingRecords: 'dashboard.pendingRecords',
    recordsToManage: 'dashboard.recordToManage',
    exportedRecords: 'dashboard.exportedRecords',
    seeRecords: 'dashboard.seeRecords',
    seeExportedRecords: 'dashboard.seeExportedRecords',
    createOrganization: 'dashboard.createOrganization',
    createOffice: 'dashboard.createOffice',
    officeCreated: 'dashboard.officeCreated',
    officeDeleted: 'dashboard.officeDeleted',
    userCreated: 'dashboard.userCreated',
    userUpdated: 'dashboard.editCustomer',
    punctualCustomer: 'dashboard.punctualCustomer',
    regularCustomer: 'dashboard.regularCustomer',
    organizationCreated: 'dashboard.organizationCreated',
    deleteOrganization: 'dashboard.deleteOrganization',
    deleteUser: 'dashboard.deleteUser',
    organizationAndGroups: 'dashboard.organizationAndGroups',
    selectGroups: 'dashboard.selectGroups',
    inviteCollaborators: 'dashboard.inviteCollaborator',
    externalCollaborator: 'dashboard.externalCollaborator',
    removeCollaborator: 'dashboard.removeCollaborator',
    removeOrganizationTitle: 'dashboard.removeOrganizationTitle',
    removeOrganizationText: 'dashboard.removeOrganizationText',
    removeUserTitle: 'dashboard.removeUserTitle',
    removeUserText: 'dashboard.removeUserText',
    sendInvitationEmailTitle: 'dashboard.sendInvitationEmailTitle',
    sendInvitationEmailText: 'dashboard.sendInvitationEmailText',
    manageDocuments: 'dashboard.manageDocuments',
    dropFilesHere: 'dashboard.dropFilesHere',
    useNewFolderButton: 'dashboard.useNewFolderButton',
    newFolderButton: 'dashboard.newFolderButton',
    folderInformation: 'dashboard.folderInformation',
    folderName: 'dashboard.folderName',
    customer: 'dashboard.customer',
    exportService: 'dashboard.exportService',
    typeDeclarationService: 'dashboard.typeDeclarationService',
    cancel: 'dashboard.cancel',
    upload: 'dashboard.upload',
    addNewCustomer: 'dashboard.addNewCustomer',
    customerName: 'dashboard.customerName',
    createNewCustomer: 'dashboard.createNewCustomer',
    theEmailWasCopiedToYourClipboard:
      'dashboard.theEmailWasCopiedToYourClipboard',
    fastTrackFirstText: 'dashboard.fastTrackFirstText',
    fastTrackSecondText: 'dashboard.fastTrackSecondText',
    fastTrackTooltipText: 'dashboard.fastTrackTooltipText',
    isCurrentlyInAnErrorState: 'dashboard.isCurrentlyInAnErrorState',
    declarationInErrorState: 'dashboard.declarationInErrorState',
    itsLastReportedStateWas: 'dashboard.itsLastReportedStateWas',
    ourTechnicalTeamHasBeenNotified:
      'dashboard.ourTechnicalTeamHasBeenNotified',
    pleaseContactCustomerServiceForFurtherInformation:
      'dashboard.pleaseContactCustomerServiceForFurtherInformation',
    created: 'dashboard.created',
    clientOrganization: 'dashboard.clientOrganization',
    reference: 'dashboard.reference',
    customerReference: 'dashboard.customerReference',
    noReference: 'dashboard.noReference',
    type: 'dashboard.type',
    timing: 'dashboard.timing',
    clientName: 'dashboard.clientName',
    status: 'dashboard.status',
    noDeclarationsFound: 'dashboard.noDeclarationsFound',
    searchForADeclaration: 'dashboard.searchForADeclaration',
    searchNameMaxLengthHint: 'dashboard.searchNameMaxLengthHint',
    tracking: 'dashboard.tracking',
    pastDue: 'dashboard.pastDue',
    importer: 'dashboard.importer',
    exporter: 'dashboard.exporter',
    noExporterIndicated: 'dashboard.noExporterIndicated',
    noImporterIndicated: 'dashboard.noImporterIndicated',
    emailSender: 'dashboard.emailSender',
    emailSubject: 'dashboard.emailSubject',
    emailSendingDate: 'dashboard.emailSendingDate',
    details: 'dashboard.details',
    viewDetails: 'dashboard.viewDetails',
    openInfoPanel: 'dashboard.openInfoPanel',
    tags: 'dashboard.tags',
    tag: 'dashboard.tag',
    noTags: 'dashboard.noTags',
    addTag: 'dashboard.addTag',
    createTag: 'dashboard.createTag',
    tagName: 'dashboard.tagName',
    source: 'dashboard.source',
    description: 'dashboard.description',
    group: 'dashboard.group',
    declarant: 'dashboard.declarant',
    filter: 'dashboard.filter',
    clearAll: 'dashboard.clearAll',
    addFilter: 'dashboard.addFilter',
    allFilterActive: 'dashboard.allFilterActive',
    allTypes: 'dashboard.allTypes',
    user: 'dashboard.user',
    sendDate: 'dashboard.sendDate',
    apply: 'dashboard.apply',
    search: 'dashboard.search',
    noResults: 'dashboard.noResults',
    lastDay: 'dashboard.lastDay',
    last3Days: 'dashboard.last3Days',
    lastWeek: 'dashboard.lastWeek',
    lastMonth: 'dashboard.lastMonth',
    last3Months: 'dashboard.last3Months',
    lastYear: 'dashboard.lastYear',
    customDateRange: 'dashboard.customDateRange',
    saveFilter: 'dashboard.saveFilter',
    customizeView: 'dashboard.customizeView',
    customizeViewTitle: 'dashboard.customizeViewTitle',
    customizeViewSubtitle: 'dashboard.customizeViewSubtitle',
    columnRequired: 'dashboard.columnRequired',
    visibleColumnsCount: 'dashboard.visibleColumnsCount',
    sortAscending: 'dashboard.sortAscending',
    sortDescending: 'dashboard.sortDescending',
    savedFilters: 'dashboard.savedFilters',
    filterName: 'dashboard.filterName',
    noSavedFilters: 'dashboard.noSavedFilters',
    saveSearch: 'dashboard.saveSearch',
    savedSearches: 'dashboard.savedSearches',
    searchName: 'dashboard.searchName',
    noSavedSearches: 'dashboard.noSavedSearches',
    unknown: 'dashboard.unknown',
    from: 'dashboard.from',
    to: 'dashboard.to',
  },

  dashboardV2: {
    kicker: 'dashboardV2.kicker',
    greeting: 'dashboardV2.greeting',
    searchPlaceholder: 'dashboardV2.searchPlaceholder',
    searchNoResults: 'dashboardV2.searchNoResults',
    searchLoading: 'dashboardV2.searchLoading',
    exportTitle: 'dashboardV2.exportTitle',
    customizeStart: 'dashboardV2.customizeStart',
    customizeStop: 'dashboardV2.customizeStop',

    kpiToProcessLabel: 'dashboardV2.kpiToProcessLabel',
    kpiToProcessSub: 'dashboardV2.kpiToProcessSub',
    kpiErrorLabel: 'dashboardV2.kpiErrorLabel',
    kpiSentLabel: 'dashboardV2.kpiSentLabel',
    kpiSentSub: 'dashboardV2.kpiSentSub',
    kpiSentPrevious: 'dashboardV2.kpiSentPrevious',
    kpiSentPrevious_other: 'dashboardV2.kpiSentPrevious_other',
    kpiSentPreviousNone: 'dashboardV2.kpiSentPreviousNone',
    kpiSentFewer: 'dashboardV2.kpiSentFewer',
    kpiSentMore: 'dashboardV2.kpiSentMore',
    kpiSentSame: 'dashboardV2.kpiSentSame',
    kpiTrendFrom: 'dashboardV2.kpiTrendFrom',
    kpiTrendFrom_other: 'dashboardV2.kpiTrendFrom_other',
    kpiTrendToday: 'dashboardV2.kpiTrendToday',
    kpiTrendTodaySame: 'dashboardV2.kpiTrendTodaySame',
    kpiTrendTodayOnly: 'dashboardV2.kpiTrendTodayOnly',
    seeDossiers: 'dashboardV2.seeDossiers',

    activityTitle: 'dashboardV2.activityTitle',
    activitySubtitle: 'dashboardV2.activitySubtitle',
    seeAll: 'dashboardV2.seeAll',
    filterAll: 'dashboardV2.filterAll',
    filterToProcess: 'dashboardV2.filterToProcess',
    filterSent: 'dashboardV2.filterSent',
    filterError: 'dashboardV2.filterError',
    colName: 'dashboardV2.colName',
    colType: 'dashboardV2.colType',
    colStatus: 'dashboardV2.colStatus',
    colDate: 'dashboardV2.colDate',
    emptyCategory: 'dashboardV2.emptyCategory',
    staleTooltip: 'dashboardV2.staleTooltip',
    staleBadgeMinutes: 'dashboardV2.staleBadgeMinutes',
    staleBadgeHours: 'dashboardV2.staleBadgeHours',
    staleBadgeDays: 'dashboardV2.staleBadgeDays',
    staleBadgeWeeks: 'dashboardV2.staleBadgeWeeks',
    staleBadgeMonths: 'dashboardV2.staleBadgeMonths',

    aiTitle: 'dashboardV2.aiTitle',
    aiSubtitle: 'dashboardV2.aiSubtitle',
    aiHeadlineSuffix: 'dashboardV2.aiHeadlineSuffix',
    aiHeadlineSub: 'dashboardV2.aiHeadlineSub',
    aiCreditsFooter: 'dashboardV2.aiCreditsFooter',
    aiEmptyTitle: 'dashboardV2.aiEmptyTitle',
    aiEmptyBody: 'dashboardV2.aiEmptyBody',
    aiEmptyCta: 'dashboardV2.aiEmptyCta',
    aiRowPrefilled: 'dashboardV2.aiRowPrefilled',
    aiRowPrefilledMeta: 'dashboardV2.aiRowPrefilledMeta',
    aiRowAnomalies: 'dashboardV2.aiRowAnomalies',
    aiRowAnomaliesMeta: 'dashboardV2.aiRowAnomaliesMeta',
    aiRowSuggestions: 'dashboardV2.aiRowSuggestions',
    aiRowSuggestionsMeta: 'dashboardV2.aiRowSuggestionsMeta',
    aiRowFields: 'dashboardV2.aiRowFields',
    aiRowFieldsMeta: 'dashboardV2.aiRowFieldsMeta',

    teamTitle: 'dashboardV2.teamTitle',
    teamSubtitle: 'dashboardV2.teamSubtitle',
    teamSubtitleStats: 'dashboardV2.teamSubtitleStats',
    teamRangeWeek: 'dashboardV2.teamRangeWeek',
    teamRangeMonth: 'dashboardV2.teamRangeMonth',
    teamLateBadge: 'dashboardV2.teamLateBadge',
    teamOverloadBadge: 'dashboardV2.teamOverloadBadge',
    teamAgencySelect: 'dashboardV2.teamAgencySelect',
    teamEmpty: 'dashboardV2.teamEmpty',
    teamError: 'dashboardV2.teamError',
    teamUnknownMember: 'dashboardV2.teamUnknownMember',
    colDeclarant: 'dashboardV2.colDeclarant',
    colProcessed: 'dashboardV2.colProcessed',
    colInProgress: 'dashboardV2.colInProgress',
    colLate: 'dashboardV2.colLate',
    colRate: 'dashboardV2.colRate',
    colLoad: 'dashboardV2.colLoad',
    lateTooltip: 'dashboardV2.lateTooltip',
    rateTooltip: 'dashboardV2.rateTooltip',
    loadTooltip: 'dashboardV2.loadTooltip',

    fluxTitle: 'dashboardV2.fluxTitle',
    fluxSubtitle: 'dashboardV2.fluxSubtitle',
    fluxEmpty: 'dashboardV2.fluxEmpty',
    fluxError: 'dashboardV2.fluxError',
    fluxMonthlyLabel: 'dashboardV2.fluxMonthlyLabel',
    fluxAllFlows: 'dashboardV2.fluxAllFlows',
    fluxBreakdownLabel: 'dashboardV2.fluxBreakdownLabel',
    fluxTotalLabel: 'dashboardV2.fluxTotalLabel',
    fluxTotalUnit: 'dashboardV2.fluxTotalUnit',
    fluxTooltipDeclarations: 'dashboardV2.fluxTooltipDeclarations',
    typeImport: 'dashboardV2.typeImport',
    typeExport: 'dashboardV2.typeExport',
    typeTransit: 'dashboardV2.typeTransit',

    cplxTitle: 'dashboardV2.cplxTitle',
    cplxSubtitle: 'dashboardV2.cplxSubtitle',
    cplxTierSmall: 'dashboardV2.cplxTierSmall',
    cplxTierMedium: 'dashboardV2.cplxTierMedium',
    cplxTierLarge: 'dashboardV2.cplxTierLarge',
    cplxColDossiers: 'dashboardV2.cplxColDossiers',
    cplxColBenchmark: 'dashboardV2.cplxColBenchmark',
    cplxColMeasured: 'dashboardV2.cplxColMeasured',
    cplxColGain: 'dashboardV2.cplxColGain',
    cplxMeasuredSub: 'dashboardV2.cplxMeasuredSub',
    cplxAvgTimeLabel: 'dashboardV2.cplxAvgTimeLabel',
    cplxLegendBenchmark: 'dashboardV2.cplxLegendBenchmark',
    cplxLegendMeasured: 'dashboardV2.cplxLegendMeasured',
    cplxTooltipBenchmark: 'dashboardV2.cplxTooltipBenchmark',
    cplxTooltipMeasured: 'dashboardV2.cplxTooltipMeasured',

    editBannerText: 'dashboardV2.editBannerText',
    resetCta: 'dashboardV2.resetCta',
    doneCta: 'dashboardV2.doneCta',
    newRowLabel: 'dashboardV2.newRowLabel',
    dropNewRowBottom: 'dashboardV2.dropNewRowBottom',
    hideBlock: 'dashboardV2.hideBlock',
    showBlock: 'dashboardV2.showBlock',
    dragHandleTitle: 'dashboardV2.dragHandleTitle',

    sectionKpi: 'dashboardV2.sectionKpi',
    sectionActivity: 'dashboardV2.sectionActivity',
    sectionAi: 'dashboardV2.sectionAi',
    sectionTeam: 'dashboardV2.sectionTeam',
    sectionFlux: 'dashboardV2.sectionFlux',
    sectionComplexity: 'dashboardV2.sectionComplexity',
  },

  declarationProgress: {
    title: 'declarationProgress.title',
    subtitleReady: 'declarationProgress.subtitleReady',
    subtitleWaitingHuman: 'declarationProgress.subtitleWaitingHuman',
    groupDocuments: 'declarationProgress.groupDocuments',
    groupData: 'declarationProgress.groupData',
    groupDeclaration: 'declarationProgress.groupDeclaration',
    stateDone: 'declarationProgress.stateDone',
    stateRunning: 'declarationProgress.stateRunning',
    stateBlocked: 'declarationProgress.stateBlocked',
    statePending: 'declarationProgress.statePending',
    stepAwaitingUploadsLabel: 'declarationProgress.stepAwaitingUploadsLabel',
    stepAwaitingUploadsHint: 'declarationProgress.stepAwaitingUploadsHint',
    stepFileProcessingLabel: 'declarationProgress.stepFileProcessingLabel',
    stepFileProcessingHint: 'declarationProgress.stepFileProcessingHint',
    stepAwaitingClassificationLabel:
      'declarationProgress.stepAwaitingClassificationLabel',
    stepAwaitingClassificationHint:
      'declarationProgress.stepAwaitingClassificationHint',
    stepExtractionLabel: 'declarationProgress.stepExtractionLabel',
    stepExtractionHint: 'declarationProgress.stepExtractionHint',
    stepAwaitingReviewLabel: 'declarationProgress.stepAwaitingReviewLabel',
    stepAwaitingReviewHint: 'declarationProgress.stepAwaitingReviewHint',
    stepAwaitingConfigurationLabel:
      'declarationProgress.stepAwaitingConfigurationLabel',
    stepAwaitingConfigurationHint:
      'declarationProgress.stepAwaitingConfigurationHint',
    stepMappingLabel: 'declarationProgress.stepMappingLabel',
    stepMappingHint: 'declarationProgress.stepMappingHint',
    stepInstructionRoutineLabel: 'declarationProgress.stepInstructionRoutineLabel',
    stepInstructionRoutineHint: 'declarationProgress.stepInstructionRoutineHint',
    stepAwaitingDeclarationLabel:
      'declarationProgress.stepAwaitingDeclarationLabel',
    stepAwaitingDeclarationHint:
      'declarationProgress.stepAwaitingDeclarationHint',
    resumeTitle: 'declarationProgress.resumeTitle',
    resumeHint: 'declarationProgress.resumeHint',
    resumeAction: 'declarationProgress.resumeAction',
    resumeError: 'declarationProgress.resumeError',
    detailFiles: 'declarationProgress.detailFiles',
    stepAssemblyLabel: 'declarationProgress.stepAssemblyLabel',
    stepAssemblyHint: 'declarationProgress.stepAssemblyHint',
    detailAssembly: 'declarationProgress.detailAssembly',
    detailAssemblyPlanner: 'declarationProgress.detailAssemblyPlanner',
    detailPages: 'declarationProgress.detailPages',
    detailDocuments: 'declarationProgress.detailDocuments',
    detailRead: 'declarationProgress.detailRead',
    detailBlocked: 'declarationProgress.detailBlocked',
    detailChosenAutomatically: 'declarationProgress.detailChosenAutomatically',
    detailParties: 'declarationProgress.detailParties',
    decType_import: 'declarationProgress.decType_import',
    decType_export: 'declarationProgress.decType_export',
    decType_ens: 'declarationProgress.decType_ens',
    decType_transit: 'declarationProgress.decType_transit',
  },

  declarationValidationProgress: {
    sectionRequired: 'declarationValidationProgress.sectionRequired',
    sectionBlocking: 'declarationValidationProgress.sectionBlocking',
  },

  tariffClassification: {
    statusValid: 'tariffClassification.statusValid',
    statusIncomplete: 'tariffClassification.statusIncomplete',
    statusUnknown: 'tariffClassification.statusUnknown',
    statusMissing: 'tariffClassification.statusMissing',
    authorAuto: 'tariffClassification.authorAuto',
    received: 'tariffClassification.received',
    residual: 'tariffClassification.residual',
    apply: 'tariffClassification.apply',
    cancel: 'tariffClassification.cancel',
    close: 'tariffClassification.close',
    productName: 'tariffClassification.productName',
    colArticles: 'tariffClassification.colArticles',
    bannerTitle: 'tariffClassification.bannerTitle',
    bannerTitle_one: 'tariffClassification.bannerTitle_one',
    bannerBody: 'tariffClassification.bannerBody',
    preview: 'tariffClassification.preview',
    dialogTitle: 'tariffClassification.dialogTitle',
    dialogTitle_one: 'tariffClassification.dialogTitle_one',
    dialogIntro: 'tariffClassification.dialogIntro',
    colReceived: 'tariffClassification.colReceived',
    colCompleted: 'tariffClassification.colCompleted',
    colLabel: 'tariffClassification.colLabel',
    skippedOutOfScope: 'tariffClassification.skippedOutOfScope',
    skippedOutOfScope_one: 'tariffClassification.skippedOutOfScope_one',
    skippedAmbiguous: 'tariffClassification.skippedAmbiguous',
    skippedAmbiguous_one: 'tariffClassification.skippedAmbiguous_one',
    autoNote: 'tariffClassification.autoNote',
    confirm: 'tariffClassification.confirm',
    confirm_one: 'tariffClassification.confirm_one',
    done: 'tariffClassification.done',
    done_one: 'tariffClassification.done_one',
    undo: 'tariffClassification.undo',
    reasonAuto: 'tariffClassification.reasonAuto',
    reasonUser: 'tariffClassification.reasonUser',
    reasonUndo: 'tariffClassification.reasonUndo',
    tourStepIntroTitle: 'tariffClassification.tourStepIntroTitle',
    tourStepIntroBody: 'tariffClassification.tourStepIntroBody',
    tourStepPreviewTitle: 'tariffClassification.tourStepPreviewTitle',
    tourStepPreviewBody: 'tariffClassification.tourStepPreviewBody',
    tourStepPreviewButtonTitle: 'tariffClassification.tourStepPreviewButtonTitle',
    tourStepPreviewButtonBody: 'tariffClassification.tourStepPreviewButtonBody',
    tourStepPreviewTitleTitle: 'tariffClassification.tourStepPreviewTitleTitle',
    tourStepPreviewTitleBody: 'tariffClassification.tourStepPreviewTitleBody',
    tourStepPreviewTableTitle: 'tariffClassification.tourStepPreviewTableTitle',
    tourStepPreviewTableBody: 'tariffClassification.tourStepPreviewTableBody',
    tourStepPreviewCheckboxTitle: 'tariffClassification.tourStepPreviewCheckboxTitle',
    tourStepPreviewCheckboxBody: 'tariffClassification.tourStepPreviewCheckboxBody',
    tourStepPreviewCompletedTitle: 'tariffClassification.tourStepPreviewCompletedTitle',
    tourStepPreviewCompletedBody: 'tariffClassification.tourStepPreviewCompletedBody',
    tourStepPreviewLabelTitle: 'tariffClassification.tourStepPreviewLabelTitle',
    tourStepPreviewLabelBody: 'tariffClassification.tourStepPreviewLabelBody',
    tourStepPreviewSkippedTitle: 'tariffClassification.tourStepPreviewSkippedTitle',
    tourStepPreviewSkippedBody: 'tariffClassification.tourStepPreviewSkippedBody',
    tourStepPreviewAutoTitle: 'tariffClassification.tourStepPreviewAutoTitle',
    tourStepPreviewAutoBody: 'tariffClassification.tourStepPreviewAutoBody',
    tourStepPreviewConfirmTitle: 'tariffClassification.tourStepPreviewConfirmTitle',
    tourStepPreviewConfirmBody: 'tariffClassification.tourStepPreviewConfirmBody',
    tourStepCardTitle: 'tariffClassification.tourStepCardTitle',
    tourStepCardBody: 'tariffClassification.tourStepCardBody',
    tourStepFiltersTitle: 'tariffClassification.tourStepFiltersTitle',
    tourStepFiltersBody: 'tariffClassification.tourStepFiltersBody',
    tourStepReviewTitle: 'tariffClassification.tourStepReviewTitle',
    tourStepReviewBody: 'tariffClassification.tourStepReviewBody',
    tourStepDirectoryTargetTitle: 'tariffClassification.tourStepDirectoryTargetTitle',
    tourStepDirectoryTargetBody: 'tariffClassification.tourStepDirectoryTargetBody',
    tourStepDirectorySearchTitle: 'tariffClassification.tourStepDirectorySearchTitle',
    tourStepDirectorySearchBody: 'tariffClassification.tourStepDirectorySearchBody',
    tourStepDirectoryScopeTitle: 'tariffClassification.tourStepDirectoryScopeTitle',
    tourStepDirectoryScopeBody: 'tariffClassification.tourStepDirectoryScopeBody',
    tourStepGridTitle: 'tariffClassification.tourStepGridTitle',
    tourStepGridBody: 'tariffClassification.tourStepGridBody',
    tourStepHelpTitle: 'tariffClassification.tourStepHelpTitle',
    tourStepHelpBody: 'tariffClassification.tourStepHelpBody',
    clearSearch: 'tariffClassification.clearSearch',
    openTaric: 'tariffClassification.openTaric',
    openTaricTooltip: 'tariffClassification.openTaricTooltip',
    openRitaTooltip: 'tariffClassification.openRitaTooltip',
    incompleteCount: 'tariffClassification.incompleteCount',
    incompleteCount_one: 'tariffClassification.incompleteCount_one',
    openInOtherWindow: 'tariffClassification.openInOtherWindow',
    openedInOtherWindow: 'tariffClassification.openedInOtherWindow',
    otherWindowDisabled: 'tariffClassification.otherWindowDisabled',
    measureStateConditional: 'tariffClassification.measureStateConditional',
    measureStateInapplicable: 'tariffClassification.measureStateInapplicable',
    browsePosition: 'tariffClassification.browsePosition',
    browsePrevious: 'tariffClassification.browsePrevious',
    browseNext: 'tariffClassification.browseNext',
    toCheck: 'tariffClassification.toCheck',
    cellComplete: 'tariffClassification.cellComplete',
    cellAuto: 'tariffClassification.cellAuto',
    cellCompleteHint: 'tariffClassification.cellCompleteHint',
    cellAutoHint: 'tariffClassification.cellAutoHint',
    cellIncompleteHint: 'tariffClassification.cellIncompleteHint',
    cellUnknownHint: 'tariffClassification.cellUnknownHint',
    verifDecisionsTitle: 'tariffClassification.verifDecisionsTitle',
    verifDecisionsTitle_one: 'tariffClassification.verifDecisionsTitle_one',
    verifCompleteTitle: 'tariffClassification.verifCompleteTitle',
    verifOpenTarifill: 'tariffClassification.verifOpenTarifill',
    verifContextLead: 'tariffClassification.verifContextLead',
    verifContextLines: 'tariffClassification.verifContextLines',
    verifContextRest: 'tariffClassification.verifContextRest',
    verifGroupChoice: 'tariffClassification.verifGroupChoice',
    verifGroupAuto: 'tariffClassification.verifGroupAuto',
    verifPillChoice: 'tariffClassification.verifPillChoice',
    verifPillAuto: 'tariffClassification.verifPillAuto',
    verifAnalysis: 'tariffClassification.verifAnalysis',
    verifRead: 'tariffClassification.verifRead',
    verifReadValue: 'tariffClassification.verifReadValue',
    verifReadValue_one: 'tariffClassification.verifReadValue_one',
    verifValidStart: 'tariffClassification.verifValidStart',
    verifValidStartValue: 'tariffClassification.verifValidStartValue',
    verifAuto: 'tariffClassification.verifAuto',
    verifAutoValue: 'tariffClassification.verifAutoValue',
    verifAutoValue_one: 'tariffClassification.verifAutoValue_one',
    completedByTarifill: 'tariffClassification.completedByTarifill',
    receivedShort: 'tariffClassification.receivedShort',
    noDesignation: 'tariffClassification.noDesignation',
    directoryLink: 'tariffClassification.directoryLink',
    treeLoading: 'tariffClassification.treeLoading',
    treeFailed: 'tariffClassification.treeFailed',
    tourStepDirectoryTreeTitle: 'tariffClassification.tourStepDirectoryTreeTitle',
    tourStepDirectoryTreeBody: 'tariffClassification.tourStepDirectoryTreeBody',
    measuresDemoNote: 'tariffClassification.measuresDemoNote',
    groupSplit: 'tariffClassification.groupSplit',
    moreDesignations: 'tariffClassification.moreDesignations',
    reviewStart: 'tariffClassification.reviewStart',
    reviewPosition: 'tariffClassification.reviewPosition',
    reviewDone: 'tariffClassification.reviewDone',
    reviewProgress: 'tariffClassification.reviewProgress',
    reviewExit: 'tariffClassification.reviewExit',
    reviewPrevious: 'tariffClassification.reviewPrevious',
    reviewSkip: 'tariffClassification.reviewSkip',
    reviewHintPick: 'tariffClassification.reviewHintPick',
    reviewHintMove: 'tariffClassification.reviewHintMove',
    keyEscape: 'tariffClassification.keyEscape',
    filterChapter: 'tariffClassification.filterChapter',
    filterAllChapters: 'tariffClassification.filterAllChapters',
    chapterOption: 'tariffClassification.chapterOption',
    showNext: 'tariffClassification.showNext',
    levelChapter: 'tariffClassification.levelChapter',
    levelHeading: 'tariffClassification.levelHeading',
    levelSubheading: 'tariffClassification.levelSubheading',
    levelCn: 'tariffClassification.levelCn',
    levelTaric: 'tariffClassification.levelTaric',
    askAssistant: 'tariffClassification.askAssistant',
    openRita: 'tariffClassification.openRita',
    assistantPromptReceived: 'tariffClassification.assistantPromptReceived',
    assistantPromptReceived_one: 'tariffClassification.assistantPromptReceived_one',
    assistantPromptMissing: 'tariffClassification.assistantPromptMissing',
    assistantPromptMissing_one: 'tariffClassification.assistantPromptMissing_one',
    assistantPromptDesignations: 'tariffClassification.assistantPromptDesignations',
    assistantPromptOrigin: 'tariffClassification.assistantPromptOrigin',
    assistantPromptBranches: 'tariffClassification.assistantPromptBranches',
    assistantPromptAsk: 'tariffClassification.assistantPromptAsk',
    missingDigits: 'tariffClassification.missingDigits',
    missingDigits_one: 'tariffClassification.missingDigits_one',
    notInNomenclature: 'tariffClassification.notInNomenclature',
    pickCandidate: 'tariffClassification.pickCandidate',
    pickCandidate_one: 'tariffClassification.pickCandidate_one',
    help: 'tariffClassification.help',
    tourTitle: 'tariffClassification.tourTitle',
    openTarifill: 'tariffClassification.openTarifill',
    groupArticles: 'tariffClassification.groupArticles',
    groupArticles_one: 'tariffClassification.groupArticles_one',
    noCode: 'tariffClassification.noCode',
    searchInDirectory: 'tariffClassification.searchInDirectory',
    directoryPlaceholder: 'tariffClassification.directoryPlaceholder',
    directoryScopeAll: 'tariffClassification.directoryScopeAll',
    directoryExtend: 'tariffClassification.directoryExtend',
    directoryNoResult: 'tariffClassification.directoryNoResult',
    directoryResults: 'tariffClassification.directoryResults',
    directoryResults_one: 'tariffClassification.directoryResults_one',
    determinedDerived: 'tariffClassification.determinedDerived',
    determinedMasterData: 'tariffClassification.determinedMasterData',
    determinedDefault: 'tariffClassification.determinedDefault',
    determinationTitle: 'tariffClassification.determinationTitle',
    determinationDerived: 'tariffClassification.determinationDerived',
    determinationMasterData: 'tariffClassification.determinationMasterData',
    determinationMasterDataUnnamed: 'tariffClassification.determinationMasterDataUnnamed',
    determinationDefault: 'tariffClassification.determinationDefault',
    stateReady: 'tariffClassification.stateReady',
    statePartial: 'tariffClassification.statePartial',
    stateUnknown: 'tariffClassification.stateUnknown',
    filterAll: 'tariffClassification.filterAll',
    filterPartial: 'tariffClassification.filterPartial',
    filterReady: 'tariffClassification.filterReady',
    filterUnknown: 'tariffClassification.filterUnknown',
    readyArticles: 'tariffClassification.readyArticles',
    readyArticles_one: 'tariffClassification.readyArticles_one',
    listSearchPlaceholder: 'tariffClassification.listSearchPlaceholder',
    listEmpty: 'tariffClassification.listEmpty',
    articleNumber: 'tariffClassification.articleNumber',
    articleShort: 'tariffClassification.articleShort',
    receivedCode: 'tariffClassification.receivedCode',
    noCodeShort: 'tariffClassification.noCodeShort',
    originShort: 'tariffClassification.originShort',
    partialIntro: 'tariffClassification.partialIntro',
    partialIntro_one: 'tariffClassification.partialIntro_one',
    partialPrefixOf: 'tariffClassification.partialPrefixOf',
    unknownIntro: 'tariffClassification.unknownIntro',
    missingIntro: 'tariffClassification.missingIntro',
    nextLevels: 'tariffClassification.nextLevels',
    nextLevels_one: 'tariffClassification.nextLevels_one',
    costAfterComplete: 'tariffClassification.costAfterComplete',
    openDirectoryFor: 'tariffClassification.openDirectoryFor',
    openDetail: 'tariffClassification.openDetail',
    openTreeHere: 'tariffClassification.openTreeHere',
    backToArticles: 'tariffClassification.backToArticles',
    pathTitle: 'tariffClassification.pathTitle',
    costTitle: 'tariffClassification.costTitle',
    costNormal: 'tariffClassification.costNormal',
    costPreference: 'tariffClassification.costPreference',
    costSituation: 'tariffClassification.costSituation',
    costOrigin: 'tariffClassification.costOrigin',
    costTerritory: 'tariffClassification.costTerritory',
    costTerritoryValue: 'tariffClassification.costTerritoryValue',
    costPreferentialOrigin: 'tariffClassification.costPreferentialOrigin',
    costNomenclature: 'tariffClassification.costNomenclature',
    costAdditionalCodes: 'tariffClassification.costAdditionalCodes',
    costValueData: 'tariffClassification.costValueData',
    costInvoiced: 'tariffClassification.costInvoiced',
    costCustomsValue: 'tariffClassification.costCustomsValue',
    costVatValue: 'tariffClassification.costVatValue',
    costCif: 'tariffClassification.costCif',
    costCifNo: 'tariffClassification.costCifNo',
    costNetMass: 'tariffClassification.costNetMass',
    costColCode: 'tariffClassification.costColCode',
    costColTax: 'tariffClassification.costColTax',
    costColRate: 'tariffClassification.costColRate',
    costColAmount: 'tariffClassification.costColAmount',
    costDuty: 'tariffClassification.costDuty',
    costDutyThirdCountry: 'tariffClassification.costDutyThirdCountry',
    costDutyPreference: 'tariffClassification.costDutyPreference',
    costVat: 'tariffClassification.costVat',
    costVatBasis: 'tariffClassification.costVatBasis',
    costTotal: 'tariffClassification.costTotal',
    costNoValue: 'tariffClassification.costNoValue',
    costRatesAt: 'tariffClassification.costRatesAt',
    costCompareRita: 'tariffClassification.costCompareRita',
    measuresSectionTitle: 'tariffClassification.measuresSectionTitle',
    measuresCount: 'tariffClassification.measuresCount',
    measuresCount_one: 'tariffClassification.measuresCount_one',
    documentsCount: 'tariffClassification.documentsCount',
    documentsCount_one: 'tariffClassification.documentsCount_one',
    measureSourceTaric: 'tariffClassification.measureSourceTaric',
    measureSourceRita: 'tariffClassification.measureSourceRita',
    measureNationalCode: 'tariffClassification.measureNationalCode',
    measureVat: 'tariffClassification.measureVat',
    documentToProvide: 'tariffClassification.documentToProvide',
    documentRequired: 'tariffClassification.documentRequired',
    proofOptional: 'tariffClassification.proofOptional',
    proofRequired: 'tariffClassification.proofRequired',
    directoryFor: 'tariffClassification.directoryFor',
    directoryScopeOurs: 'tariffClassification.directoryScopeOurs',
    directoryOursPlaceholder: 'tariffClassification.directoryOursPlaceholder',
    directoryOursEmpty: 'tariffClassification.directoryOursEmpty',
    directoryChooseArticle: 'tariffClassification.directoryChooseArticle',
    inDossier: 'tariffClassification.inDossier',
    dossierArticles: 'tariffClassification.dossierArticles',
    viewInTree: 'tariffClassification.viewInTree',
    completeInTree: 'tariffClassification.completeInTree',
    usedByArticles: 'tariffClassification.usedByArticles',
    usedByArticles_one: 'tariffClassification.usedByArticles_one',
    chapterCode: 'tariffClassification.chapterCode',
    treeSearched: 'tariffClassification.treeSearched',
    treeNone: 'tariffClassification.treeNone',
    tourStepCardApplyTitle: 'tariffClassification.tourStepCardApplyTitle',
    tourStepCardApplyBody: 'tariffClassification.tourStepCardApplyBody',
    tourStepCardCostTitle: 'tariffClassification.tourStepCardCostTitle',
    tourStepCardCostBody: 'tariffClassification.tourStepCardCostBody',
    tourStepCardOptionsTitle: 'tariffClassification.tourStepCardOptionsTitle',
    tourStepCardOptionsBody: 'tariffClassification.tourStepCardOptionsBody',
    tourStepCardPathTitle: 'tariffClassification.tourStepCardPathTitle',
    tourStepCardPathBody: 'tariffClassification.tourStepCardPathBody',
    tourStepDetailBrowseTitle: 'tariffClassification.tourStepDetailBrowseTitle',
    tourStepDetailBrowseBody: 'tariffClassification.tourStepDetailBrowseBody',
    tourStepDetailCodeTitle: 'tariffClassification.tourStepDetailCodeTitle',
    tourStepDetailCodeBody: 'tariffClassification.tourStepDetailCodeBody',
    tourStepDetailPathTitle: 'tariffClassification.tourStepDetailPathTitle',
    tourStepDetailPathBody: 'tariffClassification.tourStepDetailPathBody',
    tourStepDirectoryButtonTitle: 'tariffClassification.tourStepDirectoryButtonTitle',
    tourStepDirectoryButtonBody: 'tariffClassification.tourStepDirectoryButtonBody',
    tourStepSummaryTitle: 'tariffClassification.tourStepSummaryTitle',
    tourStepSummaryBody: 'tariffClassification.tourStepSummaryBody',
  },
  declarationKeyboard: {
    shortcutSourceDocument: 'declarationKeyboard.shortcutSourceDocument',
    shortcutDauRecap: 'declarationKeyboard.shortcutDauRecap',
    shortcutShowHints: 'declarationKeyboard.shortcutShowHints',
    hintsDialogTitle: 'declarationKeyboard.hintsDialogTitle',
    panelSubtitle: 'declarationKeyboard.panelSubtitle',
    panelSearchPlaceholder: 'declarationKeyboard.panelSearchPlaceholder',
    panelSearchEmpty: 'declarationKeyboard.panelSearchEmpty',
    panelContextBadge: 'declarationKeyboard.panelContextBadge',
    panelClose: 'declarationKeyboard.panelClose',
    panelFooterToggle: 'declarationKeyboard.panelFooterToggle',
    shortcutStepNavigation: 'declarationKeyboard.shortcutStepNavigation',
    shortcutFocusSearch: 'declarationKeyboard.shortcutFocusSearch',
    shortcutOpenSettings: 'declarationKeyboard.shortcutOpenSettings',
    shortcutCopyNabuNumber: 'declarationKeyboard.shortcutCopyNabuNumber',
    shortcutOpenHistory: 'declarationKeyboard.shortcutOpenHistory',
    shortcutMoveCell: 'declarationKeyboard.shortcutMoveCell',
    shortcutEditCell: 'declarationKeyboard.shortcutEditCell',
    shortcutLeaveCell: 'declarationKeyboard.shortcutLeaveCell',
    keyEnter: 'declarationKeyboard.keyEnter',
    keyEscape: 'declarationKeyboard.keyEscape',
    keySpace: 'declarationKeyboard.keySpace',
    shortcutToggleArticleGrid: 'declarationKeyboard.shortcutToggleArticleGrid',
    shortcutOpenTarifill: 'declarationKeyboard.shortcutOpenTarifill',
    categoryNavigate: 'declarationKeyboard.categoryNavigate',
    categoryOpen: 'declarationKeyboard.categoryOpen',
    categoryEdit: 'declarationKeyboard.categoryEdit',
    categoryAssistant: 'declarationKeyboard.categoryAssistant',
    categoryGrid: 'declarationKeyboard.categoryGrid',
    categoryDocument: 'declarationKeyboard.categoryDocument',
    shortcutSourceDocumentSwitch: 'declarationKeyboard.shortcutSourceDocumentSwitch',
    shortcutSourceDocumentPage: 'declarationKeyboard.shortcutSourceDocumentPage',
    shortcutSourceDocumentZoom: 'declarationKeyboard.shortcutSourceDocumentZoom',
    shortcutSourceDocumentResetZoom: 'declarationKeyboard.shortcutSourceDocumentResetZoom',
    shortcutSourceDocumentRotate: 'declarationKeyboard.shortcutSourceDocumentRotate',
    shortcutSourceDocumentSearch: 'declarationKeyboard.shortcutSourceDocumentSearch',
    shortcutSourceDocumentPan: 'declarationKeyboard.shortcutSourceDocumentPan',
    copyNabuNumberTooltip: 'declarationKeyboard.copyNabuNumberTooltip',
  },

  declarationUi: {
    saving: 'declarationUi.saving',
    stateGenerated: 'declarationUi.stateGenerated',
    stateInReview: 'declarationUi.stateInReview',
    stateReady: 'declarationUi.stateReady',
    stateSent: 'declarationUi.stateSent',
    stateAccepted: 'declarationUi.stateAccepted',
    stateRejected: 'declarationUi.stateRejected',
    stateSuperseded: 'declarationUi.stateSuperseded',
    fieldRequiredError: 'declarationUi.fieldRequiredError',
    catalogLoading: 'declarationUi.catalogLoading',
    fieldMaxLengthError: 'declarationUi.fieldMaxLengthError',
    fieldRejected: 'declarationUi.fieldRejected',
    sourceManualTooltip: 'declarationUi.sourceManualTooltip',
    sourceRoutineTooltip: 'declarationUi.sourceRoutineTooltip',
    sourceComputed: 'declarationUi.sourceComputed',
    sourceDerived: 'declarationUi.sourceDerived',
    sourceMasterData: 'declarationUi.sourceMasterData',
    sourceDefault: 'declarationUi.sourceDefault',
    sourceManual: 'declarationUi.sourceManual',
    sourceConsolidated: 'declarationUi.sourceConsolidated',
    sourceRemote: 'declarationUi.sourceRemote',
    sourceSetting: 'declarationUi.sourceSetting',
    sourceSettingFlux: 'declarationUi.sourceSettingFlux',
    sourceSettingFluxUnnamed: 'declarationUi.sourceSettingFluxUnnamed',
    sourceSettingGroup: 'declarationUi.sourceSettingGroup',
    sourceSettingUser: 'declarationUi.sourceSettingUser',
    sourcePieceSaid: 'declarationUi.sourcePieceSaid',
    evidenceExtracted: 'declarationUi.evidenceExtracted',
    title: 'declarationUi.title',
    loading: 'declarationUi.loading',
    notFound: 'declarationUi.notFound',
    error: 'declarationUi.error',
    interfaceClassic: 'declarationUi.interfaceClassic',
    interfaceSections: 'declarationUi.interfaceSections',
    showDocument: 'declarationUi.showDocument',
    showOrigin: 'declarationUi.showOrigin',
    hideDocument: 'declarationUi.hideDocument',
    validate: 'declarationUi.validate',
    validateAndSend: 'declarationUi.validateAndSend',
    validated: 'declarationUi.validated',
    blockedHint: 'declarationUi.blockedHint',
    progressRequired: 'declarationUi.progressRequired',
    sectionCountRequired: 'declarationUi.sectionCountRequired',
    sectionCountRequired_one: 'declarationUi.sectionCountRequired_one',
    sectionCountOptional: 'declarationUi.sectionCountOptional',
    sectionCountOptional_one: 'declarationUi.sectionCountOptional_one',
    progressFilled: 'declarationUi.progressFilled',
    anomalies: 'declarationUi.anomalies',
    severityBlocking: 'declarationUi.severityBlocking',
    severityInfo: 'declarationUi.severityInfo',
    seeDetail: 'declarationUi.seeDetail',
    hideDetail: 'declarationUi.hideDetail',
    seeInfos: 'declarationUi.seeInfos',
    hideInfos: 'declarationUi.hideInfos',
    linesConcerned: 'declarationUi.linesConcerned',
    totalMismatchTitle: 'declarationUi.totalMismatchTitle',
    totalMismatchTitleReference: 'declarationUi.totalMismatchTitleReference',
    totalMismatchValues: 'declarationUi.totalMismatchValues',
    totalMismatchValuesReference: 'declarationUi.totalMismatchValuesReference',
    totalLinesMissingTitle: 'declarationUi.totalLinesMissingTitle',
    totalLinesMissingValues: 'declarationUi.totalLinesMissingValues',
    totalNoticeHint: 'declarationUi.totalNoticeHint',
    lineCount: 'declarationUi.lineCount',
    goToLine: 'declarationUi.goToLine',
    completion: 'declarationUi.completion',
    searchField: 'declarationUi.searchField',
    onlyBlocking: 'declarationUi.onlyBlocking',
    expandAll: 'declarationUi.expandAll',
    nothingToExpand: 'declarationUi.nothingToExpand',
    collapseAll: 'declarationUi.collapseAll',
    expandRubrique: 'declarationUi.expandRubrique',
    collapseRubrique: 'declarationUi.collapseRubrique',
    mailThread: 'declarationUi.mailThread',
    emailSource: 'declarationUi.emailSource',
    collapseRail: 'declarationUi.collapseRail',
    expandRail: 'declarationUi.expandRail',
    noMatch: 'declarationUi.noMatch',
    noFieldsInStep: 'declarationUi.noFieldsInStep',
    fieldSearchRecent: 'declarationUi.fieldSearchRecent',
    fieldSearchToComplete: 'declarationUi.fieldSearchToComplete',
    fieldSearchToCompleteHint: 'declarationUi.fieldSearchToCompleteHint',
    fieldSearchMissing: 'declarationUi.fieldSearchMissing',
    fieldSearchInError: 'declarationUi.fieldSearchInError',
    fieldSearchSynonymsProcedure: 'declarationUi.fieldSearchSynonymsProcedure',
    fieldSearchSynonymsIncoterm: 'declarationUi.fieldSearchSynonymsIncoterm',
    fieldSearchSynonymsCustomsOffice: 'declarationUi.fieldSearchSynonymsCustomsOffice',
    fieldSearchSynonymsIdentification: 'declarationUi.fieldSearchSynonymsIdentification',
    fieldSearchSynonymsSupportingDocument: 'declarationUi.fieldSearchSynonymsSupportingDocument',
    fieldSearchSynonymsPreviousDocument: 'declarationUi.fieldSearchSynonymsPreviousDocument',
    fieldSearchSynonymsContainer: 'declarationUi.fieldSearchSynonymsContainer',
    fieldSearchSynonymsTransport: 'declarationUi.fieldSearchSynonymsTransport',
    fieldSearchSynonymsLocationOfGoods: 'declarationUi.fieldSearchSynonymsLocationOfGoods',
    fieldSearchSynonymsConsignee: 'declarationUi.fieldSearchSynonymsConsignee',
    fieldSearchSynonymsExporter: 'declarationUi.fieldSearchSynonymsExporter',
    fieldSearchSynonymsImporter: 'declarationUi.fieldSearchSynonymsImporter',
    fieldSearchSynonymsRepresentative: 'declarationUi.fieldSearchSynonymsRepresentative',
    fieldSearchSynonymsDeclarant: 'declarationUi.fieldSearchSynonymsDeclarant',
    fieldSearchSynonymsReference: 'declarationUi.fieldSearchSynonymsReference',
    fieldSearchSynonymsDeclarationType: 'declarationUi.fieldSearchSynonymsDeclarationType',
    fieldSearchSynonymsOrigin: 'declarationUi.fieldSearchSynonymsOrigin',
    keyboardNext: 'declarationUi.keyboardNext',
    keyboardCommit: 'declarationUi.keyboardCommit',
    fields: 'declarationUi.fields',
    add: 'declarationUi.add',
    remove: 'declarationUi.remove',
    noOccurrence: 'declarationUi.noOccurrence',
    sourceDocument: 'declarationUi.sourceDocument',
    control: 'declarationUi.control',
    notOnDocument: 'declarationUi.notOnDocument',
    notIdentified: 'declarationUi.notIdentified',
    clear: 'declarationUi.clear',
    howObtained: 'declarationUi.howObtained',
    noAnomaly: 'declarationUi.noAnomaly',
    fix: 'declarationUi.fix',
    guidedReview: 'declarationUi.guidedReview',
    locate: 'declarationUi.locate',
    previous: 'declarationUi.previous',
    next: 'declarationUi.next',
    close: 'declarationUi.close',
    totals: 'declarationUi.totals',
    documentTotal: 'declarationUi.documentTotal',
    linesTotal: 'declarationUi.linesTotal',
    verdictEqual: 'declarationUi.verdictEqual',
    verdictDiffers: 'declarationUi.verdictDiffers',
    verdictMissing: 'declarationUi.verdictMissing',
    verdictLinesMissing: 'declarationUi.verdictLinesMissing',
    totalEmpty: 'declarationUi.totalEmpty',
    referenceManual: 'declarationUi.referenceManual',
    referenceLines: 'declarationUi.referenceLines',
    referenceReading: 'declarationUi.referenceReading',
    alsoReadOn: 'declarationUi.alsoReadOn',
    enterTotal: 'declarationUi.enterTotal',
    editTotal: 'declarationUi.editTotal',
    enterPlaceholder: 'declarationUi.enterPlaceholder',
    readOn: 'declarationUi.readOn',
    computedSum: 'declarationUi.computedSum',
    readShort: 'declarationUi.readShort',
    pageShort: 'declarationUi.pageShort',
    notDeclared: 'declarationUi.notDeclared',
    verdictGap: 'declarationUi.verdictGap',
    offerKeepLines: 'declarationUi.offerKeepLines',
    offerKeepReading: 'declarationUi.offerKeepReading',
    offerClearReference: 'declarationUi.offerClearReference',
    distributeTotal: 'declarationUi.distributeTotal',
    distributeTitle: 'declarationUi.distributeTitle',
    distributeSummary: 'declarationUi.distributeSummary',
    distributeSummary_one: 'declarationUi.distributeSummary_one',
    distributeEvenly: 'declarationUi.distributeEvenly',
    distributeProrata: 'declarationUi.distributeProrata',
    distributePackages: 'declarationUi.distributePackages',
    distributePackagesPerDocument: 'declarationUi.distributePackagesPerDocument',
    distributePackagesPerDocumentHint: 'declarationUi.distributePackagesPerDocumentHint',
    distributePackagesFirstLine: 'declarationUi.distributePackagesFirstLine',
    distributePackagesFirstLineHint: 'declarationUi.distributePackagesFirstLineHint',
    distributeOverwrite: 'declarationUi.distributeOverwrite',
    distributeOverwrite_one: 'declarationUi.distributeOverwrite_one',
    distributeConfirm: 'declarationUi.distributeConfirm',
    distributeInvoice: 'declarationUi.distributeInvoice',
    distributeInvoiceUndo: 'declarationUi.distributeInvoiceUndo',
    distributeMenuTitle: 'declarationUi.distributeMenuTitle',
    distributeMenuTitle_one: 'declarationUi.distributeMenuTitle_one',
    distributeEqualOption: 'declarationUi.distributeEqualOption',
    distributeEqualHint: 'declarationUi.distributeEqualHint',
    distributeProrataOption: 'declarationUi.distributeProrataOption',
    distributeProrataHint: 'declarationUi.distributeProrataHint',
    distributeFirstLineOption: 'declarationUi.distributeFirstLineOption',
    distributeFirstLineHint: 'declarationUi.distributeFirstLineHint',
    revertConfirmText: 'declarationUi.revertConfirmText',
    revertConfirmTextGeneric: 'declarationUi.revertConfirmTextGeneric',
    revertDialogTitleGeneric: 'declarationUi.revertDialogTitleGeneric',
    revertKeep: 'declarationUi.revertKeep',
    revertConfirm: 'declarationUi.revertConfirm',
    undoLast: 'declarationUi.undoLast',
    redoLast: 'declarationUi.redoLast',
    sourceDistributed: 'declarationUi.sourceDistributed',
    articlesFilled: 'declarationUi.articlesFilled',
    articles: 'declarationUi.articles',
    columns: 'declarationUi.columns',
    allColumns: 'declarationUi.allColumns',
    usefulColumns: 'declarationUi.usefulColumns',
    addLine: 'declarationUi.addLine',
    addColumn: 'declarationUi.addColumn',
    addColumnSpecific: 'declarationUi.addColumnSpecific',
    searchArticles: 'declarationUi.searchArticles',
    ocrPasteHint: 'declarationUi.ocrPasteHint',
    ocrPasteSame: 'declarationUi.ocrPasteSame',
    ocrPasteDown: 'declarationUi.ocrPasteDown',
    ocrPasteRight: 'declarationUi.ocrPasteRight',
    ocrPasteDismiss: 'declarationUi.ocrPasteDismiss',
    ocrPasteTruncated: 'declarationUi.ocrPasteTruncated',
    noLineMatch: 'declarationUi.noLineMatch',
    linesGroupCount: 'declarationUi.linesGroupCount',
    linesGroupCount_one: 'declarationUi.linesGroupCount_one',
    linesGroupOther: 'declarationUi.linesGroupOther',
    linesGroupUnknownPiece: 'declarationUi.linesGroupUnknownPiece',
    linesGroupCollapse: 'declarationUi.linesGroupCollapse',
    linesGroupCollapsePiece: 'declarationUi.linesGroupCollapsePiece',
    linesGroupExpandPiece: 'declarationUi.linesGroupExpandPiece',
    linesGroupExpand: 'declarationUi.linesGroupExpand',
    linesGroupsToolbar: 'declarationUi.linesGroupsToolbar',
    linesGroupsToolbarPieces: 'declarationUi.linesGroupsToolbarPieces',
    linesGroupsCollapseAll: 'declarationUi.linesGroupsCollapseAll',
    linesGroupsExpandAll: 'declarationUi.linesGroupsExpandAll',
    invoiceTotalsTitle: 'declarationUi.invoiceTotalsTitle',
    invoiceTotalsTitlePieces: 'declarationUi.invoiceTotalsTitlePieces',
    invoiceTotalsLines: 'declarationUi.invoiceTotalsLines',
    invoiceTotalsNotPrinted: 'declarationUi.invoiceTotalsNotPrinted',
    filterColumns: 'declarationUi.filterColumns',
    columnTypeText: 'declarationUi.columnTypeText',
    columnTypeNumber: 'declarationUi.columnTypeNumber',
    columnTypeInteger: 'declarationUi.columnTypeInteger',
    columnTypeDate: 'declarationUi.columnTypeDate',
    columnTypeDateTime: 'declarationUi.columnTypeDateTime',
    columnTypeBoolean: 'declarationUi.columnTypeBoolean',
    columnTypeCode: 'declarationUi.columnTypeCode',
    noColumnMatch: 'declarationUi.noColumnMatch',
    removeColumn: 'declarationUi.removeColumn',
    setColumn: 'declarationUi.setColumn',
    setColumnTitle: 'declarationUi.setColumnTitle',
    setColumnTitle_one: 'declarationUi.setColumnTitle_one',
    setColumnReplaces: 'declarationUi.setColumnReplaces',
    setColumnReplaces_one: 'declarationUi.setColumnReplaces_one',
    setColumnApply: 'declarationUi.setColumnApply',
    reorderColumn: 'declarationUi.reorderColumn',
    pinColumn: 'declarationUi.pinColumn',
    unpinColumn: 'declarationUi.unpinColumn',
    noLines: 'declarationUi.noLines',
    documents: 'declarationUi.documents',
    piecePages: 'declarationUi.piecePages',
    pieceSheet: 'declarationUi.pieceSheet',
    pieceFilePages: 'declarationUi.pieceFilePages',
    pieceFileSheets: 'declarationUi.pieceFileSheets',
    pieceDated: 'declarationUi.pieceDated',
    pieceNumberNotRead: 'declarationUi.pieceNumberNotRead',
    pieceNotUsed: 'declarationUi.pieceNotUsed',
    pieceEmail: 'declarationUi.pieceEmail',
    previousPiece: 'declarationUi.previousPiece',
    nextPiece: 'declarationUi.nextPiece',
    pieceNavHint: 'declarationUi.pieceNavHint',
    previousPage: 'declarationUi.previousPage',
    nextPage: 'declarationUi.nextPage',
    scrollToTop: 'declarationUi.scrollToTop',
    scrollToBottom: 'declarationUi.scrollToBottom',
    resizeForm: 'declarationUi.resizeForm',
    zoomIn: 'declarationUi.zoomIn',
    zoomOut: 'declarationUi.zoomOut',
    resetZoom: 'declarationUi.resetZoom',
    rotateLeft: 'declarationUi.rotateLeft',
    rotateRight: 'declarationUi.rotateRight',
    fitPage: 'declarationUi.fitPage',
    showThumbnails: 'declarationUi.showThumbnails',
    hideThumbnails: 'declarationUi.hideThumbnails',
    searchInDocument: 'declarationUi.searchInDocument',
    searchPlaceholder: 'declarationUi.searchPlaceholder',
    searchLoading: 'declarationUi.searchLoading',
    searchNoResult: 'declarationUi.searchNoResult',
    searchPrevious: 'declarationUi.searchPrevious',
    searchNext: 'declarationUi.searchNext',
    searchClose: 'declarationUi.searchClose',
    openOriginal: 'declarationUi.openOriginal',
    noDocument: 'declarationUi.noDocument',
    previewUnavailable: 'declarationUi.previewUnavailable',
    loadingPreview: 'declarationUi.loadingPreview',
    citation: 'declarationUi.citation',
    origin: 'declarationUi.origin',
    openCalendar: 'declarationUi.openCalendar',
    empty: 'declarationUi.empty',
    required: 'declarationUi.required',
    outOfForm: 'declarationUi.outOfForm',
    conflictReload: 'declarationUi.conflictReload',
    rejected: 'declarationUi.rejected',
    operationSum: 'declarationUi.operationSum',
    operationProduct: 'declarationUi.operationProduct',
    operationProrata: 'declarationUi.operationProrata',
    operationRequalification: 'declarationUi.operationRequalification',
    computedFromReadings: 'declarationUi.computedFromReadings',
    pageNumber: 'declarationUi.pageNumber',
    prepareDeclarationTitle: 'declarationUi.prepareDeclarationTitle',
    reviewIntro: 'declarationUi.reviewIntro',
    reviewUnblocked: 'declarationUi.reviewUnblocked',
    reviewGroupBlocking: 'declarationUi.reviewGroupBlocking',
    reviewGroupToCheck: 'declarationUi.reviewGroupToCheck',
    reviewGroupInfo: 'declarationUi.reviewGroupInfo',
    reviewGroupDecided: 'declarationUi.reviewGroupDecided',
    reviewIssueCount: 'declarationUi.reviewIssueCount',
    reviewIssueCount_one: 'declarationUi.reviewIssueCount_one',
    reviewLines: 'declarationUi.reviewLines',
    reviewComplete: 'declarationUi.reviewComplete',
    reviewCheckValues: 'declarationUi.reviewCheckValues',
    reviewShowReadings: 'declarationUi.reviewShowReadings',
    reviewHideReadings: 'declarationUi.reviewHideReadings',
    reviewPieceFallback: 'declarationUi.reviewPieceFallback',
    reviewPageUnavailable: 'declarationUi.reviewPageUnavailable',
    reviewVerified: 'declarationUi.reviewVerified',
    reviewReopen: 'declarationUi.reviewReopen',
    reviewTabToProcess: 'declarationUi.reviewTabToProcess',
    labelValue: 'declarationUi.labelValue',
    quoted: 'declarationUi.quoted',
    clearColumnTooltip: 'declarationUi.clearColumnTooltip',
    clearColumnTooltip_one: 'declarationUi.clearColumnTooltip_one',
    clearColumn: 'declarationUi.clearColumn',
    removeArticle: 'declarationUi.removeArticle',
    manualCorrectionNote: 'declarationUi.manualCorrectionNote',
    totalsFamilyBilling: 'declarationUi.totalsFamilyBilling',
    totalsFamilyPackaging: 'declarationUi.totalsFamilyPackaging',
    addTuple: 'declarationUi.addTuple',
    removeTuple: 'declarationUi.removeTuple',
    prepareDeclarationButton: 'declarationUi.prepareDeclarationButton',
    prepareWindowPin: 'declarationUi.prepareWindowPin',
    prepareWindowPinLeft: 'declarationUi.prepareWindowPinLeft',
    prepareWindowPinRight: 'declarationUi.prepareWindowPinRight',
    prepareWindowUnpin: 'declarationUi.prepareWindowUnpin',
    pinPreferencesHint: 'declarationUi.pinPreferencesHint',
    pinPreferencesHintAction: 'declarationUi.pinPreferencesHintAction',
    pinPreferencesHintClose: 'declarationUi.pinPreferencesHintClose',
    pinPreferencesHintDocked: 'declarationUi.pinPreferencesHintDocked',
    pinPreferencesHintDockedFromPreferences:
      'declarationUi.pinPreferencesHintDockedFromPreferences',
    prepareWindowClose: 'declarationUi.prepareWindowClose',
    prepareWindowResize: 'declarationUi.prepareWindowResize',
    consolidate: 'declarationUi.consolidate',
    consolidateArticles: 'declarationUi.consolidateArticles',
    unconsolidate: 'declarationUi.unconsolidate',
    consolidationTitle: 'declarationUi.consolidationTitle',
    confirm: 'declarationUi.confirm',
    cancel: 'declarationUi.cancel',
    linesTab: 'declarationUi.linesTab',
    articlesTab: 'declarationUi.articlesTab',
    showSourceLines: 'declarationUi.showSourceLines',
    showConsolidatedArticles: 'declarationUi.showConsolidatedArticles',
    mergedLines: 'declarationUi.mergedLines',
    unkeyedLines: 'declarationUi.unkeyedLines',
    unkeyedLines_one: 'declarationUi.unkeyedLines_one',
    sourceLinesTitle: 'declarationUi.sourceLinesTitle',
    expandArticleLines: 'declarationUi.expandArticleLines',
    collapseArticleLines: 'declarationUi.collapseArticleLines',
    expandAllArticles: 'declarationUi.expandAllArticles',
    collapseAllArticles: 'declarationUi.collapseAllArticles',
    expandAllSourceLines: 'declarationUi.expandAllSourceLines',
    collapseAllSourceLines: 'declarationUi.collapseAllSourceLines',
    validatedDeliveryPending: 'declarationUi.validatedDeliveryPending',
    deliveryRunning: 'declarationUi.deliveryRunning',
    deliverySucceeded: 'declarationUi.deliverySucceeded',
    updatedAgo: 'declarationUi.updatedAgo',
    updatedAtTooltip: 'declarationUi.updatedAtTooltip',
    deliveryFailed: 'declarationUi.deliveryFailed',
    deliveryEntry: 'declarationUi.deliveryEntry',
    declarationsValidatedCount: 'declarationUi.declarationsValidatedCount',
    sendRecapTitle: 'declarationUi.sendRecapTitle',
    commentsTitle: 'declarationUi.commentsTitle',
    commentsButtonUnread: 'declarationUi.commentsButtonUnread',
    commentsEmptyTitle: 'declarationUi.commentsEmptyTitle',
    commentsEmptyHint: 'declarationUi.commentsEmptyHint',
    commentsPlaceholder: 'declarationUi.commentsPlaceholder',
    commentsSend: 'declarationUi.commentsSend',
    commentsSendUrgent: 'declarationUi.commentsSendUrgent',
    commentsUrgentLabel: 'declarationUi.commentsUrgentLabel',
    commentsUrgentHint: 'declarationUi.commentsUrgentHint',
    commentsNewlineHint: 'declarationUi.commentsNewlineHint',
    commentsEditHint: 'declarationUi.commentsEditHint',
    commentsUnknownAuthor: 'declarationUi.commentsUnknownAuthor',
    commentsEdited: 'declarationUi.commentsEdited',
    commentsEdit: 'declarationUi.commentsEdit',
    commentsDelete: 'declarationUi.commentsDelete',
    commentsDeleteConfirm: 'declarationUi.commentsDeleteConfirm',
    commentsSave: 'declarationUi.commentsSave',
    commentsCancel: 'declarationUi.commentsCancel',
    commentsError: 'declarationUi.commentsError',
    commentsSending: 'declarationUi.commentsSending',
    commentsSendFailed: 'declarationUi.commentsSendFailed',
    commentsRetry: 'declarationUi.commentsRetry',
    commentsDiscard: 'declarationUi.commentsDiscard',
    commentsToday: 'declarationUi.commentsToday',
    commentsYesterday: 'declarationUi.commentsYesterday',
    commentsNew: 'declarationUi.commentsNew',
    commentsClose: 'declarationUi.commentsClose',
    dossierTabDetails: 'declarationUi.dossierTabDetails',
    dossierProperties: 'declarationUi.dossierProperties',
    dossierActions: 'declarationUi.dossierActions',
    dossierOwner: 'declarationUi.dossierOwner',
    dossierOwnerError: 'declarationUi.dossierOwnerError',
    dossierModel: 'declarationUi.dossierModel',
    dossierType: 'declarationUi.dossierType',
    dossierClient: 'declarationUi.dossierClient',
    dossierTags: 'declarationUi.dossierTags',
    dossierTagsError: 'declarationUi.dossierTagsError',
    dossierNoModel: 'declarationUi.dossierNoModel',
    dossierModelChange: 'declarationUi.dossierModelChange',
    dossierModelRemove: 'declarationUi.dossierModelRemove',
    dossierModelApply: 'declarationUi.dossierModelApply',
    dossierModelKeepsCorrections: 'declarationUi.dossierModelKeepsCorrections',
    dossierModelApplied: 'declarationUi.dossierModelApplied',
    dossierModelError: 'declarationUi.dossierModelError',
    dossierTypeChange: 'declarationUi.dossierTypeChange',
    dossierTypeFromTo: 'declarationUi.dossierTypeFromTo',
    dossierTypeWarning: 'declarationUi.dossierTypeWarning',
    dossierTypeApply: 'declarationUi.dossierTypeApply',
    dossierTypeError: 'declarationUi.dossierTypeError',
    dossierAddFile: 'declarationUi.dossierAddFile',
    dossierAddFileHint: 'declarationUi.dossierAddFileHint',
    dossierAddFileChoose: 'declarationUi.dossierAddFileChoose',
    dossierAddFileUnsupported: 'declarationUi.dossierAddFileUnsupported',
    dossierAddFileWarning: 'declarationUi.dossierAddFileWarning',
    dossierAddFileApply: 'declarationUi.dossierAddFileApply',
    dossierAddFileError: 'declarationUi.dossierAddFileError',
    relaunchStarted: 'declarationUi.relaunchStarted',
    relaunchReading: 'declarationUi.relaunchReading',
    reviseAction: 'declarationUi.reviseAction',
    reviseDialogTitle: 'declarationUi.reviseDialogTitle',
    reviseDialogText: 'declarationUi.reviseDialogText',
    reviseReasonLabel: 'declarationUi.reviseReasonLabel',
    reviseConfirm: 'declarationUi.reviseConfirm',
    reviseError: 'declarationUi.reviseError',
    revisionOpenBanner: 'declarationUi.revisionOpenBanner',
    dossierApplyAutomation: 'declarationUi.dossierApplyAutomation',
    automationTitle: 'declarationUi.automationTitle',
    automationChoose: 'declarationUi.automationChoose',
    automationPreview: 'declarationUi.automationPreview',
    automationArticle: 'declarationUi.automationArticle',
    automationOverwritesCorrection: 'declarationUi.automationOverwritesCorrection',
    automationIgnored: 'declarationUi.automationIgnored',
    automationRejected: 'declarationUi.automationRejected',
    automationNothing: 'declarationUi.automationNothing',
    automationApply: 'declarationUi.automationApply',
    automationApplied: 'declarationUi.automationApplied',
    automationConflict: 'declarationUi.automationConflict',
    automationRunError: 'declarationUi.automationRunError',
    automationApplyError: 'declarationUi.automationApplyError',
    automationNone: 'declarationUi.automationNone',
    commentsDetach: 'declarationUi.commentsDetach',
  },

  declarationEvents: {
    eventValidate: 'declarationEvents.eventValidate',
    routineActor: 'declarationEvents.routineActor',
    eventReviewIssue: 'declarationEvents.eventReviewIssue',
    eventAddTuple: 'declarationEvents.eventAddTuple',
    eventRemoveTuple: 'declarationEvents.eventRemoveTuple',
    eventAddLine: 'declarationEvents.eventAddLine',
    eventRemoveLine: 'declarationEvents.eventRemoveLine',
    eventModifyOccurrence: 'declarationEvents.eventModifyOccurrence',
    eventClearColumn: 'declarationEvents.eventClearColumn',
    eventSetColumn: 'declarationEvents.eventSetColumn',
    eventClear: 'declarationEvents.eventClear',
    eventSetValue: 'declarationEvents.eventSetValue',
    reasonInvalidFormat: 'declarationEvents.reasonInvalidFormat',
    reasonNotInCatalog: 'declarationEvents.reasonNotInCatalog',
    reasonStaleIssue: 'declarationEvents.reasonStaleIssue',
    reasonReasonRequired: 'declarationEvents.reasonReasonRequired',
    reasonLocked: 'declarationEvents.reasonLocked',
    reasonUnknownPath: 'declarationEvents.reasonUnknownPath',
    reasonMissingTuple: 'declarationEvents.reasonMissingTuple',
    reasonFallback: 'declarationEvents.reasonFallback',
    applyRejectedCorrections: 'declarationEvents.applyRejectedCorrections',
    applyConflict: 'declarationEvents.applyConflict',
    applySaveRetryable: 'declarationEvents.applySaveRetryable',
    applySaveNotRetryable: 'declarationEvents.applySaveNotRetryable',
    applyServerReason: 'declarationEvents.applyServerReason',
    applyInsufficientCredits: 'declarationEvents.applyInsufficientCredits',
    applySubscriptionRequired: 'declarationEvents.applySubscriptionRequired',
    applySessionExpired: 'declarationEvents.applySessionExpired',
    applyForbidden: 'declarationEvents.applyForbidden',
    applyNotFound: 'declarationEvents.applyNotFound',
    applyContactAdmin: 'declarationEvents.applyContactAdmin',
    rechargeCredits: 'declarationEvents.rechargeCredits',
    openSubscription: 'declarationEvents.openSubscription',
    retryReapply: 'declarationEvents.retryReapply',
    retry: 'declarationEvents.retry',
    discardCorrections: 'declarationEvents.discardCorrections',
    eventConsolidate: 'declarationEvents.eventConsolidate',
    eventUnconsolidate: 'declarationEvents.eventUnconsolidate',
    reasonUnknownKey: 'declarationEvents.reasonUnknownKey',
    reasonRequiredKeyMissing: 'declarationEvents.reasonRequiredKeyMissing',
    reasonNoKeys: 'declarationEvents.reasonNoKeys',
    historyUnconsolidated: 'declarationEvents.historyUnconsolidated',
    reasonRejectedWithDetail: 'declarationEvents.reasonRejectedWithDetail',
    eventSetTotalReferenceManual: 'declarationEvents.eventSetTotalReferenceManual',
    eventSetTotalReferenceLines: 'declarationEvents.eventSetTotalReferenceLines',
    eventSetTotalReferenceReading: 'declarationEvents.eventSetTotalReferenceReading',
    eventClearTotalReference: 'declarationEvents.eventClearTotalReference',
    reasonUnknownTotal: 'declarationEvents.reasonUnknownTotal',
    reasonInvalidValue: 'declarationEvents.reasonInvalidValue',
    reasonNoLines: 'declarationEvents.reasonNoLines',
    reasonUnknownReading: 'declarationEvents.reasonUnknownReading',
    eventDistributeTotal: 'declarationEvents.eventDistributeTotal',
    reasonWrongTotal: 'declarationEvents.reasonWrongTotal',
    reasonNoReference: 'declarationEvents.reasonNoReference',
    reasonUnknownWeight: 'declarationEvents.reasonUnknownWeight',
    reasonIncompleteWeights: 'declarationEvents.reasonIncompleteWeights',
    gestureDistribute: 'declarationEvents.gestureDistribute',
    gestureClearColumn: 'declarationEvents.gestureClearColumn',
    gestureSetColumn: 'declarationEvents.gestureSetColumn',
    gestureApplySettings: 'declarationEvents.gestureApplySettings',
    gestureApplyAutomation: 'declarationEvents.gestureApplyAutomation',
    gestureAddLines: 'declarationEvents.gestureAddLines',
    gestureValue: 'declarationEvents.gestureValue',
    gestureValueCleared: 'declarationEvents.gestureValueCleared',
    gestureValues: 'declarationEvents.gestureValues',
    gestureTotalReference: 'declarationEvents.gestureTotalReference',
    gestureTotalReferenceCleared: 'declarationEvents.gestureTotalReferenceCleared',
    gestureRevert: 'declarationEvents.gestureRevert',
    gestureRevertMore: 'declarationEvents.gestureRevertMore',
    gestureRevertMore_one: 'declarationEvents.gestureRevertMore_one',
    gestureLine: 'declarationEvents.gestureLine',
    gestureGeneric: 'declarationEvents.gestureGeneric',
    gestureUnvalidate: 'declarationEvents.gestureUnvalidate',
    gestureAbandonRevision: 'declarationEvents.gestureAbandonRevision',
    eventRevert: 'declarationEvents.eventRevert',
    reasonStaleRevert: 'declarationEvents.reasonStaleRevert',
    reasonBarrier: 'declarationEvents.reasonBarrier',
    reasonAlreadyReverted: 'declarationEvents.reasonAlreadyReverted',
    reasonNotRevertible: 'declarationEvents.reasonNotRevertible',
    reasonUnknownGesture: 'declarationEvents.reasonUnknownGesture',
    reasonAmbiguousTuple: 'declarationEvents.reasonAmbiguousTuple',
    reasonLockedArticles: 'declarationEvents.reasonLockedArticles',
    reasonUnknownLine: 'declarationEvents.reasonUnknownLine',
    reasonUnknownTuple: 'declarationEvents.reasonUnknownTuple',
    reasonUnknownCategory: 'declarationEvents.reasonUnknownCategory',
    reasonWrongLevel: 'declarationEvents.reasonWrongLevel',
    reasonEmptyValue: 'declarationEvents.reasonEmptyValue',
    reasonUnknownEvent: 'declarationEvents.reasonUnknownEvent',
    assistantEventArticle: 'declarationEvents.assistantEventArticle',
    assistantEventClear: 'declarationEvents.assistantEventClear',
    assistantEventSetColumn: 'declarationEvents.assistantEventSetColumn',
    assistantEventClearColumn: 'declarationEvents.assistantEventClearColumn',
    assistantEventCopyColumn: 'declarationEvents.assistantEventCopyColumn',
    assistantEventWhere: 'declarationEvents.assistantEventWhere',
    assistantEventSetColumnWhere: 'declarationEvents.assistantEventSetColumnWhere',
    assistantEventClearColumnWhere:
      'declarationEvents.assistantEventClearColumnWhere',
    assistantEventCopyColumnUnchanged:
      'declarationEvents.assistantEventCopyColumnUnchanged',
    assistantEventCopyColumnUnchanged_one:
      'declarationEvents.assistantEventCopyColumnUnchanged_one',
    assistantEventScopeEquals:
      'declarationEvents.assistantEventScopeEquals',
    assistantEventScopeIn:
      'declarationEvents.assistantEventScopeIn',
    assistantEventScopeEmpty:
      'declarationEvents.assistantEventScopeEmpty',
    assistantEventScopeFilled:
      'declarationEvents.assistantEventScopeFilled',
    assistantEventMapColumn:
      'declarationEvents.assistantEventMapColumn',
    assistantEventMapColumnFrom:
      'declarationEvents.assistantEventMapColumnFrom',
    assistantEventMapColumnUnchanged:
      'declarationEvents.assistantEventMapColumnUnchanged',
    assistantEventMapColumnUnchanged_one:
      'declarationEvents.assistantEventMapColumnUnchanged_one',
    assistantEventComputeColumn:
      'declarationEvents.assistantEventComputeColumn',
    assistantEventComputeColumnUnchanged:
      'declarationEvents.assistantEventComputeColumnUnchanged',
    assistantEventComputeColumnUnchanged_one:
      'declarationEvents.assistantEventComputeColumnUnchanged_one',
    assistantEventFormatColumnPadEnd:
      'declarationEvents.assistantEventFormatColumnPadEnd',
    assistantEventFormatColumnPadStart:
      'declarationEvents.assistantEventFormatColumnPadStart',
    assistantEventFormatColumnTruncate:
      'declarationEvents.assistantEventFormatColumnTruncate',
    assistantEventFormatColumnUnchanged:
      'declarationEvents.assistantEventFormatColumnUnchanged',
    assistantEventFormatColumnUnchanged_one:
      'declarationEvents.assistantEventFormatColumnUnchanged_one',
    assistantEventAddLine: 'declarationEvents.assistantEventAddLine',
    assistantEventAddLineValues: 'declarationEvents.assistantEventAddLineValues',
    assistantEventRemoveLine: 'declarationEvents.assistantEventRemoveLine',
    assistantEventDistributeEqual:
      'declarationEvents.assistantEventDistributeEqual',
    assistantEventDistributeBy: 'declarationEvents.assistantEventDistributeBy',
    assistantEventDistributePackages:
      'declarationEvents.assistantEventDistributePackages',
    assistantEventScopeDocument:
      'declarationEvents.assistantEventScopeDocument',
    assistantEventDistributeAmount:
      'declarationEvents.assistantEventDistributeAmount',
    assistantEventDistributeFirstLine:
      'declarationEvents.assistantEventDistributeFirstLine',
    assistantEventDistributeFirstLinePerDocument:
      'declarationEvents.assistantEventDistributeFirstLinePerDocument',
    assistantEventDistributeEqualScoped:
      'declarationEvents.assistantEventDistributeEqualScoped',
    assistantEventDistributeByScoped:
      'declarationEvents.assistantEventDistributeByScoped',
    assistantEventDistributeFromValue:
      'declarationEvents.assistantEventDistributeFromValue',
    assistantEventDistributeFromDocument:
      'declarationEvents.assistantEventDistributeFromDocument',
    assistantEventDistributeFromReference:
      'declarationEvents.assistantEventDistributeFromReference',
    assistantEventConsolidate: 'declarationEvents.assistantEventConsolidate',
    assistantEventUnconsolidate: 'declarationEvents.assistantEventUnconsolidate',
    assistantEventTotalManual: 'declarationEvents.assistantEventTotalManual',
    assistantEventTotalLines: 'declarationEvents.assistantEventTotalLines',
    assistantEventTotalReading: 'declarationEvents.assistantEventTotalReading',
    assistantEventTotalRead: 'declarationEvents.assistantEventTotalRead',
    assistantEventRevert: 'declarationEvents.assistantEventRevert',
    assistantEventRevert_one: 'declarationEvents.assistantEventRevert_one',
    assistantEventRevertUnknown: 'declarationEvents.assistantEventRevertUnknown',
    assistantEventRevertDependents:
      'declarationEvents.assistantEventRevertDependents',
    assistantEventRevertDependents_one:
      'declarationEvents.assistantEventRevertDependents_one',
    assistantValueTrue: 'declarationEvents.assistantValueTrue',
    assistantValueFalse: 'declarationEvents.assistantValueFalse',
    assistantSuggestionBlocked: 'declarationEvents.assistantSuggestionBlocked',
    assistantSuggestionMissing: 'declarationEvents.assistantSuggestionMissing',
    assistantSuggestionMissingUnnamed:
      'declarationEvents.assistantSuggestionMissingUnnamed',
    assistantSuggestionLines: 'declarationEvents.assistantSuggestionLines',
    assistantSuggestionLines_one:
      'declarationEvents.assistantSuggestionLines_one',
    assistantSuggestionLinesColumns:
      'declarationEvents.assistantSuggestionLinesColumns',
    assistantSuggestionFormat: 'declarationEvents.assistantSuggestionFormat',
    assistantSuggestionConflict:
      'declarationEvents.assistantSuggestionConflict',
    assistantSuggestionConflict_one:
      'declarationEvents.assistantSuggestionConflict_one',
    assistantSuggestionConflictUnnamed:
      'declarationEvents.assistantSuggestionConflictUnnamed',
    assistantSuggestionGap: 'declarationEvents.assistantSuggestionGap',
    assistantSuggestionGap_one: 'declarationEvents.assistantSuggestionGap_one',
    assistantSuggestionDistribute:
      'declarationEvents.assistantSuggestionDistribute',
    assistantSuggestionWeights: 'declarationEvents.assistantSuggestionWeights',
    assistantSuggestionTotals: 'declarationEvents.assistantSuggestionTotals',
    assistantSuggestionHistory: 'declarationEvents.assistantSuggestionHistory',
    assistantSuggestionSummary: 'declarationEvents.assistantSuggestionSummary',
    assistantSuggestionNamesTwo:
      'declarationEvents.assistantSuggestionNamesTwo',
    assistantSuggestionNamesMore:
      'declarationEvents.assistantSuggestionNamesMore',
    assistantSuggestionNamesMore_one:
      'declarationEvents.assistantSuggestionNamesMore_one',
    assistantSuggestionNamesOneMore:
      'declarationEvents.assistantSuggestionNamesOneMore',
    assistantSuggestionNamesOneMore_one:
      'declarationEvents.assistantSuggestionNamesOneMore_one',
  },

  extraction: {
    unknown: 'extraction.unknown',
    selectAnErrorState: 'extraction.selectAnErrorState',
    exportDeclaration: 'extraction.exportDeclaration',
    dauRecapButtonLabel: 'extraction.dauRecapButtonLabel',
    dauRecapButtonTooltip: 'extraction.dauRecapButtonTooltip',
    dauRecapNoArticlesTooltip: 'extraction.dauRecapNoArticlesTooltip',
    dauRecapUnavailableSchemaTooltip:
      'extraction.dauRecapUnavailableSchemaTooltip',
    dauRecapPrintButton: 'extraction.dauRecapPrintButton',
    dauRecapCloseButton: 'extraction.dauRecapCloseButton',
    dauRecapModalSubtitle: 'extraction.dauRecapModalSubtitle',
    dauRecapCloseHint: 'extraction.dauRecapCloseHint',
    dauRecapPreviousPage: 'extraction.dauRecapPreviousPage',
    dauRecapNextPage: 'extraction.dauRecapNextPage',
    dauRecapZoomOut: 'extraction.dauRecapZoomOut',
    dauRecapZoomIn: 'extraction.dauRecapZoomIn',
    validateThisDataset: 'extraction.validateThisDataset',
    validateDatasetSuccess: 'extraction.validateDatasetSuccess',
    dataset: 'extraction.dataset',
    validateDatasetModalTitle: 'extraction.validateDatasetModalTitle',
    validateDatasetModalDescription: 'extraction.validateDatasetModalDescription',
    datasetsValidatedProgress: 'extraction.datasetsValidatedProgress',
    datasetsRemainingProgress: 'extraction.datasetsRemainingProgress',
    datasetsAllValidatedReady: 'extraction.datasetsAllValidatedReady',
    goToNextDataset: 'extraction.goToNextDataset',
    datasetValidationGuidanceBanner: 'extraction.datasetValidationGuidanceBanner',
    multiDatasetSendRecapTitle: 'extraction.multiDatasetSendRecapTitle',
    agentRationale: 'extraction.agentRationale',
    agentRationaleTooltip: 'extraction.agentRationaleTooltip',
    showSidebar: 'extraction.showSidebar',
    hideSidebar: 'extraction.hideSidebar',
    enlargeViewer: 'extraction.enlargeViewer',
    shrinkViewer: 'extraction.shrinkViewer',
    enlargeTableOverlay: 'extraction.enlargeTableOverlay',
    shrinkTableOverlay: 'extraction.shrinkTableOverlay',
    enlargeTableWidth: 'extraction.enlargeTableWidth',
    shrinkTableWidth: 'extraction.shrinkTableWidth',
    enlargeTable: 'extraction.enlargeTable',
    shrinkTable: 'extraction.shrinkTable',
    scrollToDocumentTop: 'extraction.scrollToDocumentTop',
    scrollToDocumentBottom: 'extraction.scrollToDocumentBottom',
    suggestedColumnIsMissing: 'extraction.suggestedColumnIsMissing',
    thereAreOverlappingFields: 'extraction.thereAreOverlappingFields',
    clickHereToSeeFurtherEditingOptions:
      'extraction.clickHereToSeeFutherEditingOptions',
    default: 'extraction.default',
    anUnusedDocumentWasFound: 'extraction.anUnusedDocumentWasFound',
    additionalCodeNotValid: 'extraction.additionalCodeNotValid',
    noErrorState: 'extraction.noErrorState',
    additionalCodeIsMissingACertificate:
      'extraction.additionalCodeIsMissingACertificate',
    noTaxComponentSelected: 'extraction.noTaxComponentSelected',
    noDutyComponentSelected: 'extraction.noDutyComponentSelected',
    countryOfOriginUnknown: 'extraction.countryOfOriginUnknown',
    countryOfDestinationUnknown: 'extraction.countryOfDestinationUnknown',
    countryUnknown: 'extraction.countryUnknown',
    failedToRetrieveTaricCodeDataForCode:
      'extraction.failedToRetrieveTaricCodeDataForCode',
    findAColumn: 'extraction.findAColumn',
    changeColumnName: 'extraction.changeColumnName',
    closeDebug: 'extraction.closeDebug',
    legalInformationAboutCode: 'extraction.legalInformationAboutCode',
    legalInformationAboutMeasure: 'extraction.legalInformationAboutMeasure',
    legalInformation: 'extraction.legalInformation',
    index: 'extraction.index',
    datasourceOrigin: 'extraction.datasourceOrigin',
    propertiesInheritedFromCode: 'extraction.propertiesInheritedFromCode',
    articles: 'extraction.articles',
    totaux: 'extraction.totaux',
    assistant: 'extraction.assistant',
    totalDeclaredValue: 'extraction.totalDeclaredValue',
    productCodes: 'extraction.productCodes',
    fields: 'extraction.fields',
    rows: 'extraction.rows',
    errors: 'extraction.errors',
    mergeValidationExplanation: 'extraction.mergeValidationExplanation',
    mergeValidationCaseOneExplanation:
      'extraction.mergeValidationCaseOneExplanation',
    mergeValidationCaseTwoExplanation:
      'extraction.mergeValidationCaseTwoExplanation',
    mergeValidationCaseThreeExplanation:
      'extraction.mergeValidationCaseThreeExplanation',
    mergeValidationCaseFourExplanation:
      'extraction.mergeValidationCaseFourExplanation',
    mergeSourceDuplicateExplanation:
      'extraction.mergeSourceDuplicateExplanation',
    mergeSourceDuplicateExplanation2:
      'extraction.mergeSourceDuplicateExplanation2',
    mergeDestinationDuplicateExplanation:
      'extraction.mergeDestinationDuplicateExplanation',
    readyToMerge: 'extraction.readyToMerge',
    mergeSuccess: 'extraction.mergeSuccess',
    mergeError: 'extraction.mergeError',
    mapToRow: 'extraction.mapToRow',
    inTheDestinationTable: 'extraction.inTheDestinationTable',
    mergeDestinationUnmapped: 'extraction.destinationUnmapped',
    and: 'extraction.and',
    willNotReceiveAnyDataFromTheMerge:
      'extraction.willNotReceiveAnyDataFromTheMerge',
    mergeImpossible: 'extraction.mergeImpossible',
    packages: 'extraction.packages',
    chooseClassification: 'extraction.chooseClassification',
    updateDeclarationExportType: 'extraction.updateDeclarationExportType',
    changeExportTypeForCurrentDeclaration:
      'extraction.changeExportTypeForCurrentDeclaration',
    exceptions: 'exceptions',
    addData: 'extraction.addData',
    validateTheMerge: 'extraction.validateTheMerge',
    rowsToValidate: 'extraction.rowsToValidate',
    rowsToValidate_other: 'extraction.rowsToValidate_other',
    editGrid: 'extraction.editGrid',
    deleteTable: 'extraction.deleteTable',
    deleteTablePage: 'extraction.deleteTablePage',
    deleteAllTablePages: 'extraction.deleteAllTablePages',
    addColumn: 'extraction.addColumn',
    addRow: 'extraction.addRow',
    tableRows: 'extraction.tableRows',
    deleteRow: 'extraction.deleteRow',
    articlesTable: 'extraction.articlesTable',
    showArticlesTable: 'extraction.showArticlesTable',
    hideArticlesTable: 'extraction.hideArticlesTable',
    selectedLines: 'extraction.selectedLines',
    selectedLines_other: 'extraction.selectedLines_other',
    selectedLines_zero: 'extraction.selectedLines_zero',
    rowTotalAmountIsMissing: 'extraction.rowTotalAmountIsMissing',
    noExceptionsFound: 'extraction.noExceptionsFound',
    noDescriptionFound: 'extraction.noDescriptionFound',
    noConditionsFound: 'extraction.noConditionsFound',
    noColumnsFound: 'extraction.noColumnsFound',
    whyMergeKeysNeeded: 'extraction.whyMergeKeysNeeded',
    noClassification: 'extraction.noClassification',
    legalContext: 'extraction.legalContext',
    informations: 'extraction.informations',
    certificateCode: 'extraction.certificateCode',
    informationOnCodesAndDuties: 'extraction.informationOnCodesAndDuties',
    products: 'extraction.products',
    missingProduct: 'extraction.missingProduct',
    downloadRowsAsExcelWorksheet: 'extraction.downloadRowsAsExcelWorksheet',
    convertRowsToFees: 'extraction.convertRowsToFees',
    convertRowsToRefunds: 'extraction.convertRowsToRefunds',
    createNewDeclarationFromRows: 'extraction.createNewDeclarationFromRows',
    addInformation: 'extraction.addInformation',
    addElement: 'extraction.addElement',
    updatingData: 'extraction.updatingData',
    customInformation: 'extraction.customInformation',
    documentInformation: 'extraction.documentInformation',
    transactionDetails: 'extraction.transactionDetails',
    shippingInformation: 'extraction.shippingInformation',
    anyColumnsToMatchNotPresentWillBeCreated:
      'extraction.anyColumnsToMatchNotPresentWillBeCreated',
    whenCopyingARowFromSourceOnlyCopyValuesWillBeCopied:
      'extraction.whenCopyingARowFromSourceOnlyCopyValuesWillBeCopied',
    chooseTheTableYouWantToMergeIntoTheMainArticlesTable:
      'extraction.chooseTheTableYouWantToMergeIntoTheMainArticlesTable',
    findField: 'extraction.findField',
    duplicate: 'extraction.duplicate',
    areYouSureYouWantToCopyDeclaration:
      'extraction.areYouSureYouWantToCopyDeclaration', // eslint-disable-line prettier/prettier
    thereWasAnErrorCopyingTheDeclaration:
      'extraction.thereWasAnErrorCopyingTheDeclaration', // eslint-disable-line
    groupByHSCode: 'extraction.groupByHSCode',
    cellTooSmall: 'extraction.cellTooSmall',
    cellNotValid: 'extraction.cellNotValid',
    doYouWantToGroupTokensByHSCode: 'extraction.doYouWantToGroupTokensByHSCode',
    createNewFieldHere: 'extraction.createNewFieldHere',
    showOtherFieldsHere: 'extraction.showOtherFieldsHere',
    convertSelectionToTable: 'extraction.convertSelectionToTable',
    drawingHintField: 'extraction.drawingHintField',
    drawingHintArticleGrid: 'extraction.drawingHintArticleGrid',
    drawingHintArticleColumn: 'extraction.drawingHintArticleColumn',
    drawingHintPageAlreadyHasArticleGrid:
      'extraction.drawingHintPageAlreadyHasArticleGrid',
    drawingRejectedAgenticField: 'extraction.drawingRejectedAgenticField',
    drawingRejectedPageAlreadyHasArticleGrid:
      'extraction.drawingRejectedPageAlreadyHasArticleGrid',
    validateRequiresFieldSelection: 'extraction.validateRequiresFieldSelection',
    convertTableToSelection: 'extraction.convertTableToSelection',
    mergeOptions: 'extraction.mergeOptions',
    sourceTable: 'extraction.sourceTable',
    columnsToMatch: 'extraction.columnsToMatch',
    columnsToCopy: 'extraction.columnsToCopy',
    validation: 'extraction.validation',
    columnToMatchExplanation: 'extraction.columnToMatchExplanation',
    yes: 'extraction.yes',
    no: 'extraction.no',
    error: 'extraction.error',
    invoices: 'extraction.invoices',
    'commercial-invoice': 'extraction.commercial-invoice',
    packings: 'extraction.packings',
    'packing-list': 'extraction.packing-list',
    'hscodes-list': 'extraction.hscodes-list',
    'bill-of-lading': 'extraction.bill-of-lading',
    'delivery-note': 'extraction.delivery-note',
    'packing-list-description': 'extraction.packing-list-description',
    'hscodes-list-description': 'extraction.hscodes-list-description',
    'articles-table-description': 'extraction.articles-table-description',
    'bill-of-lading-description': 'extraction.bill-of-lading-description',
    'delivery-note-description': 'extraction.delivery-note-description',
    mergeTables: 'extraction.mergeTables',
    columnEmpty: 'extraction.columnEmpty',
    documentColumnIsEmpty: 'extraction.documentColumnIsEmpty',
    valueRequiredToSpread: 'extraction.valueRequiredToSpread',
    valuesMissing: 'extraction.valuesMissing',
    source: 'extraction.source',
    sourceTooltip: 'extraction.sourceTooltip',
    packageTypeNotSourced: 'extraction.packageTypeNotSourced',
    weightUnitNotSourced: 'extraction.weightUnitNotSourced',
    unitTypeNotSourced: 'extraction.unitTypeNotSourced',
    spreadOverDocumentLinesAutoSingle:
      'extraction.spreadOverDocumentLinesAutoSingle',
    spreadOverDocumentLinesSelectSingle:
      'extraction.spreadOverDocumentLinesSelectSingle',
    clearColumnValuesForDocument: 'extraction.clearColumnValuesForDocument',
    spreadOverDocumentLinesSelect: 'extraction.spreadOverDocumentLinesSelect',
    spreadOverDocumentLinesAuto: 'extraction.spreadOverDocumentLinesAuto',
    spreadOverAllLinesSelect: 'extraction.spreadOverAllLinesSelect',
    spreadOverAllLinesAuto: 'extraction.spreadOverAllLinesAuto',
    documentCellsClearedSuccessfully:
      'extraction.documentCellsClearedSuccessfully',
    errorClearingDocumentCells: 'extraction.errorClearingDocumentCells',
    thisActionWillClearAllCellsInTheDocumentColumn:
      'extraction.thisActionWillClearAllCellsInTheDocumentColumn',
    declaration: 'extraction.declaration',
    declarationTooltip: 'extraction.declarationTooltip',
    currencyNotSourced: 'extraction.currencyNotSourced',
    theDocumentTotalAndTheTableTotalAreDifferent:
      'extraction.theDocumentTotalAndTheTableTotalAreDifferent',
    theDocumentTotalAndTheTableTotalAreEqual:
      'extraction.theDocumentTotalAndTheTableTotalAreEqual',
    documentTotalNotFound: 'extraction.documentTotalNotFound',
    documentTotalNotFoundSingle: 'extraction.documentTotalNotFoundSingle',
    noPostProcessFound: 'extraction.noPostProcessFound',
    notFound: 'extraction.notFound',
    notSourced: 'extraction.notSourced',
    extraction: 'extraction.extraction',
    nothingToShow: 'extraction.nothingToShow',
    table: 'extraction.table',
    field: 'extraction.field',
    tables: 'extraction.tables',
    grids: 'extraction.grids',
    grid: 'extraction.grid',
    excelGridModeTooltip: 'extraction.excelGridModeTooltip',
    excelGridModeInstructions: 'extraction.excelGridModeInstructions',
    excelCellsModeTooltip: 'extraction.excelCellsModeTooltip',
    gridModeTooltip: 'extraction.gridModeTooltip',
    gridModeInstructions: 'extraction.gridModeInstructions',
    cellsModeTooltip: 'extraction.cellsModeTooltip',
    cells: 'extraction.cells',
    convertRowsToAdditions: 'extraction.convertRowsToAdditions',
    deleteArticleRowTitle: 'extraction.deleteArticleRowTitle',
    deleteArticleRowMessage: 'extraction.deleteArticleRowMessage',
    deleteArticleRowTooltip: 'extraction.deleteArticleRowTooltip',
    convertRowsToDeductions: 'extraction.convertRowsToDeductions',
    displayTheTable: 'extraction.displayTheTable',
    save: 'extraction.save',
    noOtherFormatsAvailable: 'extraction.noOtherFormatsAvailable',
    downloadTestFile: 'extraction.downloadTestFile',
    exportTo: 'extraction.exportTo',
    newField: 'extraction.newField',
    convertIntoField: 'extraction.convertIntoField',
    convertIntoTable: 'extraction.convertIntoTable',
    newTable: 'extraction.newTable',
    on: 'extraction.on',
    completedFields: 'extraction.completedFields',
    workComplete: 'extraction.workComplete',
    mustBeString: 'extraction.mustBeString',
    mustBeInteger: 'extraction.mustBeInteger',
    mustBeNumber: 'extraction.mustBeNumber',
    mustBeInAlpha2: 'extraction.mustBeInAlpha2',
    doitTreAuFormatAlpha2ExemplePourFranceFr:
      'extraction.doitTreAuFormatAlpha2ExemplePourFranceFr',
    mustMatchFormatDateTime: 'extraction.mustMatchFormatDateTime',
    mustMatchFormatDate: 'extraction.mustMatchFormatDate',
    pleaseEnterExactly10CharactersInFormat:
      'extraction.pleaseEnterExactly10CharactersInFormat',
    mustNotHaveMoreThanCharacters: 'extraction.mustNotHaveMoreThanCharacters',
    mustNotHaveFewerThanCharacters: 'extraction.mustNotHaveFewerThanCharacters',
    pleaseEnterBetweenXAndYCharacters:
      'extraction.pleaseEnterBetweenXAndYCharacters',
    pleaseEnterExactlyXCharacters: 'extraction.pleaseEnterExactlyXCharacters',
    pleaseEnterAWholeNumber: 'extraction.pleaseEnterAWholeNumber',
    '18LettersAndNumbersMaximum': 'extraction.18LettersAndNumbersMaximum',
    pleaseEnterANumber: 'extraction.pleaseEnterANumber',
    pleaseEnterAMaximumOf: 'extraction.pleaseEnterAMaximumOf',
    pleaseSelectFromTheGivenValues: 'extraction.pleaseSelectFromTheGivenValues',
    pleaseEnterAValueThatConsistsOfLetters:
      'extraction.pleaseEnterAValueThatConsistsOfLetters',
    pleaseEnterAValidSiretNumber: 'extraction.pleaseEnterAValidSiretNumber',
    loadingExtractionInformation: 'extraction.loadingExtractionInformation',
    emailAttachments: 'extraction.emailAttachments',
    emailAttachments_other: 'extraction.emailAttachments_other',
    loadingBackToDashboard: 'extraction.loadingBackToDashboard',
    notAccessibleForOrganization: 'extraction.notAccessibleForOrganization',
    deleteColumn: 'extraction.deleteColumn',
    doYouWantToDeleteTable: 'extraction.doYouWantToDeleteTable',
    doYouWantToDeleteTableOnCurrentPage:
      'extraction.doYouWantToDeleteTableOnCurrentPage',
    editTable: 'extraction.editTable',
    editCells: 'extraction.editCells',
    editField: 'extraction.editField',
    unknownTaricCode: 'extraction.unknownTaricCode',
    tabHasNoData: 'extraction.tabHasNoData',
    deleteTableOnlyInThePage: 'extraction.deleteTableOnlyInThePage',
    deleteTableInAllPage: 'extraction.deleteTableInAllPage',
    doYouWantToDeleteColumn: 'extraction.doYouWantToDeleteColumn',
    doYouWantToDeleteGroupedColumns:
      'extraction.doYouWantToDeleteGroupedColumns',
    doYouWantToDeleteColumnAndDeconsolidate:
      'extraction.doYouWantToDeleteColumnAndDeconsolidate',
    doYouWantToEditColumnAndDeconsolidate:
      'extraction.doYouWantToEditColumnAndDeconsolidate',
    addOriginOfArticles: 'extraction.addOriginOfArticles',
    addHSCodeOfArticles: 'extraction.addHSCodeOfArticles',
    addCodePrefOfArticles: 'extraction.addCodePrefOfArticles',
    addOriginCountryCode: 'extraction.addOriginCountryCode',
    codePreferenceModalTitle: 'extraction.codePreferenceModalTitle',
    codePreferenceCopy: 'extraction.codePreferenceCopy',
    ofItems: 'extraction.ofItems',
    add: 'extraction.add',
    doYouWantToDeleteRow: 'extraction.doYouWantToDeleteRow',
    createTable: 'extraction.createTable',
    emptyTable: 'extraction.emptyTable',
    emptyTableHintLine1: 'extraction.emptyTableHintLine1',
    emptyTableHintLine2: 'extraction.emptyTableHintLine2',
    addToTable: 'extraction.addToTable',
    declarationState: 'extraction.declarationState',
    returnToDeclarations: 'extraction.returnToDeclarations',
    updateDeclaration: 'extraction.updateDeclaration',
    declarationUploading: 'extraction.declarationUploading',
    declarationUploaded: 'extraction.declarationUploaded',
    youWillBeRedirectedToModelCreation:
      'extraction.youWillBeRedirectedToModelCreation',
    youWillBeRedirectedToTheDashboard:
      'extraction.youWillBeRedirectedToTheDashboard',
    thisDeclarationIsNotInAnErrorState:
      'extraction.thisDeclarationIsNotInAnErrorState',
    declarationUploadFailed: 'extraction.declarationUploadFailed',
    failedToLoadOptions: 'extraction.failedToLoadOptions',
    checkDeclarationAndRetry: 'extraction.checkDeclarationAndRetry',
    checkDeclaration: 'extraction.checkDeclaration',
    warningOriginX: 'extraction.warningOriginX',
    warningOriginY: 'extraction.warningOriginY',
    warningTouchingCellsOnY: 'extraction.warningTouchingCellsOnY',
    warningTouchingCellsOnX: 'extraction.warningTouchingCellsOnX',
    warningBottomRowTooSmall: 'extraction.warningBottomRowTooSmall',
    warningTopRowTooSmall: 'extraction.warningTopRowTooSmall',
    warningTableLeavesPage: 'extraction.warningTableLeavesPage',
    consolidate: 'extraction.consolidate',
    selectTheColumnsToBeUsedForConsolidation:
      'extraction.selectTheColumnsToBeUsedForConsolidation',
    consolidated: 'extraction.consolidated',
    deconsolidate: 'extraction.deconsolidate',
    clickOnTheButtonToUndoConsolidation:
      'extraction.clickOnTheButtonToUndoConsolidation',
    sendingConfirmation: 'extraction.sendingConfirmation',
    createModelInfo: 'extraction.createModelInfo',
    sendingFileQuestion: 'extraction.sendingFileQuestion',
    saveModelQuestion: 'extraction.saveModelQuestion',
    consolidateAndVerify: 'extraction.consolidateAndVerify',
    consolidateAndSend: 'extraction.consolidateAndSend',
    consolidateAndSendOptions: 'extraction.consolidateAndSendOptions',
    sendWithoutConsolidating: 'extraction.sendWithoutConsolidating',
    declarationQualityQuestion: 'extraction.declarationQualityQuestion',
    declarationQualityVeryDissatisfied:
      'extraction.declarationQualityVeryDissatisfied',
    declarationQualityVerySatisfied:
      'extraction.declarationQualityVerySatisfied',
    declarationQualityAddRemark: 'extraction.declarationQualityAddRemark',
    declarationQualityRemarkPlaceholder:
      'extraction.declarationQualityRemarkPlaceholder',
    createNewModel: 'extraction.createNewModel',
    redirectCreateModel: 'extraction.redirectCreateModel',
    modelFieldsAreFixed: 'extraction.modelFieldsAreFixed',
    selectAllFields: 'extraction.selectAllFields',
    modelDetail: 'extraction.modelDetail',
    setBatchImportError: 'extraction.setBatchImportError',
    puttingThisDossierInErrorStateTellsExternalUsersNabuCannotProcessIt:
      'extraction.puttingThisDossierInErrorStateTellsExternalUsersNabuCannotProcessIt',
    modelCreation: 'extraction.modelCreation',
    internalErrorState: 'extraction.internalErrorState',
    modelCreated: 'extraction.modelCreated',
    modelCreationFailed: 'extraction.modelCreationFailed',
    retryExport: 'extraction.retryExport',
    exportRetryDialogMessage: 'extraction.exportRetryDialogMessage',
    exportFailedMessage: 'extraction.exportFailedMessage',
    exportRetryInitiated: 'extraction.exportRetryInitiated',
    noModelApplied: 'extraction.noModelApplied',
    glideHeaderSum: 'extraction.glideHeaderSum',
    additionalCode: 'extraction.additionalCode',
    glideHeaderArticleNumber: 'extraction.glideHeaderArticleNumber',
    checkFieldModalFirstTextWarning:
      'extraction.checkFieldModalFirstTextWarning', // eslint-disable-line
    checkFieldModalFirstText: 'extraction.checkFieldModalFirstText',
    checkFieldModalFirstTextEnding: 'extraction.checkFieldModalFirstTextEnding',
    checkFieldModalSecondText: 'extraction.checkFieldModalSecondText',
    checkFieldModalFieldUpdated: 'extraction.checkFieldModalFieldUpdated',
    checkFieldModalConsolidatedTitle:
      'extraction.checkFieldModalConsolidatedTitle',
    checkFieldModalConsolidatedFirstText:
      'extraction.checkFieldModalConsolidatedFirstText',
    consolidationRequired: 'extraction.consolidationRequired',
    checkFieldModalConsolidatedSecondText:
      'extraction.checkFieldModalConsolidatedSecondText',
    checkFieldModalConsolidatedUpdatedButton:
      'extraction.checkFieldModalConsolidatedUpdatedButton',
    checkFieldModalConsolidatedSendButton:
      'extraction.checkFieldModalConsolidatedSendButton',
    checkFieldModalDependenciesWarning:
      'extraction.checkFieldModalDependenciesWarning',
    missingValuesInColumn: 'extraction.missingValuesInColumn',
    columnMissing: 'extraction.columnMissing',
    resetLabelBox: 'extraction.resetLabelBox',
    productDescription: 'extraction.productDescription',
    currency: 'extraction.currency',
    additionalCodes: 'extraction.additionalCodes', //
    noAdditionalCodesAvailableForThisTaricCode:
      'extraction.noAdditionalCodesAvailableForThisTaricCode', //
    addAnAdditionalCode: 'extraction.addAnAdditionalCode', //
    noResult: 'extraction.noResult',
    previousResult: 'extraction.previousResult',
    nextResult: 'extraction.nextResult',
    searchByKeywords: 'extraction.searchByKeywords',
    currentChoice: 'extraction.currentChoice',
    selectItem: 'extraction.selectItem',
    itemDescription: 'extraction.itemDescription',
    searchAnotherHsCode: 'extraction.searchAnotherHsCode',
    moreDetails: 'extraction.moreDetails',
    seeLess: 'extraction.seeLess',
    previousRow: 'extraction.previousRow',
    nextRow: 'extraction.nextRow',
    row: 'extraction.row',
    mustBeEqualToOneOfTheAllowedValues:
      'extraction.mustBeEqualToOneOfTheAllowedValues',
    editDescription: 'extraction.editDescription',
    replaceDescriptionByTaricCodeDescription:
      'extraction.replaceDescriptionByTaricCodeDescription',
    applyValueToAllRows: 'extraction.applyValueToAllRows',
    revertToInitialCode: 'extraction.revertToInitialCode',
    noAdditionalCodesSelected: 'extraction.noAdditionalCodesSelected',
    additionalCodesSelected: 'extraction.additionalCodesSelected',
    additionalCodesSelected_other: 'extraction.additionalCodesSelected_other',
    copyValueToEntireColumn: 'extraction.copyValueToEntireColumn',
    copyValueToEntireColumnShortcut:
      'extraction.copyValueToEntireColumnShortcut',
    copyToCurrentDocumentColumn: 'extraction.copyToCurrentDocumentColumn',
    copyToAllDocumentsColumn: 'extraction.copyToAllDocumentsColumn',
    copyToCurrentDocumentColumnShortcut:
      'extraction.copyToCurrentDocumentColumnShortcut',
    copyToColumnOptions: 'extraction.copyToColumnOptions',
    areYouSureYouWantToCopyThisCellValueToAllColumns:
      'extraction.areYouSureYouWantToCopyThisCellValueToAllColumns',
    areYouSureYouWantToCopyThisCellValueToCurrentDocumentColumn:
      'extraction.areYouSureYouWantToCopyThisCellValueToCurrentDocumentColumn',
    areYouSureYouWantToCopyThisCellValueToAllDocumentsColumns:
      'extraction.areYouSureYouWantToCopyThisCellValueToAllDocumentsColumns',
    taricCodeNotFound: 'extraction.taricCodeNotFound',
    noArticleDescription: 'extraction.noArticleDescription',
    updateDeclarationModel: 'extraction.updateDeclarationModel',
    removeModel: 'extraction.removeModel',
    changeModel: 'extraction.changeModel',
    changeModelForCurrentDeclaration:
      'extraction.changeModelForCurrentDeclaration',
    applyItemToDeclaration: 'extraction.applyItemToDeclaration',
    redoClassificationStep: 'extraction.redoClassificationStep',
    noDuty: 'extraction.noDuty',
    hoverOverAResultToSeeDetails: 'extraction.hoverOverAResultToSeeDetails',
    searchAdditionalCodesByKeyword: 'extraction.searchAdditionalCodesByKeyword',
    basicValidations: 'extraction.basicValidations',
    showAnomalies: 'extraction.showAnomalies',
    clickToViewValidationErrors: 'extraction.clickToViewValidationErrors',
    validationErrorsToFix: 'extraction.validationErrorsToFix',
    validationErrorsToFix_other: 'extraction.validationErrorsToFix_other',
    goToValidationField: 'extraction.goToValidationField',
    validationFieldError: 'extraction.validationFieldError',
    anomaliesBeforeSend: 'extraction.anomaliesBeforeSend',
    anomaliesBeforeSend_other: 'extraction.anomaliesBeforeSend_other',
    validationSummary: 'extraction.validationSummary',
    showErrorsOnlySections: 'extraction.showErrorsOnlySections',
    clearErrorsOnlyFilter: 'extraction.clearErrorsOnlyFilter',
    otherErrorFields: 'extraction.otherErrorFields',
    coherenceChecks: 'extraction.coherenceChecks',
    pressCtrlJToGoToNextCoherenceError:
      'extraction.pressCtrlJToGoToNextCoherenceError',
    sendMessage: 'extraction.sendMessage',
    newMessage: 'extraction.newMessage',
    countries: 'extraction.countries',
    excludedCountries: 'extraction.excludedCountries',
    includedCountries: 'extraction.includedCountries',
    renvois: 'extraction.renvois',
    referenceAbbrev_tax: 'extraction.referenceAbbrev_tax',
    referenceAbbrev_certificate: 'extraction.referenceAbbrev_certificate',
    referenceAbbrev_preference: 'extraction.referenceAbbrev_preference',
    referenceAbbrev_location: 'extraction.referenceAbbrev_location',
    referenceAbbrev_additionalcode: 'extraction.referenceAbbrev_additionalcode',
    taxCode: 'extraction.taxCode',
    preferenceCode: 'extraction.preferenceCode',
    duty: 'extraction.duty',
    tax: 'extraction.tax',
    prefTarif: 'extraction.prefTarif',
    tariffProvision: 'extraction.tariffProvision',
    tariffProvision_short: 'extraction.dispo-tarif',
    legalReferences: 'extraction.legalReferences',
    consolidationOptions: 'extraction.consolidationOptions',
    hscode: 'extraction.hscode',
    countryOfOrigin: 'extraction.countryOfOrigin',
    description: 'extraction.description',
    numberOfUnits: 'extraction.numberOfUnits',
    numberOfPackages: 'extraction.numberOfPackages',
    netWeight: 'extraction.netWeight',
    grossWeight: 'extraction.grossWeight',
    containerCode: 'extraction.containerCode',
    codeDescriptionNotFound: 'extraction.codeDescriptionNotFound',
    noTablesWithMergeableColumns: 'extraction.noTablesWithMergeableColumns',
    noCertificateRequired: 'extraction.noCertificateRequired',
    informationAbout: 'extraction.informationAbout',
    thisCodeHasMissingInformation: 'extraction.thisCodeHasMissingInformation',
    is: 'extraction.is',
    if: 'extraction.if',
    then: 'extraction.then',
    shouldBe: 'extraction.shouldBe',
    equalTo: 'extraction.equalTo',
    lessThan: 'extraction.lessThan',
    lessThanOrEqualTo: 'extraction.lessThanOrEqualTo',
    greaterThan: 'extraction.greaterThan',
    greaterThanOrEqualTo: 'extraction.greaterThanOrEqualTo',
    notEqualTo: 'extraction.notEqualTo',
    notIn: 'extraction.notIn',
    in: 'extraction.in',
    filled: 'extraction.filled',
    totalDocument: 'extraction.totalDocument',
    calculatedDocument: 'extraction.calculatedDocument',
    documentTotals: 'extraction.documentTotals',
    amountTotal: 'extraction.amountTotal',
    grossWeightTotal: 'extraction.grossWeightTotal',
    netWeightTotal: 'extraction.netWeightTotal',
    numberOfPosition: 'extraction.numberOfPosition',
    spread: 'extraction.spread',
    spreadOverAllLines: 'extraction.spreadOverAllLines',
    spreadDialogTitle: 'extraction.spreadDialogTitle',
    spreadDialogContent: 'extraction.spreadDialogContent',
    spreadSuccess: 'extraction.spreadSuccess',
    spreadError: 'extraction.spreadError',
    document: 'extraction.document',
    totalNotFound: 'extraction.totalNotFound',
    errorCells: 'extraction.errorCells',
    errorMissingDocumentTitle: 'extraction.errorMissingDocumentTitle',
    errorMissingDocumentContent: 'extraction.errorMissingDocumentContent',
    errorDocumentaryInconsistenciesTitle:
      'extraction.errorDocumentaryInconsistenciesTitle',
    errorDocumentaryInconsistenciesContent:
      'extraction.errorDocumentaryInconsistenciesContent',
    errorNonCompliantDocumentTitle: 'extraction.errorNonCompliantDocumentTitle',
    errorNonCompliantDocumentContent:
      'extraction.errorNonCompliantDocumentContent',
    errorGenericTitle: 'extraction.errorGenericTitle',
    errorGenericContent: 'extraction.errorGenericContent',
    noClientOrganization: 'extraction.noClientOrganization',
    searchForAField: 'searchForAField',
    keyboardShortcutTab: 'extraction.keyboardShortcutTab',
    keyboardShortcutEnter: 'extraction.keyboardShortcutEnter',
    keyboardShortcutNextField: 'extraction.keyboardShortcutNextField',
    keyboardShortcutValidate: 'extraction.keyboardShortcutValidate',
    selectedField: 'extraction.selectedField',
    stepFieldNotIdentified: 'extraction.stepFieldNotIdentified',
    stepControlEnter: 'extraction.stepControlEnter',
    stepControlEmptyValue: 'extraction.stepControlEmptyValue',
    stepControlPanelValidation: 'extraction.stepControlPanelValidation',
    stepControlNoIssues: 'extraction.stepControlNoIssues',
    stepControlSeverityCritical: 'extraction.stepControlSeverityCritical',
    stepControlSeverityGap: 'extraction.stepControlSeverityGap',
    stepControlAddTransportFees: 'extraction.stepControlAddTransportFees',
    stepControlAdditionsDeductions: 'extraction.stepControlAdditionsDeductions',
    stepControlTotalsPanelInfoTooltip: 'extraction.stepControlTotalsPanelInfoTooltip',
    stepControlTotalsCardTotalOfDocument:
      'extraction.stepControlTotalsCardTotalOfDocument',
    stepControlTotalsCardLineSum: 'extraction.stepControlTotalsCardLineSum',
    stepControlTotalsCardIdentical: 'extraction.stepControlTotalsCardIdentical',
    stepControlTotalsCardToFill: 'extraction.stepControlTotalsCardToFill',
    stepControlTotalsCardSourceCountInvoices_one:
      'extraction.stepControlTotalsCardSourceCountInvoices_one',
    stepControlTotalsCardSourceCountInvoices_other:
      'extraction.stepControlTotalsCardSourceCountInvoices_other',
    stepControlTotalsCardSourceCountPackingLists_one:
      'extraction.stepControlTotalsCardSourceCountPackingLists_one',
    stepControlTotalsCardSourceCountPackingLists_other:
      'extraction.stepControlTotalsCardSourceCountPackingLists_other',
    stepControlTotalsCardSumHint: 'extraction.stepControlTotalsCardSumHint',
    stepControlTotalsCardDocTypeInvoice:
      'extraction.stepControlTotalsCardDocTypeInvoice',
    stepControlTotalsCardDocTypePackingList:
      'extraction.stepControlTotalsCardDocTypePackingList',
    stepControlTotalsCardTooltipOk: 'extraction.stepControlTotalsCardTooltipOk',
    stepControlTotalsCardTooltipGap: 'extraction.stepControlTotalsCardTooltipGap',
    stepControlTotalsCardTooltipMissing:
      'extraction.stepControlTotalsCardTooltipMissing',
    stepKeyboardShortcutTab: 'extraction.stepKeyboardShortcutTab',
    stepKeyboardShortcutEnter: 'extraction.stepKeyboardShortcutEnter',
    stepKeyboardShortcutNextField: 'extraction.stepKeyboardShortcutNextField',
    stepKeyboardShortcutValidate: 'extraction.stepKeyboardShortcutValidate',
    stepKeyboardShortcutEscape: 'extraction.stepKeyboardShortcutEscape',
    stepKeyboardShortcutCancel: 'extraction.stepKeyboardShortcutCancel',
    stepKeyboardShortcutSearch: 'extraction.stepKeyboardShortcutSearch',
    stepKeyboardShortcutQuickActions: 'extraction.stepKeyboardShortcutQuickActions',
    summaryTableArticles: 'extraction.summaryTableArticles',
    fieldsList: 'extraction.fieldsList',
    runTableAutomations: 'extraction.runTableAutomations',
    referentialAutomationDrawerTitle:
      'extraction.referentialAutomationDrawerTitle',
    referentialAutomationDrawerSubtitle:
      'extraction.referentialAutomationDrawerSubtitle',
    referentialAutomationPreviewHint:
      'extraction.referentialAutomationPreviewHint',
    referentialAutomationSelectLabel:
      'extraction.referentialAutomationSelectLabel',
    referentialAutomationSourceLabel:
      'extraction.referentialAutomationSourceLabel',
    referentialAutomationReadyTitle:
      'extraction.referentialAutomationReadyTitle',
    referentialAutomationReadyDescription:
      'extraction.referentialAutomationReadyDescription',
    referentialAutomationLaunch: 'extraction.referentialAutomationLaunch',
    referentialAutomationApply: 'extraction.referentialAutomationApply',
    referentialAutomationApplySummary:
      'extraction.referentialAutomationApplySummary',
    referentialAutomationApplySuccess:
      'extraction.referentialAutomationApplySuccess',
    referentialAutomationApplyError:
      'extraction.referentialAutomationApplyError',
    referentialAutomationRunError: 'extraction.referentialAutomationRunError',
    referentialAutomationNoReferentials:
      'extraction.referentialAutomationNoReferentials',
    referentialAutomationRowUpdateBadge:
      'extraction.referentialAutomationRowUpdateBadge',
    referentialAutomationWillChangeLabel:
      'extraction.referentialAutomationWillChangeLabel',
    referentialAutomationWillChangeLabel_one:
      'extraction.referentialAutomationWillChangeLabel_one',
    referentialAutomationEmptyCell: 'extraction.referentialAutomationEmptyCell',
    runReferentialAutomations: 'extraction.runReferentialAutomations',
    fraisSummaryTitle: 'extraction.fraisSummaryTitle',
    remisesSummaryTitle: 'extraction.remisesSummaryTitle',
    downloadOriginalFilesForThisDossier:
      'extraction.downloadOriginalFilesForThisDossier',
    additionSummaryTitle: 'extraction.additionSummaryTitle',
    noStatisticalValueDocumentsFound:
      'extraction.noStatisticalValueDocumentsFound',
    deductionSummaryTitle: 'extraction.deductionSummaryTitle',
    conversionSourcedFrom: 'extraction.conversionSourcedFrom',
    statisticalValueSummaryTitle: 'extraction.statisticalValueSummaryTitle',
    totauxSummaryTitle: 'extraction.totauxSummaryTitle',
    totauxSummaryInfo: 'extraction.totauxSummaryInfo',
    totalsRubriqueFacturation: 'extraction.totalsRubriqueFacturation',
    totalsRubriqueColisage: 'extraction.totalsRubriqueColisage',
    totalsArticlesBadge: 'extraction.totalsArticlesBadge',
    totalsArticlesBadge_other: 'extraction.totalsArticlesBadge_other',
    statisticalValueSummaryInfo: 'extraction.statisticalValueSummaryInfo',
    statisticalValueAutoBadge: 'extraction.statisticalValueAutoBadge',
    statisticalValueManualBadge: 'extraction.statisticalValueManualBadge',
    statisticalValueIncotermLabel: 'extraction.statisticalValueIncotermLabel',
    statisticalValueIncotermFolderLabel:
      'extraction.statisticalValueIncotermFolderLabel',
    statisticalValueIncotermNotSet: 'extraction.statisticalValueIncotermNotSet',
    statisticalValueIncotermNotSetHelp:
      'extraction.statisticalValueIncotermNotSetHelp',
    statisticalValueIncotermFcaDescription:
      'extraction.statisticalValueIncotermFcaDescription',
    statisticalValueIncotermFobDescription:
      'extraction.statisticalValueIncotermFobDescription',
    statisticalValueIncotermCifDescription:
      'extraction.statisticalValueIncotermCifDescription',
    statisticalValueManualEntry: 'extraction.statisticalValueManualEntry',
    statisticalValueManualEntryHelpOff:
      'extraction.statisticalValueManualEntryHelpOff',
    statisticalValueManualEntryHelpOn:
      'extraction.statisticalValueManualEntryHelpOn',
    statisticalValueManualInputPlaceholder:
      'extraction.statisticalValueManualInputPlaceholder',
    statisticalValueManualCalculatedHint:
      'extraction.statisticalValueManualCalculatedHint',
    statisticalValueManualReuseCalculatedValue:
      'extraction.statisticalValueManualReuseCalculatedValue',
    statisticalValueTransportAbroad:
      'extraction.statisticalValueTransportAbroad',
    statisticalValueTransportAbroadHelp:
      'extraction.statisticalValueTransportAbroadHelp',
    statisticalValueBreakdownArticles:
      'extraction.statisticalValueBreakdownArticles',
    statisticalValueBreakdownTransport:
      'extraction.statisticalValueBreakdownTransport',
    statisticalValueBreakdownMiscFees:
      'extraction.statisticalValueBreakdownMiscFees',
    duplicateThisDossier: 'extraction.duplicateThisDossier',
    renameThisDossier: 'extraction.renameThisDossier',
    renameDossierTitle: 'extraction.renameDossierTitle',
    manageTags: 'extraction.manageTags',
    bugTagDuplicateTitle: 'extraction.bugTagDuplicateTitle',
    bugTagDuplicateMessage: 'extraction.bugTagDuplicateMessage',
    bugTagDuplicateYes: 'extraction.bugTagDuplicateYes',
    bugTagDuplicateNo: 'extraction.bugTagDuplicateNo',
    duplicatingFolder: 'extraction.duplicatingFolder',
    folderDuplicatedSuccessfully: 'extraction.folderDuplicatedSuccessfully',
    openDuplicatedFolder: 'extraction.openDuplicatedFolder',
    viewingDuplicatedFolder: 'extraction.viewingDuplicatedFolder',
    editLockConflictTitle: 'extraction.editLock.conflictTitle',
    editLockConflictMessage: 'extraction.editLock.conflictMessage',
    editLockSinceToday: 'extraction.editLock.sinceToday',
    editLockSinceYesterday: 'extraction.editLock.sinceYesterday',
    editLockSinceOnDate: 'extraction.editLock.sinceOnDate',
    editLockReadOnlyBadgeHint: 'extraction.editLock.readOnlyBadgeHint',
    editLockLostTitle: 'extraction.editLock.lostTitle',
    editLockLostMessage: 'extraction.editLock.lostMessage',
    editLockLockRequiredTitle: 'extraction.editLock.lockRequiredTitle',
    editLockLockRequiredMessage: 'extraction.editLock.lockRequiredMessage',
    editLockLockedBy: 'extraction.editLock.lockedBy',
    editLockTakeOver: 'extraction.editLock.takeOver',
    editLockBackToList: 'extraction.editLock.backToList',
    editLockUnknownUser: 'extraction.editLock.unknownUser',
    editLockBadgeEditing: 'extraction.editLock.badgeEditing',
    editLockBadgeReadOnly: 'extraction.editLock.badgeReadOnly',
    editLockBannerEditing: 'extraction.editLock.bannerEditing',
    editLockBannerReadOnlyConflict:
      'extraction.editLock.bannerReadOnlyConflict',
    editLockBannerReadOnlyLost: 'extraction.editLock.bannerReadOnlyLost',
    editLockEditorTooltip: 'extraction.editLock.editorTooltip',
    createAModelFromThisDossier: 'extraction.createAModelFromThisDossier',
    createANewClientOrganizationFromThisDossier:
      'extraction.createANewClientOrganizationFromThisDossier',
    runMergeAutomations: 'extraction.runMergeAutomations',
    tableAutomations: 'extraction.tableAutomations',
    tableAutomationMatchesFound: 'extraction.tableAutomationMatchesFound',
    payloads: 'extraction.payloads',
    noTableAutomationsFound: 'extraction.noTableAutomationsFound',
    noAutomationGroupsFound: 'extraction.noAutomationGroupsFound',
    noTableInDocument: 'extraction.noTableInDocument',
    allFieldsValidated: 'extraction.allFieldsValidated',
    fieldsInError: 'extraction.fieldsInError',
    fieldsValidationProgress: 'extraction.fieldsValidationProgress',
    totalFieldsToValidate: 'extraction.totalFieldsToValidate',
    sectionCompleted: 'extraction.sectionCompleted',
    sectionCompletionProgress: 'extraction.sectionCompletionProgress',
    dossierReferenceCopiedToClipboard:
      'extraction.dossierReferenceCopiedToClipboard',
    comments: 'extraction.comments',
    addAComment: 'extraction.addAComment',
    commentsForThisDeclaration: 'extraction.commentsForThisDeclaration',
    downloadDeclarationOutputFile: 'extraction.downloadDeclarationOutputFile',
    settingsDrawerTreatment: 'extraction.settingsDrawer.treatment',
    settingsDrawerFolder: 'extraction.settingsDrawer.folder',
    settingsDrawerComments: 'extraction.settingsDrawer.comments',
    settingsDrawerTags: 'extraction.settingsDrawer.tags',
    settingsDrawerLayout: 'extraction.settingsDrawer.layout',
    settingsDrawerOpenComments: 'extraction.settingsDrawer.openComments',
    settingsDrawerInvertDocumentPanel:
      'extraction.settingsDrawer.invertDocumentPanel',
    settingsDrawerLayoutBalanced: 'extraction.settingsDrawer.layoutBalanced',
    settingsDrawerLayoutDocument: 'extraction.settingsDrawer.layoutDocument',
    settingsDrawerLayoutPanel: 'extraction.settingsDrawer.layoutPanel',
    settingsDrawerLayoutDocumentTable:
      'extraction.settingsDrawer.layoutDocumentTable',
    relevanceScore: 'extraction.relevanceScore',
    rossumExtraction: 'extraction.rossumExtraction',
    legacyExtractionModel: 'extraction.legacyExtractionModel',
    newExtractionModel: 'extraction.newExtractionModel',
    rossumExtractionNoCompatibleLayer:
      'extraction.rossumExtractionNoCompatibleLayer',
    updateExtractionModelTitle: 'extraction.updateExtractionModelTitle',
    selectExtractionModel: 'extraction.selectExtractionModel',
    extractionModelRegenerateAlertToNew:
      'extraction.extractionModelRegenerateAlertToNew',
    extractionModelRegenerateAlertToLegacy:
      'extraction.extractionModelRegenerateAlertToLegacy',
    newInterfaceToggleLabel: 'extraction.newInterfaceToggleLabel',
    newInterfaceBetaBadge: 'extraction.newInterfaceBetaBadge',
    newInterfacePlaceholder: 'extraction.newInterfacePlaceholder',
    betaStepHeadersTitle: 'extraction.betaStepHeadersTitle',
    betaStepHeadersSubtitle: 'extraction.betaStepHeadersSubtitle',
    betaStepArticlesTitle: 'extraction.betaStepArticlesTitle',
    betaStepArticlesSubtitle: 'extraction.betaStepArticlesSubtitle',
    betaStepDeliveryTitle: 'extraction.betaStepDeliveryTitle',
    betaStepDeliverySubtitle: 'extraction.betaStepDeliverySubtitle',
    betaStepRegulationTitle: 'extraction.betaStepRegulationTitle',
    betaStepRegulationSubtitle: 'extraction.betaStepRegulationSubtitle',
    betaStepControlTitle: 'extraction.betaStepControlTitle',
    betaStepTotalsTitle: 'extraction.betaStepTotalsTitle',
    betaStepControlSubtitle: 'extraction.betaStepControlSubtitle',
    betaActionAssistant: 'extraction.betaActionAssistant',
    betaActionAssistantTooltip: 'extraction.betaActionAssistantTooltip',
    betaActionSourceDocument: 'extraction.betaActionSourceDocument',
    betaActionSourceDocumentTooltip: 'extraction.betaActionSourceDocumentTooltip',
    betaActionArticlesTable: 'extraction.betaActionArticlesTable',
    betaActionStartReview: 'extraction.betaActionStartReview',
    betaActionStartReviewTooltip: 'extraction.betaActionStartReviewTooltip',
    betaStatusCritical: 'extraction.betaStatusCritical',
    betaStatusWarning: 'extraction.betaStatusWarning',
    betaStatusSuggestion: 'extraction.betaStatusSuggestion',
    betaReviewProgress: 'extraction.betaReviewProgress',
    betaReviewCounter: 'extraction.betaReviewCounter',
    betaReviewPrevious: 'extraction.betaReviewPrevious',
    betaReviewNext: 'extraction.betaReviewNext',
    betaReviewOpenTable: 'extraction.betaReviewOpenTable',
    betaReviewVerified: 'extraction.betaReviewVerified',
    betaReviewClose: 'extraction.betaReviewClose',
    betaReviewNavigate: 'extraction.betaReviewNavigate',
    betaReviewPanelTitle: 'extraction.betaReviewPanelTitle',
    betaReviewPanelSubtitle: 'extraction.betaReviewPanelSubtitle',
    betaReviewPanelStartReviewHint: 'extraction.betaReviewPanelStartReviewHint',
    betaReviewPanelStartReviewHint_other: 'extraction.betaReviewPanelStartReviewHint_other',
    betaReviewPanelSectionBlocking: 'extraction.betaReviewPanelSectionBlocking',
    betaReviewPanelSectionToVerify: 'extraction.betaReviewPanelSectionToVerify',
    betaReviewPanelExportBlockedFooter: 'extraction.betaReviewPanelExportBlockedFooter',
    betaReviewPanelTabAnomalies: 'extraction.betaReviewPanelTabAnomalies',
    betaReviewPanelTabSuggestions: 'extraction.betaReviewPanelTabSuggestions',
    betaReviewPanelNoAnomalies: 'extraction.betaReviewPanelNoAnomalies',
    betaReviewPanelNoSuggestions: 'extraction.betaReviewPanelNoSuggestions',
    betaStatusSummary: 'extraction.betaStatusSummary',
    betaStatusSuggestionCount: 'extraction.betaStatusSuggestionCount',
    betaExportBlockedTitle: 'extraction.betaExportBlockedTitle',
    betaExportBlockedDescription: 'extraction.betaExportBlockedDescription',
    betaExportBlockedDescription_other: 'extraction.betaExportBlockedDescription_other',
    betaExportBlockedReview: 'extraction.betaExportBlockedReview',
    betaExportBlockedClose: 'extraction.betaExportBlockedClose',
    betaSuggestionsBannerTitle: 'extraction.betaSuggestionsBannerTitle',
    betaSuggestionsBannerSubtitle: 'extraction.betaSuggestionsBannerSubtitle',
    betaSuggestionsBannerHide: 'extraction.betaSuggestionsBannerHide',
    betaSuggestionAccept: 'extraction.betaSuggestionAccept',
    betaSuggestionIgnore: 'extraction.betaSuggestionIgnore',
    betaSuggestionConfidence_high: 'extraction.betaSuggestionConfidence_high',
    betaSuggestionConfidence_medium: 'extraction.betaSuggestionConfidence_medium',
    betaSuggestionConfidence_low: 'extraction.betaSuggestionConfidence_low',
    betaStepArticlesPlaceholder: 'extraction.betaStepArticlesPlaceholder',
    betaStepControlPlaceholder: 'extraction.betaStepControlPlaceholder',
    betaStepEmptyContent: 'extraction.betaStepEmptyContent',
    macroCheckAmount: 'extraction.macroCheckAmount',
    macroCheckPackages: 'extraction.macroCheckPackages',
    macroCheckGrossMass: 'extraction.macroCheckGrossMass',
    macroCheckNetMass: 'extraction.macroCheckNetMass',
    macroCheckOk: 'extraction.macroCheckOk',
    macroCheckLineSum: 'extraction.macroCheckLineSum',
    macroCheckSourceUnavailable: 'extraction.macroCheckSourceUnavailable',
    macroCheckTooltipAmount: 'extraction.macroCheckTooltipAmount',
    macroCheckTooltipPackages: 'extraction.macroCheckTooltipPackages',
    macroCheckTooltipGrossMass: 'extraction.macroCheckTooltipGrossMass',
    macroCheckTooltipNetMass: 'extraction.macroCheckTooltipNetMass',
    macroCheckFilterAmount: 'extraction.macroCheckFilterAmount',
    macroCheckFilterPackages: 'extraction.macroCheckFilterPackages',
    macroCheckFilterGrossMass: 'extraction.macroCheckFilterGrossMass',
    macroCheckFilterNetMass: 'extraction.macroCheckFilterNetMass',
    stepDocumentWindowTitle: 'extraction.stepDocumentWindowTitle',
    stepArticlesWindowTitle: 'extraction.stepArticlesWindowTitle',
    stepArticlesWindowOpenHint: 'extraction.stepArticlesWindowOpenHint',
    stepSourceDocumentPin: 'extraction.stepSourceDocumentPin',
    stepSourceDocumentUnpin: 'extraction.stepSourceDocumentUnpin',
    stepSourceDocumentFullscreen: 'extraction.stepSourceDocumentFullscreen',
    stepSourceDocumentOpenInOtherWindow: 'extraction.stepSourceDocumentOpenInOtherWindow',
    stepSourceDocumentOpenedInOtherWindow: 'extraction.stepSourceDocumentOpenedInOtherWindow',
    stepSourceDocumentSecondScreenTitle: 'extraction.stepSourceDocumentSecondScreenTitle',
    stepSourceDocumentSecondScreenBody: 'extraction.stepSourceDocumentSecondScreenBody',
    stepSourceDocumentSecondScreenContinue: 'extraction.stepSourceDocumentSecondScreenContinue',
    stepSourceDocumentSecondScreenTab: 'extraction.stepSourceDocumentSecondScreenTab',
    stepSourceDocumentExitFullscreen: 'extraction.stepSourceDocumentExitFullscreen',
    stepSourceDocumentClose: 'extraction.stepSourceDocumentClose',
    stepSourceDocumentResizeHandle: 'extraction.stepSourceDocumentResizeHandle',
    stepSourceDocumentTextCopied: 'extraction.stepSourceDocumentTextCopied',
    stepSourceDocumentTextCopyFailed: 'extraction.stepSourceDocumentTextCopyFailed',
    stepArticlesValuesPasted: 'extraction.stepArticlesValuesPasted',
    stepArticlesValuesPasteFailed: 'extraction.stepArticlesValuesPasteFailed',
    stepSourceDocumentPdfCopyHint: 'extraction.stepSourceDocumentPdfCopyHint',
    stepSourceDocumentExcelCopyHint: 'extraction.stepSourceDocumentExcelCopyHint',
    stepAssistantWindowTitle: 'extraction.stepAssistantWindowTitle',
    stepAssistantHeading: 'extraction.stepAssistantHeading',
    stepAssistantDescription: 'extraction.stepAssistantDescription',
    stepAssistantSuggestedActionsLabel: 'extraction.stepAssistantSuggestedActionsLabel',
    stepAssistantPlaceholder: 'extraction.stepAssistantPlaceholder',
    stepAssistantInputPlaceholder: 'extraction.stepAssistantInputPlaceholder',
    stepAssistantSend: 'extraction.stepAssistantSend',
    stepAssistantAddAttachment: 'extraction.stepAssistantAddAttachment',
    stepAssistantVoiceInput: 'extraction.stepAssistantVoiceInput',
    stepAssistantVoiceStop: 'extraction.stepAssistantVoiceStop',
    stepAssistantVoiceTranscribing: 'extraction.stepAssistantVoiceTranscribing',
    stepAssistantVoiceMicrophoneDenied: 'extraction.stepAssistantVoiceMicrophoneDenied',
    stepAssistantVoiceTooLong: 'extraction.stepAssistantVoiceTooLong',
    stepAssistantVoiceFailed: 'extraction.stepAssistantVoiceFailed',
    stepAssistantRefresh: 'extraction.stepAssistantRefresh',
    stepAssistantPin: 'extraction.stepAssistantPin',
    stepAssistantUnpin: 'extraction.stepAssistantUnpin',
    stepAssistantClose: 'extraction.stepAssistantClose',
    stepAssistantResizeHandle: 'extraction.stepAssistantResizeHandle',
    stepAssistantSuggestedActionBlocked: 'extraction.stepAssistantSuggestedActionBlocked',
    stepAssistantSuggestedActionTotals: 'extraction.stepAssistantSuggestedActionTotals',
    stepAssistantSuggestedActionMissing: 'extraction.stepAssistantSuggestedActionMissing',
    stepAssistantSuggestedActionHistory: 'extraction.stepAssistantSuggestedActionHistory',
    stepAssistantSkillsLabel: 'extraction.stepAssistantSkillsLabel',
    stepAssistantNoSkillsPrefix: 'extraction.stepAssistantNoSkillsPrefix',
    stepAssistantCreateSkill: 'extraction.stepAssistantCreateSkill',
    stepAssistantAddSkill: 'extraction.stepAssistantAddSkill',
    stepAssistantSendTooltip: 'extraction.stepAssistantSendTooltip',
    stepAssistantRemoveSkill: 'extraction.stepAssistantRemoveSkill',
    stepAssistantSkillsHint: 'extraction.stepAssistantSkillsHint',
    stepAssistantApprove: 'extraction.stepAssistantApprove',
    stepAssistantDeny: 'extraction.stepAssistantDeny',
    stepAssistantToolDone: 'extraction.stepAssistantToolDone',
    stepAssistantToolDenied: 'extraction.stepAssistantToolDenied',
    stepAssistantToolFailed: 'extraction.stepAssistantToolFailed',
    stepAssistantToolPartial: 'extraction.stepAssistantToolPartial',
    stepAssistantToolNotApplied: 'extraction.stepAssistantToolNotApplied',
    stepAssistantToolInProgress: 'extraction.stepAssistantToolInProgress',
    stepAssistantToolAddComment: 'extraction.stepAssistantToolAddComment',
    stepAssistantToolSetTags: 'extraction.stepAssistantToolSetTags',
    stepAssistantToolUpdateFields: 'extraction.stepAssistantToolUpdateFields',
    stepAssistantToolAddLines: 'extraction.stepAssistantToolAddLines',
    stepAssistantToolGetDossier: 'extraction.stepAssistantToolGetDossier',
    stepAssistantToolGetDossierDocuments:
      'extraction.stepAssistantToolGetDossierDocuments',
    stepAssistantToolGetDossierProgress:
      'extraction.stepAssistantToolGetDossierProgress',
    stepAssistantToolGetDossierHistory:
      'extraction.stepAssistantToolGetDossierHistory',
    stepAssistantToolGetDossierErrorStatus:
      'extraction.stepAssistantToolGetDossierErrorStatus',
    stepAssistantToolGetDeclaration: 'extraction.stepAssistantToolGetDeclaration',
    stepAssistantToolGetDeclarationValidation:
      'extraction.stepAssistantToolGetDeclarationValidation',
    stepAssistantToolGetDeclarationContent:
      'extraction.stepAssistantToolGetDeclarationContent',
    stepAssistantToolUnknown: 'extraction.stepAssistantToolUnknown',
    stepAssistantToolGetTags: 'extraction.stepAssistantToolGetTags',
    stepAssistantToolGetDocumentFacts:
      'extraction.stepAssistantToolGetDocumentFacts',
    stepAssistantToolGetPageText: 'extraction.stepAssistantToolGetPageText',
    stepAssistantToolGetSpreadsheet:
      'extraction.stepAssistantToolGetSpreadsheet',
    stepAssistantToolCompareDocuments:
      'extraction.stepAssistantToolCompareDocuments',
    stepAssistantToolGetDeclarationGestures:
      'extraction.stepAssistantToolGetDeclarationGestures',
    stepAssistantToolGetExchangeRates:
      'extraction.stepAssistantToolGetExchangeRates',
    stepAssistantToolLookupCatalog:
      'extraction.stepAssistantToolLookupCatalog',
    stepAssistantToolGetDeclarationFields:
      'extraction.stepAssistantToolGetDeclarationFields',
    stepAssistantToolExplainFieldValue:
      'extraction.stepAssistantToolExplainFieldValue',
    stepAssistantToolFindClientHistory:
      'extraction.stepAssistantToolFindClientHistory',
    stepAssistantToolCalculate: 'extraction.stepAssistantToolCalculate',
    stepAssistantToolListInstructions: 'extraction.stepAssistantToolListInstructions',
    stepAssistantToolUpdateInstructionText: 'extraction.stepAssistantToolUpdateInstructionText',
    stepAssistantToolSetInstructionAutomatic: 'extraction.stepAssistantToolSetInstructionAutomatic',
    stepAssistantInstructionName: 'extraction.stepAssistantInstructionName',
    stepAssistantInstructionTextBefore: 'extraction.stepAssistantInstructionTextBefore',
    stepAssistantInstructionTextAfter: 'extraction.stepAssistantInstructionTextAfter',
    stepAssistantInstructionBecomesAutomatic: 'extraction.stepAssistantInstructionBecomesAutomatic',
    stepAssistantInstructionBecomesOnDemand: 'extraction.stepAssistantInstructionBecomesOnDemand',
    stepAssistantApprovalShowAll: 'extraction.stepAssistantApprovalShowAll',
    stepAssistantApprovalShowLess: 'extraction.stepAssistantApprovalShowLess',
    stepAssistantWaitingForReply: 'extraction.stepAssistantWaitingForReply',
    stepAssistantHistoryLoadError: 'extraction.stepAssistantHistoryLoadError',
    stepAssistantHistoryRetry: 'extraction.stepAssistantHistoryRetry',
    stepAssistantMessageTimeYesterday: 'extraction.stepAssistantMessageTimeYesterday',
    stepAssistantMessageTimeOnDate: 'extraction.stepAssistantMessageTimeOnDate',
    stepAssistantReplyError: 'extraction.stepAssistantReplyError',
    stepAssistantQuotaReached: 'extraction.stepAssistantQuotaReached',
    stepAssistantDisabled: 'extraction.stepAssistantDisabled',
    stepAssistantThinking: 'extraction.stepAssistantThinking',
    stepAssistantStepsOne: 'extraction.stepAssistantStepsOne',
    stepAssistantStepsOther: 'extraction.stepAssistantStepsOther',
    stepAssistantStepWrite: 'extraction.stepAssistantStepWrite',
  },
  extractionSteps: {
    'run-export': 'extractionSteps.run-export',
    'start-work': 'extractionSteps.start-work',
    'publishing-page-messages': 'extractionSteps.publishing-page-messages',
    'start-extraction': 'extractionSteps.start-extraction',
    'apply-post-process': 'extractionSteps.apply-post-process',
    'apply-specific-data': 'extractionSteps.apply-specific-data',
    'batch-import-status-to-done':
      'extractionSteps.batch-import-status-to-done',
    'parsing-ocr': 'extractionSteps.parsing-ocr',
    'get-fast-track-option': 'extractionSteps.get-fast-track-option',
    'handle-ocr': 'extractionSteps.handle-ocr',
    'collecting-configurations': 'extractionSteps.collecting-configurations',
    'starting-work': 'extractionSteps.starting-work',
    'save-export-data': 'extractionSteps.save-export-data',
    'update-batch-import-status': 'extractionSteps.update-batch-import-status',
    'canceled-iteration': 'extractionSteps.canceled-iteration',
    'classification-done': 'extractionSteps.classification-done',
    'saving-pages': 'extractionSteps.saving-pages',
    'end-validation-work': 'extractionSteps.end-validation-work',
    'end-mapping-work': 'extractionSteps.end-mapping-work',
    'start-ocr-work': 'extractionSteps.start-ocr-work',
    'create-files-in-database': 'extractionSteps.create-files-in-database',
    'generate-export': 'extractionSteps.generate-export',
    'start-mapping-work': 'extractionSteps.start-mapping-work',
    'segmentation-done': 'extractionSteps.segmentation-done',
    'apply-segmentations': 'extractionSteps.apply-segmentations',
    'fetching-file': 'extractionSteps.fetching-file',
    deskew: 'extractionSteps.deskew',
  },
  flows: {
    sender: 'flows.sender',
    receiver: 'flows.receiver',
    modelType: 'flows.modelType',
    exportContext: 'flows.exportContext',
  },
  settings: {
    noDocumentsFound: 'settings.noDocumentsFound',
    docTitleProfile: 'settings.docTitleProfile',
    docTitleNotifications: 'settings.docTitleNotifications',
    docTitleSecurity: 'settings.docTitleSecurity',
    docTitleOrg: 'settings.docTitleOrg',
    docTitleFormCustomization: 'settings.docTitleFormCustomization',
    formCustomizationPageTitle: 'settings.formCustomizationPageTitle',
    formCustomizationPageSubtitle: 'settings.formCustomizationPageSubtitle',
    formCustomizationLoadError: 'settings.formCustomizationLoadError',
    formCustomizationMissingSchema: 'settings.formCustomizationMissingSchema',
    formCustomizationConexTitle: 'settings.formCustomizationConexTitle',
    formCustomizationConexSubtitle: 'settings.formCustomizationConexSubtitle',
    formCustomizationConexDescription:
      'settings.formCustomizationConexDescription',
    formCustomizationAkaneaTitle: 'settings.formCustomizationAkaneaTitle',
    formCustomizationAkaneaSubtitle: 'settings.formCustomizationAkaneaSubtitle',
    formCustomizationAkaneaDescription:
      'settings.formCustomizationAkaneaDescription',
    formCustomizationLayoutName: 'settings.formCustomizationLayoutName',
    formCustomizationApplyLayout: 'settings.formCustomizationApplyLayout',
    formCustomizationAppliedBadge: 'settings.formCustomizationAppliedBadge',
    formCustomizationStartingModel: 'settings.formCustomizationStartingModel',
    formCustomizationStartingModelSubtitle:
      'settings.formCustomizationStartingModelSubtitle',
    formCustomizationNabuModelTitle: 'settings.formCustomizationNabuModelTitle',
    formCustomizationNabuModelSubtitle:
      'settings.formCustomizationNabuModelSubtitle',
    formCustomizationResetNabu: 'settings.formCustomizationResetNabu',
    formCustomizationTabsContent: 'settings.formCustomizationTabsContent',
    formCustomizationCollapseAll: 'settings.formCustomizationCollapseAll',
    formCustomizationExpandAll: 'settings.formCustomizationExpandAll',
    formCustomizationEdit: 'settings.formCustomizationEdit',
    formCustomizationTabTitleLabel: 'settings.formCustomizationTabTitleLabel',
    formCustomizationAddFieldAction: 'settings.formCustomizationAddFieldAction',
    formCustomizationApplyConfirm: 'settings.formCustomizationApplyConfirm',
    formCustomizationApplyModalTitle: 'settings.formCustomizationApplyModalTitle',
    formCustomizationApplyModalConfirm:
      'settings.formCustomizationApplyModalConfirm',
    formCustomizationResetConfirm: 'settings.formCustomizationResetConfirm',
    formCustomizationTabHeaders: 'settings.formCustomizationTabHeaders',
    formCustomizationTabDelivery: 'settings.formCustomizationTabDelivery',
    formCustomizationTabRegulation: 'settings.formCustomizationTabRegulation',
    formCustomizationVisibleSections:
      'settings.formCustomizationVisibleSections',
    formCustomizationRenameTab: 'settings.formCustomizationRenameTab',
    formCustomizationSearchPlaceholder:
      'settings.formCustomizationSearchPlaceholder',
    formCustomizationFilterVisibility:
      'settings.formCustomizationFilterVisibility',
    formCustomizationFilterRequired: 'settings.formCustomizationFilterRequired',
    formCustomizationFilterAll: 'settings.formCustomizationFilterAll',
    formCustomizationFilterVisible: 'settings.formCustomizationFilterVisible',
    formCustomizationFilterHidden: 'settings.formCustomizationFilterHidden',
    formCustomizationFilterRequiredOnly:
      'settings.formCustomizationFilterRequiredOnly',
    formCustomizationFilterOptional: 'settings.formCustomizationFilterOptional',
    formCustomizationShowRequiredBadge:
      'settings.formCustomizationShowRequiredBadge',
    formCustomizationPreview: 'settings.formCustomizationPreview',
    formCustomizationFieldsCount: 'settings.formCustomizationFieldsCount',
    formCustomizationMoveSection: 'settings.formCustomizationMoveSection',
    formCustomizationSection: 'settings.formCustomizationSection',
    formCustomizationMoveField: 'settings.formCustomizationMoveField',
    formCustomizationAddField: 'settings.formCustomizationAddField',
    formCustomizationRequired: 'settings.formCustomizationRequired',
    formCustomizationDefaultValue: 'settings.formCustomizationDefaultValue',
    formCustomizationBehavior: 'settings.formCustomizationBehavior',
    formCustomizationBehaviorPrefilled:
      'settings.formCustomizationBehaviorPrefilled',
    formCustomizationBehaviorLocked:
      'settings.formCustomizationBehaviorLocked',
    formCustomizationBehaviorSuggested:
      'settings.formCustomizationBehaviorSuggested',
    formCustomizationDuplicate: 'settings.formCustomizationDuplicate',
    formCustomizationRemove: 'settings.formCustomizationRemove',
    formCustomizationHide: 'settings.formCustomizationHide',
    formCustomizationShow: 'settings.formCustomizationShow',
    formCustomizationRequiredBadge: 'settings.formCustomizationRequiredBadge',
    formCustomizationPreviewSelectPlaceholder:
      'settings.formCustomizationPreviewSelectPlaceholder',
    formCustomizationLockedBadge: 'settings.formCustomizationLockedBadge',
    formCustomizationSuggestedHint: 'settings.formCustomizationSuggestedHint',
    settingsUnsavedChanges: 'settings.settingsUnsavedChanges',
    settingsLeaveUnsavedTitle: 'settings.settingsLeaveUnsavedTitle',
    settingsLeaveUnsavedMessage: 'settings.settingsLeaveUnsavedMessage',
    settingsLeaveUnsavedConfirm: 'settings.settingsLeaveUnsavedConfirm',
    formCustomizationSaved: 'settings.formCustomizationSaved',
    formCustomizationSaveError: 'settings.formCustomizationSaveError',
    formCustomizationAnomalyHiddenRequired:
      'settings.formCustomizationAnomalyHiddenRequired',
    formCustomizationAnomalyEmptySection:
      'settings.formCustomizationAnomalyEmptySection',
    formCustomizationAnomalyLockedNoDefault:
      'settings.formCustomizationAnomalyLockedNoDefault',
    formCustomizationNoSections: 'settings.formCustomizationNoSections',
    docTitleAgencies: 'settings.docTitleAgencies',
    docTitleAgencyDetail: 'settings.docTitleAgencyDetail',
    docTitleMembers: 'settings.docTitleMembers',
    docTitleMemberDetail: 'settings.docTitleMemberDetail',
    docTitleRoles: 'settings.docTitleRoles',
    docTitleEmailTemplates: 'settings.docTitleEmailTemplates',
    docTitleHelp: 'settings.docTitleHelp',
    docTitleAiAgents: 'settings.docTitleAiAgents',
    docTitleSubscription: 'settings.docTitleSubscription',
    docTitleBilling: 'settings.docTitleBilling',
    sidebarKicker: 'settings.sidebarKicker',
    back: 'settings.back',
    groupYourAccount: 'settings.groupYourAccount',
    groupOrganization: 'settings.groupOrganization',
    groupModules: 'settings.groupModules',
    groupSupport: 'settings.groupSupport',
    navProfile: 'settings.navProfile',
    navNotifications: 'settings.navNotifications',
    navSecurity: 'settings.navSecurity',
    navOrganization: 'settings.navOrganization',
    navAgencies: 'settings.navAgencies',
    navMembers: 'settings.navMembers',
    navFormCustomization: 'settings.navFormCustomization',
    navRoles: 'settings.navRoles',
    navEmailTemplates: 'settings.navEmailTemplates',
    navAiAgents: 'settings.navAiAgents',
    navSubscription: 'settings.navSubscription',
    navBilling: 'settings.navBilling',
    navHelpCenter: 'settings.navHelpCenter',
    helpBoxTitle: 'settings.helpBoxTitle',
    helpBoxBody: 'settings.helpBoxBody',
    helpDocumentationLink: 'settings.helpDocumentationLink',
    aiAgentsPageTitle: 'settings.aiAgentsPageTitle',
    aiAgentsPageSubtitle: 'settings.aiAgentsPageSubtitle',
    aiAgentsLoadError: 'settings.aiAgentsLoadError',
    aiAgentsSkillsSectionTitle: 'settings.aiAgentsSkillsSectionTitle',
    aiAgentsSkillsSectionDescription: 'settings.aiAgentsSkillsSectionDescription',
    aiAgentsNewSkillButton: 'settings.aiAgentsNewSkillButton',
    aiAgentsCreateFirstSkillButton: 'settings.aiAgentsCreateFirstSkillButton',
    aiAgentsSkillsEmptyTitle: 'settings.aiAgentsSkillsEmptyTitle',
    aiAgentsSkillsEmptyDescription: 'settings.aiAgentsSkillsEmptyDescription',
    aiAgentsCreateSkillTitle: 'settings.aiAgentsCreateSkillTitle',
    aiAgentsCreateSkillSubtitle: 'settings.aiAgentsCreateSkillSubtitle',
    aiAgentsEditSkillTitle: 'settings.aiAgentsEditSkillTitle',
    aiAgentsSkillNameLabel: 'settings.aiAgentsSkillNameLabel',
    aiAgentsSkillNameRequired: 'settings.aiAgentsSkillNameRequired',
    aiAgentsSkillDescriptionLabel: 'settings.aiAgentsSkillDescriptionLabel',
    aiAgentsSkillDescriptionPlaceholder: 'settings.aiAgentsSkillDescriptionPlaceholder',
    aiAgentsSkillIconLabel: 'settings.aiAgentsSkillIconLabel',
    aiAgentsSkillWorkMethodLabel: 'settings.aiAgentsSkillWorkMethodLabel',
    aiAgentsSkillWorkMethodPlaceholder: 'settings.aiAgentsSkillWorkMethodPlaceholder',
    aiAgentsSkillWorkMethodTooltip: 'settings.aiAgentsSkillWorkMethodTooltip',
    aiAgentsCreateSkillSubmit: 'settings.aiAgentsCreateSkillSubmit',
    aiAgentsDeleteSkillTitle: 'settings.aiAgentsDeleteSkillTitle',
    aiAgentsDeleteSkillDescription: 'settings.aiAgentsDeleteSkillDescription',
    aiAgentsSkillNabuBadge: 'settings.aiAgentsSkillNabuBadge',
    aiAgentsSkillNabuTooltip: 'settings.aiAgentsSkillNabuTooltip',
    aiAgentsSkillDecTypesLabel: 'settings.aiAgentsSkillDecTypesLabel',
    aiAgentsSkillDecTypesHelper: 'settings.aiAgentsSkillDecTypesHelper',
    aiAgentsSkillDecTypesAll: 'settings.aiAgentsSkillDecTypesAll',
    aiAgentsSkillAutomaticLabel: 'settings.aiAgentsSkillAutomaticLabel',
    aiAgentsSkillAutomaticHelper: 'settings.aiAgentsSkillAutomaticHelper',
    aiAgentsSkillAutomaticBadge: 'settings.aiAgentsSkillAutomaticBadge',
    aiAgentsRoutinesSectionTitle: 'settings.aiAgentsRoutinesSectionTitle',
    aiAgentsRoutinesSectionDescription: 'settings.aiAgentsRoutinesSectionDescription',
    aiAgentsNewRoutineButton: 'settings.aiAgentsNewRoutineButton',
    aiAgentsRoutinesEmptyTitle: 'settings.aiAgentsRoutinesEmptyTitle',
    aiAgentsRoutinesEmptyDescription: 'settings.aiAgentsRoutinesEmptyDescription',
    aiAgentsRoutinesLoadError: 'settings.aiAgentsRoutinesLoadError',
    aiAgentsCreateRoutineTitle: 'settings.aiAgentsCreateRoutineTitle',
    aiAgentsEditRoutineTitle: 'settings.aiAgentsEditRoutineTitle',
    aiAgentsRoutineSubtitle: 'settings.aiAgentsRoutineSubtitle',
    aiAgentsRoutineNameLabel: 'settings.aiAgentsRoutineNameLabel',
    aiAgentsRoutineClientLabel: 'settings.aiAgentsRoutineClientLabel',
    aiAgentsRoutineClientHelper: 'settings.aiAgentsRoutineClientHelper',
    aiAgentsRoutineAllClients: 'settings.aiAgentsRoutineAllClients',
    aiAgentsRoutineDecTypeLabel: 'settings.aiAgentsRoutineDecTypeLabel',
    aiAgentsRoutineInstructionsLabel: 'settings.aiAgentsRoutineInstructionsLabel',
    aiAgentsRoutineInstructionsHelper: 'settings.aiAgentsRoutineInstructionsHelper',
    aiAgentsRoutineAddInstruction: 'settings.aiAgentsRoutineAddInstruction',
    aiAgentsRoutineNoInstructionLeft: 'settings.aiAgentsRoutineNoInstructionLeft',
    aiAgentsRoutineInstructionOtherType: 'settings.aiAgentsRoutineInstructionOtherType',
    aiAgentsRoutineInstructionUnavailable: 'settings.aiAgentsRoutineInstructionUnavailable',
    aiAgentsRoutineDragInstruction: 'settings.aiAgentsRoutineDragInstruction',
    aiAgentsRoutineRemoveInstruction: 'settings.aiAgentsRoutineRemoveInstruction',
    aiAgentsRoutineInstructionsCount: 'settings.aiAgentsRoutineInstructionsCount',
    aiAgentsRoutineInstructionsCount_other: 'settings.aiAgentsRoutineInstructionsCount_other',
    aiAgentsRoutineActive: 'settings.aiAgentsRoutineActive',
    aiAgentsRoutineInactive: 'settings.aiAgentsRoutineInactive',
    aiAgentsCreateRoutineSubmit: 'settings.aiAgentsCreateRoutineSubmit',
    aiAgentsDeleteRoutineTitle: 'settings.aiAgentsDeleteRoutineTitle',
    aiAgentsDeleteRoutineDescription: 'settings.aiAgentsDeleteRoutineDescription',
    aiAgentsToastRoutineCreated: 'settings.aiAgentsToastRoutineCreated',
    aiAgentsToastRoutineUpdated: 'settings.aiAgentsToastRoutineUpdated',
    aiAgentsToastRoutineDeleted: 'settings.aiAgentsToastRoutineDeleted',
    aiAgentsRoutineConditionsTaken: 'settings.aiAgentsRoutineConditionsTaken',
    aiAgentsToastSkillInRoutine: 'settings.aiAgentsToastSkillInRoutine',
    aiAgentsBlockedByNabu: 'settings.aiAgentsBlockedByNabu',
    aiAgentsBlockedByNabuTooltip: 'settings.aiAgentsBlockedByNabuTooltip',
    aiAgentsToastBlockedByNabu: 'settings.aiAgentsToastBlockedByNabu',
    aiAgentsSkillScopeLabel: 'settings.aiAgentsSkillScopeLabel',
    aiAgentsSkillScopeHelper: 'settings.aiAgentsSkillScopeHelper',
    aiAgentsSkillAgencySubAgencies: 'settings.aiAgentsSkillAgencySubAgencies',
    aiAgentsSkillIconBook: 'settings.aiAgentsSkillIconBook',
    aiAgentsSkillIconLightning: 'settings.aiAgentsSkillIconLightning',
    aiAgentsSkillIconGrid: 'settings.aiAgentsSkillIconGrid',
    aiAgentsSkillIconDocument: 'settings.aiAgentsSkillIconDocument',
    aiAgentsSkillIconSearch: 'settings.aiAgentsSkillIconSearch',
    aiAgentsSkillIconLayers: 'settings.aiAgentsSkillIconLayers',
    aiAgentsSkillIconShield: 'settings.aiAgentsSkillIconShield',
    aiAgentsSkillIconShuffle: 'settings.aiAgentsSkillIconShuffle',
    aiAgentsToastSkillCreated: 'settings.aiAgentsToastSkillCreated',
    aiAgentsToastSkillUpdated: 'settings.aiAgentsToastSkillUpdated',
    aiAgentsToastSkillDeleted: 'settings.aiAgentsToastSkillDeleted',
    aiAgentsToastSaveError: 'settings.aiAgentsToastSaveError',
    previewNoticeLocalOnly: 'settings.previewNoticeLocalOnly',
    previewNoticeInviteSoon: 'settings.previewNoticeInviteSoon',
    previewNoticeAgencyCreateSoon: 'settings.previewNoticeAgencyCreateSoon',
    previewNoticeRolesReadOnly: 'settings.previewNoticeRolesReadOnly',
    previewNoticeEmailTemplatesSoon: 'settings.previewNoticeEmailTemplatesSoon',
    previewNoticeHelpLinksSoon: 'settings.previewNoticeHelpLinksSoon',
    previewNoticeOrgConfigDemo: 'settings.previewNoticeOrgConfigDemo',
    orgConfigDemoSaved: 'settings.orgConfigDemoSaved',
    profilePageTitle: 'settings.profilePageTitle',
    profilePageSubtitle: 'settings.profilePageSubtitle',
    profileSectionPersonal: 'settings.profileSectionPersonal',
    profileSectionPersonalSubtitle: 'settings.profileSectionPersonalSubtitle',
    profileSectionPrefs: 'settings.profileSectionPrefs',
    profileSectionPrefsSubtitle: 'settings.profileSectionPrefsSubtitle',
    profileSectionDeclaration: 'settings.profileSectionDeclaration',
    profileTabGeneral: 'settings.profileTabGeneral',
    profileTabPreferences: 'settings.profileTabPreferences',
    profileTabConfiguration: 'settings.profileTabConfiguration',
    profilePreferencesInterface: 'settings.profilePreferencesInterface',
    profilePreferencesPreparation: 'settings.profilePreferencesPreparation',
    profilePreferencesPreparationClassic: 'settings.profilePreferencesPreparationClassic',
    profilePreferencesPreparationIntelligent: 'settings.profilePreferencesPreparationIntelligent',
    profilePreferencesBetaViews: 'settings.profilePreferencesBetaViews',
    profilePreferencesBetaViewsSubtitle: 'settings.profilePreferencesBetaViewsSubtitle',
    profilePreferencesSmartView: 'settings.profilePreferencesSmartView',
    profilePreferencesSmartViewSubtitle: 'settings.profilePreferencesSmartViewSubtitle',
    profilePreferencesSourceDocument: 'settings.profilePreferencesSourceDocument',
    profilePreferencesSourceDocumentDesc: 'settings.profilePreferencesSourceDocumentDesc',
    profilePreferencesControlPanel: 'settings.profilePreferencesControlPanel',
    profilePreferencesControlPanelDesc: 'settings.profilePreferencesControlPanelDesc',
    profilePreferencesAssistant: 'settings.profilePreferencesAssistant',
    profilePreferencesAssistantDesc: 'settings.profilePreferencesAssistantDesc',
    profilePreferencesHomeTab: 'settings.profilePreferencesHomeTab',
    profilePreferencesHomeTabDesc: 'settings.profilePreferencesHomeTabDesc',
    profilePreferencesLoadState: 'settings.profilePreferencesLoadState',
    profilePreferencesPlacementHidden: 'settings.profilePreferencesPlacementHidden',
    profilePreferencesPlacementFloating: 'settings.profilePreferencesPlacementFloating',
    profilePreferencesPlacementLeft: 'settings.profilePreferencesPlacementLeft',
    profilePreferencesPlacementRight: 'settings.profilePreferencesPlacementRight',
    profileSectionWorkMode: 'settings.profileSectionWorkMode',
    profileSectionWorkModeSubtitle: 'settings.profileSectionWorkModeSubtitle',
    profilePreferencesPreparationClassicDesc: 'settings.profilePreferencesPreparationClassicDesc',
    profilePreferencesPreparationIntelligentDesc: 'settings.profilePreferencesPreparationIntelligentDesc',
    profilePreferencesInterfaceStandard: 'settings.profilePreferencesInterfaceStandard',
    profilePreferencesInterfaceBeta: 'settings.profilePreferencesInterfaceBeta',
    profilePreferencesInterfaceStandardDesc: 'settings.profilePreferencesInterfaceStandardDesc',
    profilePreferencesInterfaceBetaDesc: 'settings.profilePreferencesInterfaceBetaDesc',
    profilePreferencesBetaBadge: 'settings.profilePreferencesBetaBadge',
    profilePreferencesPlacementClosed: 'settings.profilePreferencesPlacementClosed',
    profilePreferencesDefaultTab: 'settings.profilePreferencesDefaultTab',
    profilePreferencesSaved: 'settings.profilePreferencesSaved',
    profileUserConfigCardTitle: 'settings.profileUserConfigCardTitle',
    profileUserConfigCardSubtitle: 'settings.profileUserConfigCardSubtitle',
    profileUserConfigInheritanceTitle:
      'settings.profileUserConfigInheritanceTitle',
    profileUserConfigInheritanceDescription:
      'settings.profileUserConfigInheritanceDescription',
    profileConfigurationSectionSubtitle:
      'settings.profileConfigurationSectionSubtitle',
    profileConfigurationTabPlaceholder:
      'settings.profileConfigurationTabPlaceholder',
    profileEmailLabel: 'settings.profileEmailLabel',
    themeLabel: 'settings.themeLabel',
    themeLight: 'settings.themeLight',
    themeLightDesc: 'settings.themeLightDesc',
    themeDark: 'settings.themeDark',
    themeDarkDesc: 'settings.themeDarkDesc',
    themeSystem: 'settings.themeSystem',
    themeSystemDesc: 'settings.themeSystemDesc',
    toastProfileUpdated: 'settings.toastProfileUpdated',
    toastProfileError: 'settings.toastProfileError',
    validationRequired: 'settings.validationRequired',
    notificationsPageTitle: 'settings.notificationsPageTitle',
    notificationsPageSubtitle: 'settings.notificationsPageSubtitle',
    notificationsSectionEmail: 'settings.notificationsSectionEmail',
    notificationsMasterTitle: 'settings.notificationsMasterTitle',
    notificationsMasterDesc: 'settings.notificationsMasterDesc',
    notifAck: 'settings.notifAck',
    notifAckDesc: 'settings.notifAckDesc',
    notifFinalized: 'settings.notifFinalized',
    notifFinalizedDesc: 'settings.notifFinalizedDesc',
    notifDeclErr: 'settings.notifDeclErr',
    notifDeclErrDesc: 'settings.notifDeclErrDesc',
    notifPipelineErr: 'settings.notifPipelineErr',
    notifPipelineErrDesc: 'settings.notifPipelineErrDesc',
    notifMasterStateAllOn: 'settings.notifMasterStateAllOn',
    notifMasterStatePartial: 'settings.notifMasterStatePartial',
    notifMasterStateAllOff: 'settings.notifMasterStateAllOff',
    notifPipelineRowTitle: 'settings.notifPipelineRowTitle',
    notifPipelineRowDesc: 'settings.notifPipelineRowDesc',
    securityPageTitle: 'settings.securityPageTitle',
    securityPageSubtitle: 'settings.securityPageSubtitle',
    securitySectionPasswordSubtitle: 'settings.securitySectionPasswordSubtitle',
    securityPasswordAside: 'settings.securityPasswordAside',
    securityUpdatePasswordButton: 'settings.securityUpdatePasswordButton',
    orgPageTitle: 'settings.orgPageTitle',
    orgPageSubtitle: 'settings.orgPageSubtitle',
    orgTabGeneral: 'settings.orgTabGeneral',
    orgTabConfiguration: 'settings.orgTabConfiguration',
    orgTabPreferences: 'settings.orgTabPreferences',
    orgGeneralTitle: 'settings.orgGeneralTitle',
    orgGeneralSubtitle: 'settings.orgGeneralSubtitle',
    orgFieldOrgName: 'settings.orgFieldOrgName',
    orgFieldIdentifier: 'settings.orgFieldIdentifier',
    orgLoading: 'settings.orgLoading',
    orgSaveDisabledHint: 'settings.orgSaveDisabledHint',
    orgConfigChooseAgency: 'settings.orgConfigChooseAgency',
    orgConfigChooseConfig: 'settings.orgConfigChooseConfig',
    orgConfigPlaceholder: 'settings.orgConfigPlaceholder',
    orgConfigSectionTitle: 'settings.orgConfigSectionTitle',
    orgConfigSectionSubtitle: 'settings.orgConfigSectionSubtitle',
    orgPreferencesCardTitle: 'settings.orgPreferencesCardTitle',
    orgPreferencesCardSubtitle: 'settings.orgPreferencesCardSubtitle',
    orgPreferencesLimitAgencyLabel: 'settings.orgPreferencesLimitAgencyLabel',
    orgPreferencesLimitAgencyDescription:
      'settings.orgPreferencesLimitAgencyDescription',
    agenciesChipAllLabel: 'settings.agenciesChipAllLabel',
    orgPreferencesSoon: 'settings.orgPreferencesSoon',
    agenciesPageTitle: 'settings.agenciesPageTitle',
    agenciesPageSubtitle: 'settings.agenciesPageSubtitle',
    agenciesNewButton: 'settings.agenciesNewButton',
    agenciesSearchPlaceholder: 'settings.agenciesSearchPlaceholder',
    agenciesLoading: 'settings.agenciesLoading',
    agenciesEmpty: 'settings.agenciesEmpty',
    agenciesEmptySearch: 'settings.agenciesEmptySearch',
    agenciesEmptyOrgOnlyHint: 'settings.agenciesEmptyOrgOnlyHint',
    agenciesEmptyOrgConfigurationLink: 'settings.agenciesEmptyOrgConfigurationLink',
    agenciesEmptyOrgEmailLink: 'settings.agenciesEmptyOrgEmailLink',
    agenciesMembersLabel: 'settings.agenciesMembersLabel',
    agenciesColType: 'settings.agenciesColType',
    agenciesColAgency: 'settings.agenciesColAgency',
    agenciesColMembers: 'settings.agenciesColMembers',
    agenciesColAdministrator: 'settings.agenciesColAdministrator',
    agenciesAdministratorLabel: 'settings.agenciesAdministratorLabel',
    agenciesAdministratorUnassigned: 'settings.agenciesAdministratorUnassigned',
    agenciesInfoPopoverTitle: 'settings.agenciesInfoPopoverTitle',
    agenciesInfoPopoverBody: 'settings.agenciesInfoPopoverBody',
    agenciesInfoHelpLink: 'settings.agenciesInfoHelpLink',
    agenciesViewGrid: 'settings.agenciesViewGrid',
    agenciesViewList: 'settings.agenciesViewList',
    agenciesAttachedTo: 'settings.agenciesAttachedTo',
    agenciesAttachedToUnknown: 'settings.agenciesAttachedToUnknown',
    agenciesChildBadge: 'settings.agenciesChildBadge',
    agenciesChildTooltip: 'settings.agenciesChildTooltip',
    agenciesTypeService: 'settings.agenciesTypeService',
    agenciesTypeTeam: 'settings.agenciesTypeTeam',
    agenciesTypeOffice: 'settings.agenciesTypeOffice',
    agenciesTypeOrganization: 'settings.agenciesTypeOrganization',
    agenciesTypeUndefined: 'settings.agenciesTypeUndefined',
    agencyDetailBackToList: 'settings.agencyDetailBackToList',
    agencyDetailSubtitleLead: 'settings.agencyDetailSubtitleLead',
    agencyDetailTabGeneral: 'settings.agencyDetailTabGeneral',
    agencyDetailTabMembers: 'settings.agencyDetailTabMembers',
    agencyDetailTabClients: 'settings.agencyDetailTabClients',
    agencyDetailTabTableAutomations: 'settings.agencyDetailTabTableAutomations',
    agencyDetailTabConfiguration: 'settings.agencyDetailTabConfiguration',
    agencyDetailTabEmail: 'settings.agencyDetailTabEmail',
    agencyDetailTabApi: 'settings.agencyDetailTabApi',
    agencyDetailTabMetrics: 'settings.agencyDetailTabMetrics',
    agencyDetailGeneralIntro: 'settings.agencyDetailGeneralIntro',
    agencyDetailLegalNameLabel: 'settings.agencyDetailLegalNameLabel',
    agencyDetailLegalNameRequired: 'settings.agencyDetailLegalNameRequired',
    agencyDetailSaveSuccess: 'settings.agencyDetailSaveSuccess',
    agencyDetailSettingsKeysInfo: 'settings.agencyDetailSettingsKeysInfo',
    agencyDetailConfigSectionTitle: 'settings.agencyDetailConfigSectionTitle',
    agencyDetailConfigSectionSubtitle:
      'settings.agencyDetailConfigSectionSubtitle',
    agencyDetailMembersCountLine: 'settings.agencyDetailMembersCountLine',
    agencyDetailRoleOwnerBadge: 'settings.agencyDetailRoleOwnerBadge',
    membersPageTitle: 'settings.membersPageTitle',
    membersPageSubtitle: 'settings.membersPageSubtitle',
    membersInvite: 'settings.membersInvite',
    membersSearchPlaceholder: 'settings.membersSearchPlaceholder',
    membersLoading: 'settings.membersLoading',
    membersEmpty: 'settings.membersEmpty',
    membersColUser: 'settings.membersColUser',
    membersColEmail: 'settings.membersColEmail',
    membersColRole: 'settings.membersColRole',
    membersYouBadge: 'settings.membersYouBadge',
    membersInfoPopoverTitle: 'settings.membersInfoPopoverTitle',
    membersInfoPopoverBody: 'settings.membersInfoPopoverBody',
    membersSeatSummary: 'settings.membersSeatSummary',
    membersSeatLimitHint: 'settings.membersSeatLimitHint',
    membersSeatPlanScale: 'settings.membersSeatPlanScale',
    membersRequestSeats: 'settings.membersRequestSeats',
    membersFilterAllRoles: 'settings.membersFilterAllRoles',
    membersFilterAllStatuses: 'settings.membersFilterAllStatuses',
    membersFilterStatusActive: 'settings.membersFilterStatusActive',
    membersFilterStatusInactive: 'settings.membersFilterStatusInactive',
    membersColAgencies: 'settings.membersColAgencies',
    membersColAffiliation: 'settings.membersColAffiliation',
    membersAffiliationOrganization: 'settings.membersAffiliationOrganization',
    membersColStatus: 'settings.membersColStatus',
    membersColEnabled: 'settings.membersColEnabled',
    membersStatusActive: 'settings.membersStatusActive',
    membersStatusInactive: 'settings.membersStatusInactive',
    membersAddUser: 'settings.membersAddUser',
    membersViewList: 'settings.membersViewList',
    membersViewGrid: 'settings.membersViewGrid',
    membersAgencyNone: 'settings.membersAgencyNone',
    organizationMembersGroup: 'settings.organizationMembersGroup',
    membersMenuViewProfile: 'settings.membersMenuViewProfile',
    membersMenuEdit: 'settings.membersMenuEdit',
    membersMenuDeactivate: 'settings.membersMenuDeactivate',
    membersMenuReactivate: 'settings.membersMenuReactivate',
    membersDeactivateTitle: 'settings.membersDeactivateTitle',
    membersDeactivateBody: 'settings.membersDeactivateBody',
    membersReactivateTitle: 'settings.membersReactivateTitle',
    membersReactivateBody: 'settings.membersReactivateBody',
    membersDeactivateSuccess: 'settings.membersDeactivateSuccess',
    membersReactivateSuccess: 'settings.membersReactivateSuccess',
    membersSetActiveForbidden: 'settings.membersSetActiveForbidden',
    membersSetActiveError: 'settings.membersSetActiveError',
    membersMenuTransferAgency: 'settings.membersMenuTransferAgency',
    membersMenuManageAgencies: 'settings.membersMenuManageAgencies',
    manageAgenciesDialogTitle: 'settings.manageAgenciesDialogTitle',
    manageAgenciesDialogDescription: 'settings.manageAgenciesDialogDescription',
    manageAgenciesSearchPlaceholder: 'settings.manageAgenciesSearchPlaceholder',
    manageAgenciesSave: 'settings.manageAgenciesSave',
    manageAgenciesMinOneAgency: 'settings.manageAgenciesMinOneAgency',
    manageAgenciesSuccess: 'settings.manageAgenciesSuccess',
    manageAgenciesAlreadyMember: 'settings.manageAgenciesAlreadyMember',
    manageAgenciesNoAgencies: 'settings.manageAgenciesNoAgencies',
    manageAgenciesNoSearchResults: 'settings.manageAgenciesNoSearchResults',
    manageAgenciesErrorForbidden: 'settings.manageAgenciesErrorForbidden',
    manageAgenciesErrorInvalid: 'settings.manageAgenciesErrorInvalid',
    manageAgenciesErrorGeneric: 'settings.manageAgenciesErrorGeneric',
    memberDetailAgencyFilterAll: 'settings.memberDetailAgencyFilterAll',
    memberDetailAgencyFilterLabel: 'settings.memberDetailAgencyFilterLabel',
    membersMenuDelete: 'settings.membersMenuDelete',
    memberDetailBackToList: 'settings.memberDetailBackToList',
    memberDetailStatLastConnection: 'settings.memberDetailStatLastConnection',
    memberDetailStatMemberSince: 'settings.memberDetailStatMemberSince',
    memberDetailStatDeclarations: 'settings.memberDetailStatDeclarations',
    memberDetailNotAvailable: 'settings.memberDetailNotAvailable',
    memberDetailTabInfo: 'settings.memberDetailTabInfo',
    memberDetailTabReports: 'settings.memberDetailTabReports',
    memberDetailReportsIntro: 'settings.memberDetailReportsIntro',
    memberDetailReportsTitle: 'settings.memberDetailReportsTitle',
    memberDetailReportsSubtitle: 'settings.memberDetailReportsSubtitle',
    memberDetailReportsSeeDocuments: 'settings.memberDetailReportsSeeDocuments',
    memberDetailOverviewTitle: 'settings.memberDetailOverviewTitle',
    memberDetailOverviewSubtitle: 'settings.memberDetailOverviewSubtitle',
    memberDetailOverviewDeclarationsLabel:
      'settings.memberDetailOverviewDeclarationsLabel',
    memberDetailPeriodLast7Days: 'settings.memberDetailPeriodLast7Days',
    memberDetailPeriodLast30Days: 'settings.memberDetailPeriodLast30Days',
    memberDetailPeriodLast90Days: 'settings.memberDetailPeriodLast90Days',
    memberDetailPeriodLast12Months: 'settings.memberDetailPeriodLast12Months',
    memberDetailPeriodAll: 'settings.memberDetailPeriodAll',
    memberDetailPeriodCustom: 'settings.memberDetailPeriodCustom',
    memberDetailStatusValidated: 'settings.memberDetailStatusValidated',
    memberDetailStatusPending: 'settings.memberDetailStatusPending',
    memberDetailStatusError: 'settings.memberDetailStatusError',
    memberDetailStatusAbandoned: 'settings.memberDetailStatusAbandoned',
    memberDetailStatusUnknown: 'settings.memberDetailStatusUnknown',
    memberDetailColReference: 'settings.memberDetailColReference',
    memberDetailSectionIdentity: 'settings.memberDetailSectionIdentity',
    memberDetailSectionIdentitySubtitle:
      'settings.memberDetailSectionIdentitySubtitle',
    memberDetailSectionAttachment: 'settings.memberDetailSectionAttachment',
    memberDetailSectionAttachmentSubtitle:
      'settings.memberDetailSectionAttachmentSubtitle',
    memberDetailLabelFullName: 'settings.memberDetailLabelFullName',
    memberDetailLabelEmail: 'settings.memberDetailLabelEmail',
    memberDetailLabelPhone: 'settings.memberDetailLabelPhone',
    memberDetailLabelPosition: 'settings.memberDetailLabelPosition',
    memberDetailLabelRole: 'settings.memberDetailLabelRole',
    memberDetailLabelAgencies: 'settings.memberDetailLabelAgencies',
    memberDetailToolbarEdit: 'settings.memberDetailToolbarEdit',
    memberDetailToolbarMail: 'settings.memberDetailToolbarMail',
    membersBillingMailSubject: 'settings.membersBillingMailSubject',
    membersBillingMailBody: 'settings.membersBillingMailBody',
    roleLabelSuperadmin: 'settings.roleLabelSuperadmin',
    roleLabelAgent: 'settings.roleLabelAgent',
    roleLabelDeclarative: 'settings.roleLabelDeclarative',
    rolesPageTitle: 'settings.rolesPageTitle',
    rolesPageSubtitle: 'settings.rolesPageSubtitle',
    rolesColPermission: 'settings.rolesColPermission',
    roleLabelAdmin: 'settings.roleLabelAdmin',
    roleLabelManager: 'settings.roleLabelManager',
    roleLabelOperator: 'settings.roleLabelOperator',
    roleLabelReader: 'settings.roleLabelReader',
    roleLabelGuest: 'settings.roleLabelGuest',
    emailTemplatesPageTitle: 'settings.emailTemplatesPageTitle',
    emailTemplatesPageSubtitle: 'settings.emailTemplatesPageSubtitle',
    emailTemplatesModify: 'settings.emailTemplatesModify',
    emailTemplatesFootnote: 'settings.emailTemplatesFootnote',
    emailTplAckTitle: 'settings.emailTplAckTitle',
    emailTplAckDesc: 'settings.emailTplAckDesc',
    emailTplFinalizedTitle: 'settings.emailTplFinalizedTitle',
    emailTplFinalizedDesc: 'settings.emailTplFinalizedDesc',
    emailTplDeclErrTitle: 'settings.emailTplDeclErrTitle',
    emailTplDeclErrDesc: 'settings.emailTplDeclErrDesc',
    emailTplPipelineErrTitle: 'settings.emailTplPipelineErrTitle',
    emailTplPipelineErrDesc: 'settings.emailTplPipelineErrDesc',
    emailTplInviteTitle: 'settings.emailTplInviteTitle',
    emailTplInviteDesc: 'settings.emailTplInviteDesc',
    helpPageTitle: 'settings.helpPageTitle',
    helpPageSubtitle: 'settings.helpPageSubtitle',
    helpCardDocTitle: 'settings.helpCardDocTitle',
    helpCardDocDesc: 'settings.helpCardDocDesc',
    helpCardDocAction: 'settings.helpCardDocAction',
    helpCardVideoTitle: 'settings.helpCardVideoTitle',
    helpCardVideoDesc: 'settings.helpCardVideoDesc',
    helpCardVideoAction: 'settings.helpCardVideoAction',
    helpCardChatTitle: 'settings.helpCardChatTitle',
    helpCardChatDesc: 'settings.helpCardChatDesc',
    helpCardChatAction: 'settings.helpCardChatAction',
    helpCardMailTitle: 'settings.helpCardMailTitle',
    helpCardMailDesc: 'settings.helpCardMailDesc',
    helpCardMailAction: 'settings.helpCardMailAction',
    helpSearchPlaceholder: 'settings.helpSearchPlaceholder',
    helpHeroTitle: 'settings.helpHeroTitle',
    helpHeroSubtitle: 'settings.helpHeroSubtitle',
    helpFrequentSearches: 'settings.helpFrequentSearches',
    helpPopularTitle: 'settings.helpPopularTitle',
    helpBrowseByTheme: 'settings.helpBrowseByTheme',
    helpSearchResultsTitle: 'settings.helpSearchResultsTitle',
    helpArticlesCountLink: 'settings.helpArticlesCountLink',
    helpArticlesCountLink_other: 'settings.helpArticlesCountLink_other',
    helpSupportCta: 'settings.helpSupportCta',
    helpSupportEmail: 'settings.helpSupportEmail',
    helpSupportChat: 'settings.helpSupportChat',
    helpCategoryAll: 'settings.helpCategoryAll',
    helpCategoryDeclarationDouaniere:
      'settings.helpCategoryDeclarationDouaniere',
    helpCategoryDeclarationDouaniereDesc:
      'settings.helpCategoryDeclarationDouaniereDesc',
    helpCategoryExtractionDonnee: 'settings.helpCategoryExtractionDonnee',
    helpCategoryExtractionDonneeDesc:
      'settings.helpCategoryExtractionDonneeDesc',
    helpCategoryDocumentsDossiers: 'settings.helpCategoryDocumentsDossiers',
    helpCategoryDocumentsDossiersDesc:
      'settings.helpCategoryDocumentsDossiersDesc',
    helpCategoryClassificationDocumentaire:
      'settings.helpCategoryClassificationDocumentaire',
    helpCategoryClassificationDocumentaireDesc:
      'settings.helpCategoryClassificationDocumentaireDesc',
    helpCategoryAutomatisationMetier:
      'settings.helpCategoryAutomatisationMetier',
    helpCategoryAutomatisationMetierDesc:
      'settings.helpCategoryAutomatisationMetierDesc',
    helpCategoryIntegrations: 'settings.helpCategoryIntegrations',
    helpCategoryIntegrationsDesc: 'settings.helpCategoryIntegrationsDesc',
    helpArticlesCount: 'settings.helpArticlesCount',
    helpArticlesCount_other: 'settings.helpArticlesCount_other',
    helpArticlesEmpty: 'settings.helpArticlesEmpty',
    helpArticlesLoadError: 'settings.helpArticlesLoadError',
    helpArticleLoadError: 'settings.helpArticleLoadError',
    helpBackToList: 'settings.helpBackToList',
    helpBackToCategories: 'settings.helpBackToCategories',
    helpPopularBadge: 'settings.helpPopularBadge',
    helpFrequentSearchBadge: 'settings.helpFrequentSearchBadge',
    helpFrequentSearchBadgeAria: 'settings.helpFrequentSearchBadgeAria',
    helpReadingTime: 'settings.helpReadingTime',
    helpReadingMinutesShort: 'settings.helpReadingMinutesShort',
    helpArticleViews: 'settings.helpArticleViews',
    helpArticleFeedbackQuestion: 'settings.helpArticleFeedbackQuestion',
    helpArticleFeedbackYes: 'settings.helpArticleFeedbackYes',
    helpArticleFeedbackNo: 'settings.helpArticleFeedbackNo',
    helpArticleFeedbackContactSupport: 'settings.helpArticleFeedbackContactSupport',
    helpExpandArticle: 'settings.helpExpandArticle',
    helpCollapseArticle: 'settings.helpCollapseArticle',
    helpBugTitle: 'settings.helpBugTitle',
    helpBugDesc: 'settings.helpBugDesc',
    helpBugAction: 'settings.helpBugAction',
    permViewFolders: 'settings.permViewFolders',
    permCreateFolders: 'settings.permCreateFolders',
    permSendDeclarations: 'settings.permSendDeclarations',
    permManageUsers: 'settings.permManageUsers',
    permManageOrg: 'settings.permManageOrg',
    permManageIntegrations: 'settings.permManageIntegrations',
    subscriptionPageTitle: 'settings.subscriptionPageTitle',
    subscriptionPageSubtitle: 'settings.subscriptionPageSubtitle',
    subscriptionLoadError: 'settings.subscriptionLoadError',
    subscriptionPendingTitle: 'settings.subscriptionPendingTitle',
    subscriptionPendingBody: 'settings.subscriptionPendingBody',
    subscriptionPendingCta: 'settings.subscriptionPendingCta',
    subscriptionPendingPaymentTitle:
      'settings.subscriptionPendingPaymentTitle',
    subscriptionPendingPaymentBody:
      'settings.subscriptionPendingPaymentBody',
    subscriptionPendingPaymentCta: 'settings.subscriptionPendingPaymentCta',
    subscriptionEmptyManualTitle: 'settings.subscriptionEmptyManualTitle',
    subscriptionEmptyManualBody: 'settings.subscriptionEmptyManualBody',
    subscriptionEmptyNotConfiguredTitle:
      'settings.subscriptionEmptyNotConfiguredTitle',
    subscriptionEmptyNotConfiguredBody:
      'settings.subscriptionEmptyNotConfiguredBody',
    subscriptionCreditsBannerLowTitle:
      'settings.subscriptionCreditsBannerLowTitle',
    subscriptionCreditsBannerLowBody:
      'settings.subscriptionCreditsBannerLowBody',
    subscriptionCreditsBannerExhaustedTitle:
      'settings.subscriptionCreditsBannerExhaustedTitle',
    subscriptionCreditsBannerExhaustedBody:
      'settings.subscriptionCreditsBannerExhaustedBody',
    subscriptionCreditsBannerRecharge:
      'settings.subscriptionCreditsBannerRecharge',
    subscriptionCreditsBannerLater:
      'settings.subscriptionCreditsBannerLater',
    subscriptionRecapTitle: 'settings.subscriptionRecapTitle',
    subscriptionRecapSubtitle: 'settings.subscriptionRecapSubtitle',
    subscriptionRecapSubtitlePending:
      'settings.subscriptionRecapSubtitlePending',
    subscriptionRecapAmountMonthly: 'settings.subscriptionRecapAmountMonthly',
    subscriptionRecapAmountAnnual: 'settings.subscriptionRecapAmountAnnual',
    subscriptionRecapPlanName: 'settings.subscriptionRecapPlanName',
    subscriptionRecapAnnualSavingsBadge:
      'settings.subscriptionRecapAnnualSavingsBadge',
    subscriptionRecapAnnualSavingsAmount:
      'settings.subscriptionRecapAnnualSavingsAmount',
    subscriptionCustomPricingBadge: 'settings.subscriptionCustomPricingBadge',
    subscriptionRecapCredits: 'settings.subscriptionRecapCredits',
    subscriptionRecapCreditsUsed: 'settings.subscriptionRecapCreditsUsed',
    subscriptionRecapCreditsAvailable:
      'settings.subscriptionRecapCreditsAvailable',
    subscriptionRecapCreditsExtraPurchased:
      'settings.subscriptionRecapCreditsExtraPurchased',
    subscriptionRecapCreditsExtraGifted:
      'settings.subscriptionRecapCreditsExtraGifted',
    subscriptionRecapCreditsEnvelopeUsed:
      'settings.subscriptionRecapCreditsEnvelopeUsed',
    subscriptionRecapCreditsPending:
      'settings.subscriptionRecapCreditsPending',
    subscriptionRecapCreditsPendingHint:
      'settings.subscriptionRecapCreditsPendingHint',
    subscriptionRecapNextBilling: 'settings.subscriptionRecapNextBilling',
    subscriptionRecapNextBillingPending:
      'settings.subscriptionRecapNextBillingPending',
    subscriptionRecapNextBillingPendingHint:
      'settings.subscriptionRecapNextBillingPendingHint',
    subscriptionRecapAutoCharge: 'settings.subscriptionRecapAutoCharge',
    subscriptionCreditsTitle: 'settings.subscriptionCreditsTitle',
    subscriptionCreditsSubtitle: 'settings.subscriptionCreditsSubtitle',
    subscriptionCreditsPendingTitle:
      'settings.subscriptionCreditsPendingTitle',
    subscriptionCreditsPendingBody: 'settings.subscriptionCreditsPendingBody',
    subscriptionCreditsBuy: 'settings.subscriptionCreditsBuy',
    subscriptionCreditsConsumedLabel:
      'settings.subscriptionCreditsConsumedLabel',
    subscriptionCreditsAvailable: 'settings.subscriptionCreditsAvailable',
    subscriptionCreditsDeclarationsHint:
      'settings.subscriptionCreditsDeclarationsHint',
    subscriptionCreditsSourceSubscription:
      'settings.subscriptionCreditsSourceSubscription',
    subscriptionCreditsSourcePurchased:
      'settings.subscriptionCreditsSourcePurchased',
    subscriptionCreditsSourceGifted:
      'settings.subscriptionCreditsSourceGifted',
    subscriptionCreditsEnvelopeLabel:
      'settings.subscriptionCreditsEnvelopeLabel',
    subscriptionCreditsEnvelopeConsumed:
      'settings.subscriptionCreditsEnvelopeConsumed',
    subscriptionCreditsThresholdLow:
      'settings.subscriptionCreditsThresholdLow',
    subscriptionCreditsThresholdExhausted:
      'settings.subscriptionCreditsThresholdExhausted',
    subscriptionCreditsRemainingHint:
      'settings.subscriptionCreditsRemainingHint',
    subscriptionCreditsRateDeclaration:
      'settings.subscriptionCreditsRateDeclaration',
    subscriptionCreditsRateArticle: 'settings.subscriptionCreditsRateArticle',
    subscriptionCreditsRateRollover:
      'settings.subscriptionCreditsRateRollover',
    subscriptionCreditsRateCredits: 'settings.subscriptionCreditsRateCredits',
    subscriptionCreditsRolloverNone:
      'settings.subscriptionCreditsRolloverNone',
    subscriptionCreditsRolloverMonths:
      'settings.subscriptionCreditsRolloverMonths',
    subscriptionCycleTitle: 'settings.subscriptionCycleTitle',
    subscriptionCycleSubtitle: 'settings.subscriptionCycleSubtitle',
    subscriptionCycleMonthly: 'settings.subscriptionCycleMonthly',
    subscriptionCycleMonthlyLine1: 'settings.subscriptionCycleMonthlyLine1',
    subscriptionCycleMonthlyLine2: 'settings.subscriptionCycleMonthlyLine2',
    subscriptionCycleAnnual: 'settings.subscriptionCycleAnnual',
    subscriptionCycleAnnualBadge: 'settings.subscriptionCycleAnnualBadge',
    subscriptionCycleAnnualLine1: 'settings.subscriptionCycleAnnualLine1',
    subscriptionCycleAnnualLine2: 'settings.subscriptionCycleAnnualLine2',
    subscriptionCycleEffectiveHint: 'settings.subscriptionCycleEffectiveHint',
    subscriptionPlansTitle: 'settings.subscriptionPlansTitle',
    subscriptionPlansSubtitle: 'settings.subscriptionPlansSubtitle',
    subscriptionPlansSubtitlePending:
      'settings.subscriptionPlansSubtitlePending',
    subscriptionPlansCompare: 'settings.subscriptionPlansCompare',
    subscriptionPlanPerMonth: 'settings.subscriptionPlanPerMonth',
    subscriptionPlanPerYear: 'settings.subscriptionPlanPerYear',
    subscriptionPlanAnnualEquivalent:
      'settings.subscriptionPlanAnnualEquivalent',
    subscriptionPlanAnnualSavings: 'settings.subscriptionPlanAnnualSavings',
    subscriptionPlanEnvelopeBadge: 'settings.subscriptionPlanEnvelopeBadge',
    subscriptionPlanCoverage: 'settings.subscriptionPlanCoverage',
    subscriptionPlanImportExport: 'settings.subscriptionPlanImportExport',
    subscriptionPlanCoverageDeclarations:
      'settings.subscriptionPlanCoverageDeclarations',
    subscriptionPlanCoverageOr: 'settings.subscriptionPlanCoverageOr',
    subscriptionPlanCoverageArticles: 'settings.subscriptionPlanCoverageArticles',
    subscriptionPlanRateDeclaration: 'settings.subscriptionPlanRateDeclaration',
    subscriptionPlanRateArticle: 'settings.subscriptionPlanRateArticle',
    subscriptionPlanRateLine: 'settings.subscriptionPlanRateLine',
    subscriptionPlanExtraCredit: 'settings.subscriptionPlanExtraCredit',
    subscriptionPlanMinGrowth: 'settings.subscriptionPlanMinGrowth',
    subscriptionPlanMinEnterprise: 'settings.subscriptionPlanMinEnterprise',
    subscriptionPlanSetupFee: 'settings.subscriptionPlanSetupFee',
    subscriptionPlanCurrentBadge: 'settings.subscriptionPlanCurrentBadge',
    subscriptionPlanRecommendedBadge:
      'settings.subscriptionPlanRecommendedBadge',
    subscriptionPlanSelectedBadge: 'settings.subscriptionPlanSelectedBadge',
    subscriptionPlanCurrentCta: 'settings.subscriptionPlanCurrentCta',
    subscriptionPlanChooseCta: 'settings.subscriptionPlanChooseCta',
    subscriptionPlanActivateCta: 'settings.subscriptionPlanActivateCta',
    subscriptionPlanContactCta: 'settings.subscriptionPlanContactCta',
    subscriptionPlanFeatureStarterUsers:
      'settings.subscriptionPlanFeatureStarterUsers',
    subscriptionPlanFeatureStarterEmail:
      'settings.subscriptionPlanFeatureStarterEmail',
    subscriptionPlanFeatureStarterOnboarding:
      'settings.subscriptionPlanFeatureStarterOnboarding',
    subscriptionPlanFeatureStarterArchive:
      'settings.subscriptionPlanFeatureStarterArchive',
    subscriptionPlanFeatureStarterCsv:
      'settings.subscriptionPlanFeatureStarterCsv',
    subscriptionPlanFeatureStarterNoDashboard:
      'settings.subscriptionPlanFeatureStarterNoDashboard',
    subscriptionPlanFeatureStarterNoSla:
      'settings.subscriptionPlanFeatureStarterNoSla',
    subscriptionPlanFeatureStarterNoRollover:
      'settings.subscriptionPlanFeatureStarterNoRollover',
    subscriptionPlanFeatureGrowthIntro:
      'settings.subscriptionPlanFeatureGrowthIntro',
    subscriptionPlanFeatureGrowthUsers:
      'settings.subscriptionPlanFeatureGrowthUsers',
    subscriptionPlanFeatureGrowthDashboard:
      'settings.subscriptionPlanFeatureGrowthDashboard',
    subscriptionPlanFeatureGrowthSla:
      'settings.subscriptionPlanFeatureGrowthSla',
    subscriptionPlanFeatureGrowthSupport:
      'settings.subscriptionPlanFeatureGrowthSupport',
    subscriptionPlanFeatureGrowthOnboarding:
      'settings.subscriptionPlanFeatureGrowthOnboarding',
    subscriptionPlanFeatureGrowthArchive:
      'settings.subscriptionPlanFeatureGrowthArchive',
    subscriptionPlanFeatureGrowthConnectors:
      'settings.subscriptionPlanFeatureGrowthConnectors',
    subscriptionPlanFeatureGrowthApi:
      'settings.subscriptionPlanFeatureGrowthApi',
    subscriptionPlanFeatureGrowthEdi:
      'settings.subscriptionPlanFeatureGrowthEdi',
    subscriptionPlanFeatureGrowthRollover:
      'settings.subscriptionPlanFeatureGrowthRollover',
    subscriptionPlanFeatureEnterpriseIntro:
      'settings.subscriptionPlanFeatureEnterpriseIntro',
    subscriptionPlanFeatureEnterpriseDashboard:
      'settings.subscriptionPlanFeatureEnterpriseDashboard',
    subscriptionPlanFeatureEnterpriseSla:
      'settings.subscriptionPlanFeatureEnterpriseSla',
    subscriptionPlanFeatureEnterpriseAm:
      'settings.subscriptionPlanFeatureEnterpriseAm',
    subscriptionPlanFeatureEnterpriseOnboarding:
      'settings.subscriptionPlanFeatureEnterpriseOnboarding',
    subscriptionPlanFeatureEnterpriseSso:
      'settings.subscriptionPlanFeatureEnterpriseSso',
    subscriptionPlanFeatureEnterpriseCompliance:
      'settings.subscriptionPlanFeatureEnterpriseCompliance',
    subscriptionPlanFeatureEnterpriseRouting:
      'settings.subscriptionPlanFeatureEnterpriseRouting',
    subscriptionPlanFeatureEnterpriseWorkflows:
      'settings.subscriptionPlanFeatureEnterpriseWorkflows',
    subscriptionPlanFeatureEnterpriseRollover:
      'settings.subscriptionPlanFeatureEnterpriseRollover',
    subscriptionBuyCreditsTitle: 'settings.subscriptionBuyCreditsTitle',
    subscriptionBuyCreditsSubtitle: 'settings.subscriptionBuyCreditsSubtitle',
    subscriptionBuyCreditsPackLabel: 'settings.subscriptionBuyCreditsPackLabel',
    subscriptionBuyCreditsPackDecls:
      'settings.subscriptionBuyCreditsPackDecls',
    subscriptionBuyCreditsCustomLabel:
      'settings.subscriptionBuyCreditsCustomLabel',
    subscriptionBuyCreditsCustomPlaceholder:
      'settings.subscriptionBuyCreditsCustomPlaceholder',
    subscriptionBuyCreditsPreview: 'settings.subscriptionBuyCreditsPreview',
    subscriptionBuyCreditsCancel: 'settings.subscriptionBuyCreditsCancel',
    subscriptionBuyCreditsConfirm: 'settings.subscriptionBuyCreditsConfirm',
    subscriptionToastCycleUpdated: 'settings.subscriptionToastCycleUpdated',
    subscriptionToastPlanUpdated: 'settings.subscriptionToastPlanUpdated',
    subscriptionToastCreditsPurchased:
      'settings.subscriptionToastCreditsPurchased',
    subscriptionToastActivated: 'settings.subscriptionToastActivated',
    subscriptionErrorGeneric: 'settings.subscriptionErrorGeneric',
    subscriptionErrorContactRequired:
      'settings.subscriptionErrorContactRequired',
    subscriptionErrorActivationRequired:
      'settings.subscriptionErrorActivationRequired',
    subscriptionErrorPaymentMethodRequired:
      'settings.subscriptionErrorPaymentMethodRequired',
    subscriptionContactMailSubject: 'settings.subscriptionContactMailSubject',
    billingPageTitle: 'settings.billingPageTitle',
    billingPageSubtitle: 'settings.billingPageSubtitle',
    billingPageSubtitleAddPayment: 'settings.billingPageSubtitleAddPayment',
    billingPageComingSoon: 'settings.billingPageComingSoon',
    billingLoadError: 'settings.billingLoadError',
    billingAddPaymentTitle: 'settings.billingAddPaymentTitle',
    billingAddPaymentBody: 'settings.billingAddPaymentBody',
    billingAddPaymentPlaceholder: 'settings.billingAddPaymentPlaceholder',
    billingAddPaymentCancel: 'settings.billingAddPaymentCancel',
    billingAddPaymentDone: 'settings.billingAddPaymentDone',
    billingAddPaymentBannerTitle: 'settings.billingAddPaymentBannerTitle',
    billingAddPaymentBannerBody: 'settings.billingAddPaymentBannerBody',
    billingPaymentMethodsTitle: 'settings.billingPaymentMethodsTitle',
    billingPaymentMethodsSubtitle: 'settings.billingPaymentMethodsSubtitle',
    billingInvoicesTitle: 'settings.billingInvoicesTitle',
    billingInvoicesSubtitle: 'settings.billingInvoicesSubtitle',
    billingEmptyManualTitle: 'settings.billingEmptyManualTitle',
    billingEmptyManualBody: 'settings.billingEmptyManualBody',
    billingEmptyNotConfiguredTitle: 'settings.billingEmptyNotConfiguredTitle',
    billingEmptyNotConfiguredBody: 'settings.billingEmptyNotConfiguredBody',
    billingEmptyGoSubscription: 'settings.billingEmptyGoSubscription',
    billingTokenDisabledTitle: 'settings.billingTokenDisabledTitle',
    billingTokenErrorTitle: 'settings.billingTokenErrorTitle',
    billingTokenErrorBody: 'settings.billingTokenErrorBody',
    billingTokenRetry: 'settings.billingTokenRetry',
    billingToastPaymentCreated: 'settings.billingToastPaymentCreated',
    billingToastPaymentDeleted: 'settings.billingToastPaymentDeleted',
    billingToastPaymentDefault: 'settings.billingToastPaymentDefault',
    billingToastEmbedError: 'settings.billingToastEmbedError',
    billingAddCardCta: 'settings.billingAddCardCta',
    billingAddCardTitle: 'settings.billingAddCardTitle',
    billingAddCardBody: 'settings.billingAddCardBody',
    billingAddCardError: 'settings.billingAddCardError',
    billingAddCardSubmit: 'settings.billingAddCardSubmit',
    billingAddCardConfirmError: 'settings.billingAddCardConfirmError',
    billingCardPrimaryBadge: 'settings.billingCardPrimaryBadge',
    billingCardExpiry: 'settings.billingCardExpiry',
    billingCardExpiryWithHolder: 'settings.billingCardExpiryWithHolder',
    billingCardSetDefault: 'settings.billingCardSetDefault',
    billingCardDelete: 'settings.billingCardDelete',
    billingDeleteCardTitle: 'settings.billingDeleteCardTitle',
    billingDeleteCardBody: 'settings.billingDeleteCardBody',
    billingDeleteCardConfirm: 'settings.billingDeleteCardConfirm',
    billingPaymentMethodsLoadError: 'settings.billingPaymentMethodsLoadError',
    billingPaymentMethodsEmptyTitle: 'settings.billingPaymentMethodsEmptyTitle',
    billingPaymentMethodsEmptyBody: 'settings.billingPaymentMethodsEmptyBody',
    billingInvoicesLoadError: 'settings.billingInvoicesLoadError',
    billingInvoicesEmpty: 'settings.billingInvoicesEmpty',
    billingInvoiceColNumber: 'settings.billingInvoiceColNumber',
    billingInvoiceColDate: 'settings.billingInvoiceColDate',
    billingInvoiceColPeriod: 'settings.billingInvoiceColPeriod',
    billingInvoiceColAmount: 'settings.billingInvoiceColAmount',
    billingInvoiceColStatus: 'settings.billingInvoiceColStatus',
    billingInvoiceColAction: 'settings.billingInvoiceColAction',
    billingInvoiceStatusPaid: 'settings.billingInvoiceStatusPaid',
    billingInvoiceStatusPending: 'settings.billingInvoiceStatusPending',
    billingInvoiceStatusFailed: 'settings.billingInvoiceStatusFailed',
    billingInvoiceDownload: 'settings.billingInvoiceDownload',
    billingInvoiceDownloadSuccess: 'settings.billingInvoiceDownloadSuccess',
    billingInvoiceDownloadError: 'settings.billingInvoiceDownloadError',
    billingErrorGeneric: 'settings.billingErrorGeneric',
    billingErrorLastCardActive: 'settings.billingErrorLastCardActive',
    authzRolesSubtitle: 'settings.authzRolesSubtitle',
    authzNabuRolesTitle: 'settings.authzNabuRolesTitle',
    authzCustomRolesTitle: 'settings.authzCustomRolesTitle',
    authzCreateRole: 'settings.authzCreateRole',
    authzCreateRoleTitle: 'settings.authzCreateRoleTitle',
    authzCreateRoleHint: 'settings.authzCreateRoleHint',
    authzCreateRoleName: 'settings.authzCreateRoleName',
    authzCreateRoleBase: 'settings.authzCreateRoleBase',
    authzRoleOriginNabu: 'settings.authzRoleOriginNabu',
    authzMembersCount: 'settings.authzMembersCount',
    authzMembersCountOne: 'settings.authzMembersCountOne',
    authzRoleNotFound: 'settings.authzRoleNotFound',
    authzRoleName: 'settings.authzRoleName',
    authzRoleReadOnlyNotice: 'settings.authzRoleReadOnlyNotice',
    authzImpactNone: 'settings.authzImpactNone',
    authzSaveRole: 'settings.authzSaveRole',
    authzDiscardChanges: 'settings.authzDiscardChanges',
    authzDeleteRole: 'settings.authzDeleteRole',
    authzDeleteRoleBlocked: 'settings.authzDeleteRoleBlocked',
    authzDeleteRoleConfirm: 'settings.authzDeleteRoleConfirm',
    authzRightMissing: 'settings.authzRightMissing',
    authzRightAskPeople: 'settings.authzRightAskPeople',
    authzRightAskAdmin: 'settings.authzRightAskAdmin',
    authzWhyMissing: 'settings.authzWhyMissing',
    authzWhyNotGranted: 'settings.authzWhyNotGranted',
    authzWhyAccessesHere: 'settings.authzWhyAccessesHere',
    authzWhyAccessInherited: 'settings.authzWhyAccessInherited',
    authzWhyNoAccessHere: 'settings.authzWhyNoAccessHere',
    authzWhySmallestRole: 'settings.authzWhySmallestRole',
    authzChangesPeople: 'settings.authzChangesPeople',
    authzEffectGains: 'settings.authzEffectGains',
    authzEffectLoses: 'settings.authzEffectLoses',
    authzEffectNone: 'settings.authzEffectNone',
    authzChangeRoleTitle: 'settings.authzChangeRoleTitle',
    authzChangeRoleConfirm: 'settings.authzChangeRoleConfirm',
    memberDetailTabAccess: 'settings.memberDetailTabAccess',
    authzAccessTitle: 'settings.authzAccessTitle',
    authzAccessSubtitle: 'settings.authzAccessSubtitle',
    authzAddAccess: 'settings.authzAddAccess',
    authzNoAccess: 'settings.authzNoAccess',
    authzScopeWholeOrg: 'settings.authzScopeWholeOrg',
    authzScopeWithDescendants: 'settings.authzScopeWithDescendants',
    authzScopeOnly: 'settings.authzScopeOnly',
    authzValidFrom: 'settings.authzValidFrom',
    authzValidUntil: 'settings.authzValidUntil',
    authzValidBetween: 'settings.authzValidBetween',
    authzExpired: 'settings.authzExpired',
    authzScheduled: 'settings.authzScheduled',
    authzOriginMigration: 'settings.authzOriginMigration',
    authzOriginMigrationHint: 'settings.authzOriginMigrationHint',
    authzRemoveAccess: 'settings.authzRemoveAccess',
    authzRemoveAccessConfirm: 'settings.authzRemoveAccessConfirm',
    authzRightsPreviewTitle: 'settings.authzRightsPreviewTitle',
    authzRightsPreviewOn: 'settings.authzRightsPreviewOn',
    authzStateEnabled: 'settings.authzStateEnabled',
    authzStatePartial: 'settings.authzStatePartial',
    authzStateDisabled: 'settings.authzStateDisabled',
    authzStateHidden: 'settings.authzStateHidden',
    authzStateLegend: 'settings.authzStateLegend',
    authzNoRightsHere: 'settings.authzNoRightsHere',
    authzAddAccessTitle: 'settings.authzAddAccessTitle',
    authzAddAccessRole: 'settings.authzAddAccessRole',
    authzRolesGroupNabu: 'settings.authzRolesGroupNabu',
    authzRolesGroupCustom: 'settings.authzRolesGroupCustom',
    authzAddAccessScope: 'settings.authzAddAccessScope',
    authzAddAccessScopeOrg: 'settings.authzAddAccessScopeOrg',
    authzAddAccessScopeAgencies: 'settings.authzAddAccessScopeAgencies',
    authzAddAccessIncludeDescendants: 'settings.authzAddAccessIncludeDescendants',
    authzAddAccessTemporary: 'settings.authzAddAccessTemporary',
    authzAddAccessFrom: 'settings.authzAddAccessFrom',
    authzAddAccessUntil: 'settings.authzAddAccessUntil',
    authzAddAccessDatesInvalid: 'settings.authzAddAccessDatesInvalid',
    authzAddAccessPreview: 'settings.authzAddAccessPreview',
    authzAddAccessPreviewAgencies: 'settings.authzAddAccessPreviewAgencies',
    authzAddAccessPreviewAgenciesWithDescendants: 'settings.authzAddAccessPreviewAgenciesWithDescendants',
    authzAddAccessSelectAtLeastOne: 'settings.authzAddAccessSelectAtLeastOne',
    authzAddAccessSave: 'settings.authzAddAccessSave',
    authzLegacyRoleLine: 'settings.authzLegacyRoleLine',
    authzTabCompare: 'settings.authzTabCompare',
    authzTabConfigure: 'settings.authzTabConfigure',
    authzTabAttribution: 'settings.authzTabAttribution',
    authzCopyName: 'settings.authzCopyName',
    authzCompareHint: 'settings.authzCompareHint',
    authzCompareCapacity: 'settings.authzCompareCapacity',
    authzCompareLegendNew: 'settings.authzCompareLegendNew',
    authzCompareLegendIncluded: 'settings.authzCompareLegendIncluded',
    authzCompareLegendPartial: 'settings.authzCompareLegendPartial',
    authzCompareLegendNone: 'settings.authzCompareLegendNone',
    authzCompareRemoved: 'settings.authzCompareRemoved',
    authzCompareExpand: 'settings.authzCompareExpand',
    authzCompareTotals: 'settings.authzCompareTotals',
    authzCompareTotalFull: 'settings.authzCompareTotalFull',
    authzCompareTotalPartial: 'settings.authzCompareTotalPartial',
    authzRoleKindCustom: 'settings.authzRoleKindCustom',
    authzDuplicate: 'settings.authzDuplicate',
    authzEdit: 'settings.authzEdit',
    authzCreateFromNabu: 'settings.authzCreateFromNabu',
    authzCustomRolesUsage: 'settings.authzCustomRolesUsage',
    authzCustomRolesLimitReached: 'settings.authzCustomRolesLimitReached',
    authzLoadError: 'settings.authzLoadError',
    authzToastRoleCreated: 'settings.authzToastRoleCreated',
    authzToastRoleSaved: 'settings.authzToastRoleSaved',
    authzToastRoleDeleted: 'settings.authzToastRoleDeleted',
    authzToastAccessGiven: 'settings.authzToastAccessGiven',
    authzToastAccessRemoved: 'settings.authzToastAccessRemoved',
    authzToastMemberRoleChanged: 'settings.authzToastMemberRoleChanged',
    authzErrorRoleLimit: 'settings.authzErrorRoleLimit',
    authzErrorRoleInUse: 'settings.authzErrorRoleInUse',
    authzErrorAccessAlreadyGranted: 'settings.authzErrorAccessAlreadyGranted',
    authzErrorLastAdministrator: 'settings.authzErrorLastAdministrator',
    authzErrorRoleInvalid: 'settings.authzErrorRoleInvalid',
    authzErrorForbidden: 'settings.authzErrorForbidden',
    authzErrorGeneric: 'settings.authzErrorGeneric',
    authzConfigureChipsHint: 'settings.authzConfigureChipsHint',
    authzNewRoleChip: 'settings.authzNewRoleChip',
    authzNewRoleBadge: 'settings.authzNewRoleBadge',
    authzMatrixGranted: 'settings.authzMatrixGranted',
    authzMatrixGaps: 'settings.authzMatrixGaps',
    authzMatrixRevert: 'settings.authzMatrixRevert',
    authzMatrixModule: 'settings.authzMatrixModule',
    authzMatrixRead: 'settings.authzMatrixRead',
    authzMatrixCreate: 'settings.authzMatrixCreate',
    authzMatrixUpdate: 'settings.authzMatrixUpdate',
    authzMatrixDelete: 'settings.authzMatrixDelete',
    authzMatrixAccess: 'settings.authzMatrixAccess',
    authzMatrixNotApplicable: 'settings.authzMatrixNotApplicable',
    authzMatrixDiffers: 'settings.authzMatrixDiffers',
    authzMatrixCellHint: 'settings.authzMatrixCellHint',
    authzMatrixCellOwnVersion: 'settings.authzMatrixCellOwnVersion',
    authzMatrixOwnVersions: 'settings.authzMatrixOwnVersions',
    authzCreateRoleSave: 'settings.authzCreateRoleSave',
    authzGiveCopyTitle: 'settings.authzGiveCopyTitle',
    authzGiveCopyBody: 'settings.authzGiveCopyBody',
    authzAttributionHint: 'settings.authzAttributionHint',
    authzAttributionAgencies: 'settings.authzAttributionAgencies',
    authzAttributionTitle: 'settings.authzAttributionTitle',
    authzAttributionGive: 'settings.authzAttributionGive',
    authzAttributionEmpty: 'settings.authzAttributionEmpty',
    authzAttributionDirect: 'settings.authzAttributionDirect',
    authzAttributionDirectWithDescendants: 'settings.authzAttributionDirectWithDescendants',
    authzAttributionInherited: 'settings.authzAttributionInherited',
    authzAttributionInheritedHint: 'settings.authzAttributionInheritedHint',
    authzAttributionDialogTitle: 'settings.authzAttributionDialogTitle',
    authzAttributionMember: 'settings.authzAttributionMember',
    authzAttributionNoMember: 'settings.authzAttributionNoMember',
    authzAttributionPickMember: 'settings.authzAttributionPickMember',
    authzGiveCopyCheckAll: 'settings.authzGiveCopyCheckAll',
    authzGiveCopyUncheckAll: 'settings.authzGiveCopyUncheckAll',
    authzGiveCopyCount: 'settings.authzGiveCopyCount',
    authzChangesCount: 'settings.authzChangesCount',
    authzChangesCount_other: 'settings.authzChangesCount_other',
    authzChangesTouches: 'settings.authzChangesTouches',
    authzChangesTouches_other: 'settings.authzChangesTouches_other',
    authzChangesNewRole: 'settings.authzChangesNewRole',
    authzChangesDetail: 'settings.authzChangesDetail',
    inboxesIntro: 'settings.inboxesIntro',
    inboxNew: 'settings.inboxNew',
    inboxesListTitle: 'settings.inboxesListTitle',
    inboxesActiveCount: 'settings.inboxesActiveCount',
    inboxesActiveCount_other: 'settings.inboxesActiveCount_other',
    inboxesSearch: 'settings.inboxesSearch',
    inboxesColAddress: 'settings.inboxesColAddress',
    inboxesColCreates: 'settings.inboxesColCreates',
    inboxesColAssignee: 'settings.inboxesColAssignee',
    inboxesEmptyTitle: 'settings.inboxesEmptyTitle',
    inboxesNoMatch: 'settings.inboxesNoMatch',
    inboxesEmptyHint: 'settings.inboxesEmptyHint',
    inboxCopyAddress: 'settings.inboxCopyAddress',
    inboxCopy: 'settings.inboxCopy',
    inboxActive: 'settings.inboxActive',
    inboxPaused: 'settings.inboxPaused',
    inboxToggle: 'settings.inboxToggle',
    inboxUnassigned: 'settings.inboxUnassigned',
    inboxClientFromDocuments: 'settings.inboxClientFromDocuments',
    allowedSendersTitle: 'settings.allowedSendersTitle',
    allowedSendersHint: 'settings.allowedSendersHint',
    allowedSendersPlaceholder: 'settings.allowedSendersPlaceholder',
    allowedSendersAdd: 'settings.allowedSendersAdd',
    allowedSendersInvalid: 'settings.allowedSendersInvalid',
    allowedSendersDuplicate: 'settings.allowedSendersDuplicate',
    allowedSendersAddresses: 'settings.allowedSendersAddresses',
    allowedSendersRemove: 'settings.allowedSendersRemove',
    allowedSendersDefault: 'settings.allowedSendersDefault',
    allowedSendersAgencyMembers: 'settings.allowedSendersAgencyMembers',
    allowedSendersDefaultHint: 'settings.allowedSendersDefaultHint',
    allowedSendersOnlyMembers: 'settings.allowedSendersOnlyMembers',
    allowedSendersAdded: 'settings.allowedSendersAdded',
    allowedSendersRemoved: 'settings.allowedSendersRemoved',
    allowedSendersError: 'settings.allowedSendersError',
    inboxRejectedTitle: 'settings.inboxRejectedTitle',
    inboxRejectedTo: 'settings.inboxRejectedTo',
    inboxRejectedAllow: 'settings.inboxRejectedAllow',
    inboxRejectedDismiss: 'settings.inboxRejectedDismiss',
    inboxRejectedCount: 'settings.inboxRejectedCount',
    inboxRejectedCount_other: 'settings.inboxRejectedCount_other',
    inboxRejectedPaused: 'settings.inboxRejectedPaused',
    inboxEditorNewTitle: 'settings.inboxEditorNewTitle',
    inboxEditorEditTitle: 'settings.inboxEditorEditTitle',
    inboxEditorAddress: 'settings.inboxEditorAddress',
    inboxEditorPrefixHint: 'settings.inboxEditorPrefixHint',
    inboxEditorWhatItDoes: 'settings.inboxEditorWhatItDoes',
    inboxEditorNotify: 'settings.inboxEditorNotify',
    inboxEditorNotifyHint: 'settings.inboxEditorNotifyHint',
    inboxEditorFieldType: 'settings.inboxEditorFieldType',
    inboxEditorFieldClient: 'settings.inboxEditorFieldClient',
    inboxEditorFieldClientPlaceholder: 'settings.inboxEditorFieldClientPlaceholder',
    inboxEditorFieldAssignee: 'settings.inboxEditorFieldAssignee',
    inboxEditorPreparation: 'settings.inboxEditorPreparation',
    inboxEditorPrepSmart: 'settings.inboxEditorPrepSmart',
    inboxEditorPrepClassic: 'settings.inboxEditorPrepClassic',
    inboxEditorDelete: 'settings.inboxEditorDelete',
    inboxEditorCancel: 'settings.inboxEditorCancel',
    inboxEditorCreate: 'settings.inboxEditorCreate',
    inboxEditorSave: 'settings.inboxEditorSave',
    inboxEditorClose: 'settings.inboxEditorClose',
    inboxStepMailTitle: 'settings.inboxStepMailTitle',
    inboxStepMailBody: 'settings.inboxStepMailBody',
    inboxStepFolderTitle: 'settings.inboxStepFolderTitle',
    inboxStepFolderBody: 'settings.inboxStepFolderBody',
    inboxStepPrepTitle: 'settings.inboxStepPrepTitle',
    inboxStepPrepBody: 'settings.inboxStepPrepBody',
    inboxPrepSmartPhrase: 'settings.inboxPrepSmartPhrase',
    inboxPrepClassicPhrase: 'settings.inboxPrepClassicPhrase',
    inboxStepAssignTitle: 'settings.inboxStepAssignTitle',
    inboxStepAssignBody: 'settings.inboxStepAssignBody',
    inboxStepAssignNotified: 'settings.inboxStepAssignNotified',
    inboxStepAssignNotified_other: 'settings.inboxStepAssignNotified_other',
    inboxMissingType: 'settings.inboxMissingType',
    inboxMissingFlow: 'settings.inboxMissingFlow',
    inboxMissingAssignee: 'settings.inboxMissingAssignee',
    inboxCreated: 'settings.inboxCreated',
    inboxSaved: 'settings.inboxSaved',
    inboxDeleted: 'settings.inboxDeleted',
    inboxSaveError: 'settings.inboxSaveError',
    inboxDeleteError: 'settings.inboxDeleteError',
    inboxPrefixTaken: 'settings.inboxPrefixTaken',
    inboxDeleteConfirm: 'settings.inboxDeleteConfirm',
  },
  segmentation: {
    finishSegmentationStep: 'segmentation.finishSegmentationStep',
    merge: 'segmentation.merge',
    cut: 'segmentation.cut',
    deletePage: 'segmentation.deletePage',
    keep: 'segmentation.keep',
  },
  floatinglabelform: {
    save: 'floatinglabelform.save',
    apply: 'floatinglabelform.apply',
    text: 'floatinglabelform.text',
  },
  viewer: {
    doYouWantToDeleteTheTable: 'viewer.doYouWantToDeleteTheTable',
    apply: 'viewer.apply',
    adjustTheDocument: 'viewer.adjustTheDocument',
    selectedLabel: 'viewer.selectedLabel',
    selectADocument: 'viewer.selectADocument',
    applyAModel: 'viewer.applyAModel',
    newColumn: 'viewer.newColumn',
    selectColumnTooltip: 'viewer.selectColumnTooltip',
    selectColumnTooltipExcel: 'viewer.selectColumnTooltipExcel',
    invoice: 'viewer.invoice',
  },
  classification: {
    layers: 'classification.layers',
    manualLayer: 'classification.manualLayer',
    searchClassificationType: 'classification.searchClassificationType',
    outOf: 'classification.outOf',
    validate: 'classification.validate',
    unknownDocument: 'classification.unknownDocument',
    unknownDocuments: 'classification.unknownDocuments',
    addExtractionMode: 'classification.addExtractionMode',
    ignoreDocument: 'classification.ignoreDocument',
    includeDocument: 'classification.includeDocument',
    fieldRequired: 'classification.fieldRequired',
    selectExtractionMode: 'classification.selectExtractionMode',
    onlyInvoicesAllowed: 'classification.onlyInvoicesAllowed',
    noLeadDocument: 'classification.noLeadDocument',
    someDocumentsWithoutClassification:
      'classification.someDocumentsWithoutClassification',
    hasNoExportConfiguration: 'classification.hasNoExportConfiguration',
    document: 'classification.document',
    document_other: 'classification.document_other',
    page: 'classification.page',
    page_other: 'classification.page_other',
    MT700: 'classification.MT700',
    weight_note: 'classification.weight_note',
    exchange_bill: 'classification.exchange_bill',
    origin_certif: 'classification.origin_certif',
    multimodal_doc: 'classification.multimodal_doc',
    flight_letter: 'classification.flight_letter',
    sea_waybill: 'classification.sea_waybill',
    road_document: 'classification.road_document',
    delivery_note: 'classification.delivery_note',
    insurance_policy: 'classification.insurance_policy',
    bill_of_lading: 'classification.bill_of_lading',
    single_administrative_document:
      'classification.single_administrative_document',
    commercial_invoice: 'classification.commercial_invoice',
    customs_instructions: 'classification.customs_instructions',
    packing_list: 'classification.packing_list',
    hscodes_list: 'classification.hscodes_list',
    t1: 'classification.t1',
    t2: 'classification.t2',
    t2l: 'classification.t2l',
    ata: 'classification.ata',
    bae: 'classification.bae',
    invoice_summary: 'classification.invoice_summary',
    EAD: 'classification.electronic_accompanying_document',
    electronic_accompanying_document:
      'classification.electronic_accompanying_document',
    'electronic_accompanying-document':
      'classification.electronic_accompanying_document',
    export_accompanying_document:
      'classification.electronic_accompanying_document',
    conversation: 'classification.conversation',
    terms_and_conditions: 'classification.terms_and_conditions',
    model: 'classification.model',
    setting_keys: 'classification.setting_keys',
    MT700_short: 'classification.MT700_short',
    weight_note_short: 'classification.weight_note_short',
    exchange_bill_short: 'classification.exchange_bill_short',
    origin_certif_short: 'classification.origin_certif_short',
    multimodal_doc_short: 'classification.multimodal_doc_short',
    flight_letter_short: 'classification.flight_letter_short',
    sea_waybill_short: 'classification.sea_waybill_short',
    road_document_short: 'classification.road_document_short',
    delivery_note_short: 'classification.delivery_note_short',
    insurance_policy_short: 'classification.insurance_policy_short',
    bill_of_lading_short: 'classification.bill_of_lading_short',
    single_administrative_document_short:
      'classification.single_administrative_document_short',
    commercial_invoice_short: 'classification.commercial_invoice_short',
    customs_instructions_short: 'classification.customs_instructions_short',
    packing_list_short: 'classification.packing_list_short',
    hscodes_list_short: 'classification.hscodes_list_short',
    t1_short: 'classification.t1_short',
    t2_short: 'classification.t2_short',
    t2l_short: 'classification.t2l_short',
    ata_short: 'classification.ata_short',
    bae_short: 'classification.bae_short',
    invoice_summary_short: 'classification.invoice_summary_short',
    EAD_short: 'classification.electronic_accompanying_document_short',
    electronic_accompanying_document_short:
      'classification.electronic_accompanying_document_short',
    'electronic_accompanying-document_short':
      'classification.electronic_accompanying_document_short',
    conversation_short: 'classifcation.conversation_short',
    email_short: 'classifcation.email_short',
  },
  connector: {
    connectorName: 'connector.name',
    addConnector: 'connector.add',
  },
  filter: {
    sortBy: 'sortBy',
    searchOrganization: 'searchOrganization',
    searchUser: 'searchUser',
    searchLayer: 'searchLayer',
    lastUpdateNewest: 'lastUpdateNewest',
    lastUpdateOldest: 'lastUpdateOldest',
  },
  customerFlow: {
    customer: 'customer',
    model: 'model',
    documentType: 'documentType',
    removeCustomerTitle: 'removeCustomerTitle',
    removeCustomerText: 'removeCustomerText',
    customerHasBeenDeleted: 'customerHasBeenDeleted',
    customerHasNotBeenDeleted: 'customerHasNotBeenDeleted',
    removeModelTitle: 'removeModelTitle',
    removeModelText: 'removeModelText',
    modelHasBeenDeleted: 'modelHasBeenDeleted',
    modelHasNotBeenDeleted: 'modelHasNotBeenDeleted',
    settingKeyDeleted: 'settingKeyDeleted',
    actionFailed: 'actionFailed',
    settingKeyCreated: 'settingKeyCreated',
    settingKeyUpdated: 'settingKeyUpdated',
    sender: 'sender',
    modelType: 'modelType',
    informations: 'informations',
    documentModels: 'documentModels',
    nameOfModel: 'nameOfModel',
    issuesSettingsOptions: 'issuesSettingsOptions',
    noModelAvailable: 'noModelAvailable',
    unknownUser: 'unknownUser',
    areYouSureYouWantToDeleteThisModel: 'areYouSureYouWantToDeleteThisModel',
    deleteThisModel: 'deleteThisModel',
    deleteModelSuccess: 'deleteModelSuccess',
    deleteModelFailed: 'deleteModelFailed',
    duplicateThisModel: 'duplicateThisModel',
    duplicateModelTitle: 'duplicateModelTitle',
    duplicateModelText: 'duplicateModelText',
    duplicateModelNamePlaceholder: 'duplicateModelNamePlaceholder',
    duplicateModelNameTooShort: 'duplicateModelNameTooShort',
    duplicateModelConfirm: 'duplicateModelConfirm',
    duplicateModelSuccess: 'duplicateModelSuccess',
    duplicateModelFailed: 'duplicateModelFailed',
    bulkSelectedCount: 'bulkSelectedCount',
    bulkSelectedCount_other: 'bulkSelectedCount_other',
    bulkDuplicate: 'bulkDuplicate',
    bulkDelete: 'bulkDelete',
    modelsDuplicated: 'modelsDuplicated',
    modelsDuplicated_other: 'modelsDuplicated_other',
    modelsNotDuplicated: 'modelsNotDuplicated',
    modelsNotDuplicated_other: 'modelsNotDuplicated_other',
    customersPageTitle: 'customersPageTitle',
    customersPageSubtitle: 'customersPageSubtitle',
    customersInfoPopoverTitle: 'customersInfoPopoverTitle',
    customersInfoPopoverBody: 'customersInfoPopoverBody',
    customersInfoHelpLink: 'customersInfoHelpLink',
    customersSearchPlaceholder: 'customersSearchPlaceholder',
    allAgencies: 'allAgencies',
    customersCount: 'customersCount',
    addCustomer: 'addCustomer',
    addModel: 'addModel',
    addModelAgency: 'addModelAgency',
    addModelDeclarationType: 'addModelDeclarationType',
    addModelSubtitle: 'addModelSubtitle',
    addModelIdentification: 'addModelIdentification',
    addModelName: 'addModelName',
    addModelNamePlaceholder: 'addModelNamePlaceholder',
    addModelDeclarationTypeHint: 'addModelDeclarationTypeHint',
    addModelDeclarationTypePlaceholder: 'addModelDeclarationTypePlaceholder',
    addModelNoDeclarationType: 'addModelNoDeclarationType',
    addModelNoDeclarationTypePlaceholder: 'addModelNoDeclarationTypePlaceholder',
    addModelFields: 'addModelFields',
    addModelFieldsCount: 'addModelFieldsCount',
    addModelChooseTypeFirst: 'addModelChooseTypeFirst',
    addModelSchemaError: 'addModelSchemaError',
    addModelAddField: 'addModelAddField',
    addModelNoFieldFound: 'addModelNoFieldFound',
    addModelEmptyTitle: 'addModelEmptyTitle',
    addModelEmptyBody: 'addModelEmptyBody',
    addModelRemoveField: 'addModelRemoveField',
    addModelRemoveRow: 'addModelRemoveRow',
    addModelAddRow: 'addModelAddRow',
    addModelFieldRequired: 'addModelFieldRequired',
    addModelMissingName: 'addModelMissingName',
    addModelMissingDeclarationType: 'addModelMissingDeclarationType',
    addModelMissingField: 'addModelMissingField',
    addModelEmptyFields: 'addModelEmptyFields',
    addModelEmptyFields_other: 'addModelEmptyFields_other',
    addModelSubmit: 'addModelSubmit',
    columnName: 'columnName',
    columnAddress: 'columnAddress',
    columnContact: 'columnContact',
    columnAgency: 'columnAgency',
    columnCreatedAt: 'columnCreatedAt',
    viewCustomerDetail: 'viewCustomerDetail',
    agencyRequired: 'agencyRequired',
    customerNameRequired: 'customerNameRequired',
    backToCustomers: 'backToCustomers',
    backToModels: 'backToModels',
    flowDetailDeclarationLabel: 'flowDetailDeclarationLabel',
    flowDetailConfigSectionTitle: 'flowDetailConfigSectionTitle',
    flowDetailConfigSectionSubtitle: 'flowDetailConfigSectionSubtitle',
    tabGeneral: 'tabGeneral',
    tabConfiguration: 'tabConfiguration',
    tabReferentials: 'tabReferentials',
    noReferentialsForClient: 'noReferentialsForClient',
    customerDetailAgencyLabel: 'customerDetailAgencyLabel',
    customerDetailNoAgency: 'customerDetailNoAgency',
    customerDetailConfigInfoAlert: 'customerDetailConfigInfoAlert',
    customerDetailConfigSectionTitle: 'customerDetailConfigSectionTitle',
    customerDetailConfigSectionSubtitle: 'customerDetailConfigSectionSubtitle',
    customerDetailConfigInheritanceTitle:
      'customerDetailConfigInheritanceTitle',
    customerDetailConfigInheritanceDescription:
      'customerDetailConfigInheritanceDescription',
    configSourceClient: 'configSourceClient',
    configSourceAgency: 'configSourceAgency',
    configSourceOrganization: 'configSourceOrganization',
  },
  referentials: {
    pageTitle: 'referentials.pageTitle',
    pageSubtitle: 'referentials.pageSubtitle',
    detailPageTitle: 'referentials.detailPageTitle',
    searchPlaceholder: 'referentials.searchPlaceholder',
    allClients: 'referentials.allClients',
    independentOnly: 'referentials.independentOnly',
    allStatuses: 'referentials.allStatuses',
    activeOnly: 'referentials.activeOnly',
    inactiveOnly: 'referentials.inactiveOnly',
    resultsCount: 'referentials.resultsCount',
    resultsCount_other: 'referentials.resultsCount_other',
    newReferential: 'referentials.newReferential',
    createModalTitle: 'referentials.createModalTitle',
    createModalDescription: 'referentials.createModalDescription',
    fieldNameLabel: 'referentials.fieldNameLabel',
    fieldNamePlaceholder: 'referentials.fieldNamePlaceholder',
    fieldDescriptionPlaceholder: 'referentials.fieldDescriptionPlaceholder',
    fieldDataFileLabel: 'referentials.fieldDataFileLabel',
    uploadZoneTitle: 'referentials.uploadZoneTitle',
    uploadZoneFormats: 'referentials.uploadZoneFormats',
    fieldClientLabel: 'referentials.fieldClientLabel',
    clientIndependentOption: 'referentials.clientIndependentOption',
    fieldAgencyLabel: 'referentials.fieldAgencyLabel',
    fieldAgencyTooltip: 'referentials.fieldAgencyTooltip',
    fieldConfigurationLabel: 'referentials.fieldConfigurationLabel',
    fieldConfigurationTooltip: 'referentials.fieldConfigurationTooltip',
    fieldDataFileTooltip: 'referentials.fieldDataFileTooltip',
    fieldClientTooltip: 'referentials.fieldClientTooltip',
    createReferentialButton: 'referentials.createReferentialButton',
    createEmptyBaseLink: 'referentials.createEmptyBaseLink',
    emptyBaseSelected: 'referentials.emptyBaseSelected',
    fileTooLarge: 'referentials.fileTooLarge',
    invalidFileType: 'referentials.invalidFileType',
    columnReferential: 'referentials.columnReferential',
    columnDescription: 'referentials.columnDescription',
    columnClient: 'referentials.columnClient',
    columnRows: 'referentials.columnRows',
    columnAutomations: 'referentials.columnAutomations',
    columnUpdatedAt: 'referentials.columnUpdatedAt',
    attachedToClient: 'referentials.attachedToClient',
    independent: 'referentials.independent',
    noReferentialsFound: 'referentials.noReferentialsFound',
    referentialCreated: 'referentials.referentialCreated',
    errorCreatingReferential: 'referentials.errorCreatingReferential',
    importFile: 'referentials.importFile',
    emptyBase: 'referentials.emptyBase',
    nameRequired: 'referentials.nameRequired',
    configurationRequired: 'referentials.configurationRequired',
    agencyRequired: 'referentials.agencyRequired',
    importOrEmptyRequired: 'referentials.importOrEmptyRequired',
    automationsTooltip: 'referentials.automationsTooltip',
    automationsTooltipCondition: 'referentials.automationsTooltipCondition',
    automationsTooltipAction: 'referentials.automationsTooltipAction',
    columnsTooltipTitle: 'referentials.columnsTooltipTitle',
    automationsTooltipTitle: 'referentials.automationsTooltipTitle',
    automationReplacesLabel: 'referentials.automationReplacesLabel',
    backToList: 'referentials.backToList',
    detailComingSoon: 'referentials.detailComingSoon',
    conditionsCount: 'referentials.conditionsCount',
    actionsCount: 'referentials.actionsCount',
    rowsUnknown: 'referentials.rowsUnknown',
    rowsLoaded: 'referentials.rowsLoaded',
    openReferential: 'referentials.openReferential',
    deleteReferential: 'referentials.deleteReferential',
    deleteReferentialConfirm: 'referentials.deleteReferentialConfirm',
    referentialDeleted: 'referentials.referentialDeleted',
    errorDeletingReferential: 'referentials.errorDeletingReferential',
    backToAllReferentials: 'referentials.backToAllReferentials',
    refresh: 'referentials.refresh',
    exportXlsx: 'referentials.exportXlsx',
    rowsCount: 'referentials.rowsCount',
    columnsCount: 'referentials.columnsCount',
    lastUpdatedLabel: 'referentials.lastUpdatedLabel',
    editName: 'referentials.editName',
    editDescription: 'referentials.editDescription',
    addDescription: 'referentials.addDescription',
    searchRowsPlaceholder: 'referentials.searchRowsPlaceholder',
    cellsFilledPercent: 'referentials.cellsFilledPercent',
    emptyCell: 'referentials.emptyCell',
    emptyGridMessage: 'referentials.emptyGridMessage',
    noAutomationYet: 'referentials.noAutomationYet',
    toggleActive: 'referentials.toggleActive',
    toggleAutomationAvailable: 'referentials.toggleAutomationAvailable',
    referentialUpdated: 'referentials.referentialUpdated',
    errorUpdatingReferential: 'referentials.errorUpdatingReferential',
    errorExportingReferential: 'referentials.errorExportingReferential',
    addRow: 'referentials.addRow',
    gridFooterHint: 'referentials.gridFooterHint',
    rowActions: 'referentials.rowActions',
    selectedRowsCount: 'referentials.selectedRowsCount',
    duplicateRow: 'referentials.duplicateRow',
    insertRowBelow: 'referentials.insertRowBelow',
    insertRowAbove: 'referentials.insertRowAbove',
    deleteRow: 'referentials.deleteRow',
    clearRowSelection: 'referentials.clearRowSelection',
    gridSaving: 'referentials.gridSaving',
    gridSaved: 'referentials.gridSaved',
    gridSaveError: 'referentials.gridSaveError',
    gridMissingTitle: 'referentials.gridMissingTitle',
    gridMissingDescription: 'referentials.gridMissingDescription',
    columnLinkSaved: 'referentials.columnLinkSaved',
    columnLinkSaveError: 'referentials.columnLinkSaveError',
    columnNameLabel: 'referentials.columnNameLabel',
    columnLinkLabel: 'referentials.columnLinkLabel',
    columnLinkPlaceholder: 'referentials.columnLinkPlaceholder',
    columnLinkNoResults: 'referentials.columnLinkNoResults',
    columnLinkHelper: 'referentials.columnLinkHelper',
    removeColumn: 'referentials.removeColumn',
    addColumn: 'referentials.addColumn',
    addCardinalColumn: 'referentials.addCardinalColumn',
    addCustomColumn: 'referentials.addCustomColumn',
    customColumnOption: 'referentials.customColumnOption',
    allCardinalColumnsUsed: 'referentials.allCardinalColumnsUsed',
    cardinalColumnBadge: 'referentials.cardinalColumnBadge',
    untitledColumn: 'referentials.untitledColumn',
    automationConditionsTitle: 'referentials.automationConditionsTitle',
    automationActionsTitle: 'referentials.automationActionsTitle',
    automationAddCondition: 'referentials.automationAddCondition',
    automationAddAction: 'referentials.automationAddAction',
    automationConditionsHelper: 'referentials.automationConditionsHelper',
    automationDeclarationColumnPlaceholder:
      'referentials.automationDeclarationColumnPlaceholder',
    automationReferentialColumnPlaceholder:
      'referentials.automationReferentialColumnPlaceholder',
    automationRelationPlaceholder: 'referentials.automationRelationPlaceholder',
    automationRelationEq: 'referentials.automationRelationEq',
    automationRelationLt: 'referentials.automationRelationLt',
    automationRelationGt: 'referentials.automationRelationGt',
    automationRelationIncludes: 'referentials.automationRelationIncludes',
    automationActionReplace: 'referentials.automationActionReplace',
    automationActionFillIfEmpty: 'referentials.automationActionFillIfEmpty',
    automationRemoveCondition: 'referentials.automationRemoveCondition',
    automationRemoveAction: 'referentials.automationRemoveAction',
    automationSave: 'referentials.automationSave',
    automationSaved: 'referentials.automationSaved',
    automationSaveError: 'referentials.automationSaveError',
    deleteAutomation: 'referentials.deleteAutomation',
    deleteAutomationConfirm: 'referentials.deleteAutomationConfirm',
    automationDeleted: 'referentials.automationDeleted',
    automationDeleteError: 'referentials.automationDeleteError',
    automationCreateSimplified: 'referentials.automationCreateSimplified',
    automationAutoRunLabel: 'referentials.automationAutoRunLabel',
    automationAutoRunTooltip: 'referentials.automationAutoRunTooltip',
    automationActiveLabel: 'referentials.automationActiveLabel',
    automationInactiveLabel: 'referentials.automationInactiveLabel',
    importModalTitle: 'referentials.importModalTitle',
    importModalSubtitle: 'referentials.importModalSubtitle',
    importClickOrDrag: 'referentials.importClickOrDrag',
    importModeComplete: 'referentials.importModeComplete',
    importModeCompleteDesc: 'referentials.importModeCompleteDesc',
    importModeReplace: 'referentials.importModeReplace',
    importModeReplaceDesc: 'referentials.importModeReplaceDesc',
    importNext: 'referentials.importNext',
    importBack: 'referentials.importBack',
    importConfirm: 'referentials.importConfirm',
    importDuplicateTitle: 'referentials.importDuplicateTitle',
    importDuplicateHelper: 'referentials.importDuplicateHelper',
    importDuplicateOverwrite: 'referentials.importDuplicateOverwrite',
    importDuplicateOverwriteDesc: 'referentials.importDuplicateOverwriteDesc',
    importDuplicateIgnore: 'referentials.importDuplicateIgnore',
    importDuplicateIgnoreDesc: 'referentials.importDuplicateIgnoreDesc',
    importDuplicateKeepBoth: 'referentials.importDuplicateKeepBoth',
    importDuplicateKeepBothDesc: 'referentials.importDuplicateKeepBothDesc',
    importColumnMappingTitle: 'referentials.importColumnMappingTitle',
    importDuplicateKeyLabel: 'referentials.importDuplicateKeyLabel',
    importFileSummary: 'referentials.importFileSummary',
    importEmptyFile: 'referentials.importEmptyFile',
    importInvalidFile: 'referentials.importInvalidFile',
    importSuccessTitle: 'referentials.importSuccessTitle',
    importSuccessSummary: 'referentials.importSuccessSummary',
    importStatsCreated: 'referentials.importStatsCreated',
    importStatsUpdated: 'referentials.importStatsUpdated',
    importStatsIgnored: 'referentials.importStatsIgnored',
    importStatsKeptBoth: 'referentials.importStatsKeptBoth',
    importError: 'referentials.importError',
    updateByImport: 'referentials.updateByImport',
    importSkipColumn: 'referentials.importSkipColumn',
  },
  customer: {
    addNew: 'customer.addNew',
    basicInformation: 'customer.basicInformation',
    identifiers: 'customer.identifiers',
    address: 'customer.address',
    addressRequired: 'customer.addressRequired',
    corporateName: 'customer.corporateName',
    corporateNameRequired: 'customer.corporateNameRequired',
    societyType: 'customer.societyType',
    societyTypeRequired: 'customer.societyTypeRequired',
    siretNumber: 'customer.siretNumber',
    siretNumberRequired: 'customer.siretNumberRequired',
    eoriNumber: 'customer.eoriNumber',
    eoriNumberRequired: 'customer.eoriNumberRequired',
    vatNumber: 'customer.vatNumber',
    vatNumberRequired: 'customer.vatNumberRequired',
    rexNumber: 'customer.rexNumber',
    rexNumberRequired: 'customer.rexNumberRequired',
    postalCode: 'customer.postalCode',
    postalCodeRequired: 'customer.postalCodeRequired',
    city: 'customer.city',
    cityRequired: 'customer.cityRequired',
    country: 'customer.country',
    countryRequired: 'customer.countryRequired',
    otherSettings: 'customer.otherSettings',
    settingValueRequired: 'customer.settingValueRequired',
  },

  managementConsole: {
    managementConsole: 'managementConsole.managementConsole',
    userRequired: 'managementConsole.userRequired',
    sourceName: 'managementConsole.sourceName',
    sourceType: 'managementConsole.sourceType',
    settings: 'managementConsole.settings',
    apiManagement: 'managementConsole.apiManagement',
    apiKeyName: 'managementConsole.apiKeyName',
    apiKeyFingerprint: 'managementConsole.apiKeyFingerprint',
    publicKeyRequired: 'managementConsole.publicKeyRequired',
    apiKeyCreated: 'managementConsole.apiKeyCreated',
    emailAutomation: 'managementConsole.emailAutomation',
    emailAutomations: 'managementConsole.emailAutomations',
    noApiKeysFound: 'managementConsole.noApiKeysFound',
    unrecognizedFormat: 'managementConsole.unrecognizedFormat',
    invalidKey: 'managementConsole.invalidKey',
    apiManagementIntro: 'managementConsole.apiManagementIntro',
    keyDetected: 'managementConsole.keyDetected',
    createApiKey: 'managementConsole.createApiKey',
    apiKeyId: 'managementConsole.apiKeyId',
    creatingAnApiKey: 'managementConsole.creatingAnApiKey',
    apiKeyNameRequired: 'managementConsole.apiKeyNameRequired',
    apiKeyPublicKey: 'managementConsole.apiKeyPublicKey',
    createApiKeyFor: 'managementConsole.createApiKeyFor',
    errorCreatingApiKey: 'managementConsole.errorCreatingApiKey',
    allowedsenders: 'managementConsole.allowedsenders',
    declarationType: 'managementConsole.declarationType',
    clientOrganizationsIntro: 'managementConsole.clientOrganizationsIntro',
    createEmailAutomation: 'managementConsole.createEmailAutomation',
    emailPrefixRequired: 'managementConsole.emailPrefixRequired',
    creatingATableAutomationGroupAllowsYouToAutomateComplexLineLevelTableDataEntry:
      'managementConsole.creatingATableAutomationGroupAllowsYouToAutomateComplexLineLevelTableDataEntry',
    areYouSureYouWantToDeleteThisClientOrganization:
      'managementConsole.areYouSureYouWantToDeleteThisClientOrganization',
    areYouSureYouWantToDeleteThisAuthorizedSender:
      'managementConsole.areYouSureYouWantToDeleteThisAuthorizedSender',
    allowedSenderEmailRemoveSuccess:
      'managementConsole.allowedSenderEmailRemoveSuccess',
    allowedSenderEmailRemoveFailed:
      'managementConsole.allowedSenderEmailRemoveFailed',
    areYouSureYouWantToDeleteThisEmailAutomation:
      'managementConsole.areYouSureYouWantToDeleteThisEmailAutomation',
    emailAutomationUpdatedSuccessfully:
      'managementConsole.emailAutomationUpdatedSuccessfully',
    theFollowingConfigurationWillBeAutomaticallyAppliedToAnyDeclarationRequestReceivedAt:
      'managementConsole.theFollowingConfigurationWillBeAutomaticallyAppliedToAnyDeclarationRequestReceivedAt',
    whitelistingAnEmailAddressAuthorizedThatEmailAccountToRequestDeclarationsOnBehalfOfYourGroup:
      'managementConsole.whitelistingAnEmailAddressAuthorizedThatEmailAccountToRequestDeclarationsOnBehalfOfYourGroup',
    emailAutomationDestinationAddress:
      'managementConsole.emailAutomationDestinationAddress',
    anyGroupSettingKeysWillBeApplied:
      'managementConsole.anyGroupSettingKeysWillBeApplied',
    emailAutomationRemoveSuccess:
      'managementConsole.emailAutomationRemoveSuccess',
    emailAutomationRemoveFailed:
      'managementConsole.emailAutomationRemoveFailed',
    clientOrganizationRemoveSuccess:
      'managementConsole.clientOrganizationRemoveSuccess',
    clientOrganizationRemoveFailed:
      'managementConsole.clientOrganizationRemoveFailed',
    createEmailAutomationFor: 'managementConsole.createEmailAutomationFor',
    errorUpdatingEmailAutomation:
      'managementConsole.errorUpdatingEmailAutomation',
    createAllowedSender: 'managementConsole.createAllowedSender',
    createAllowedSenderFor: 'managementConsole.createAllowedSenderFor',
    noEmailAutomationsFound: 'managementConsole.noEmailAutomationsFound',
    noAllowedSenderEmailAddressesFound:
      'managementConsole.noAllowedSenderEmailAddressesFound',
    allowedSenderEmailAddress: 'managementConsole.allowedSenderEmailAddress',
    emailAutomationsIntro: 'managementConsole.emailAutomationsIntro',
    emailAutomationAddress: 'managementConsole.emailAutomationAddress',
    anyClientOrganizationSettingKeysWillBeApplied:
      'managementConsole.anyClientOrganizationSettingKeysWillBeApplied',
    noClientOrganizationsFound: 'managementConsole.noClientOrganizationsFound',
    clientOrganization: 'managementConsole.clientOrganization',
    clientOrganizationName: 'managementConsole.clientOrganizationName',
    clientOrganizationNotes: 'managementConsole.clientOrganizationNotes',
    createClientOrganization: 'managementConsole.createClientOrganization',
    clientOrganizationCreated: 'managementConsole.clientOrganizationCreated',
    errorCreatingClientOrganization:
      'managementConsole.errorCreatingClientOrganization',
    createClientOrganizationFor:
      'managementConsole.createClientOrganizationFor',
    creatingAClientOrganizationAllowsYouToAutomateActionsWhenRequestsForTheClientOrganizationAreReceived:
      'managementConsole.creatingAClientOrganizationAllowsYouToAutomateActionsWhenRequestsForTheClientOrganizationAreReceived',
    //tabs
    establishmentsAndGroups: 'managementConsole.establishmentsAndGroups',
    clientOrganizationsAssociatedToTheGroup:
      'managementConsole.clientOrganizationsAssociatedToTheGroup',
    metrics: 'managementConsole.metrics',
    member_one: 'managementConsole.member_one',
    member_other: 'managementConsole.member_other',
    members: 'managementConsole.members',
    clientOrganizations: 'managementConsole.clientOrganizations',
    general: 'managementConsole.general',
    organizationSettings: 'managementConsole.organizationSettings',
    emailAutomationTargetUser: 'managementConsole.emailAutomationTargetUser',
    emailAutomationIntelligentPreparation: 'managementConsole.emailAutomationIntelligentPreparation',
    emailAutomationIntelligentPreparationDescription:
      'managementConsole.emailAutomationIntelligentPreparationDescription',
    //general sectinon
    companyInformation: 'managementConsole.companyInformation',
    companyNameRequired: 'managementConsole.companyNameRequired',
    registrationNumberRequired: 'managementConsole.registrationNumberRequired',
    registrationNumberWarning: 'managementConsole.registrationNumberWarning',
    registrationCountryRequired:
      'managementConsole.registrationCountryRequired',
    registrationCountryWarning: 'managementConsole.registrationCountryWarning',
    darkMode: 'managementConsole.darkMode',
    organizationUpdated: 'managementConsole.organizationUpdated',
    warningToSaveTitle: 'managementConsole.warningToSave',
    warningToSaveConfirmButtonText:
      'managementConsole.warningToSaveConfirmButtonText',
    warningToSaveCancelButtonText:
      'managementConsole.warningToSaveCancelButtonText',
    organizationSettingsUpdated:
      'managementConsole.organizationSettingsUpdated',
    issuesSettingsOptions: 'managementConsole.issuesSettingsOptions',
    generalSettings: 'managementConsole.generalSettings',
    customsPreFilling: 'managementConsole.customsPreFilling',
    lockedFieldTooltip: 'managementConsole.lockedFieldTooltip',
    unlockedFieldTooltip: 'managementConsole.unlockedFieldTooltip',
    inheritedFieldTooltip: 'managementConsole.inheritedFieldTooltip',
    establishmentAndGroup: 'managementConsole.establishmentAndGroup',
    administrator: 'managementConsole.administrator',
    establishment: 'managementConsole.establishment',
    errorUpdatingSettings: 'managementConsole.errorUpdatingSettings',
    resetSettings: 'managementConsole.resetSettings',
    settingsHasBeenUpdated: 'managementConsole.settingsHasBeenUpdated',
    impossibleToLockEmptyField: 'managementConsole.impossibleToLockEmptyField',
    settingOfGroup: 'managementConsole.settingOfGroup',
    invalidEmailPrefix: 'managementConsole.invalidEmailPrefix',
    mailhookCreated: 'managementConsole.mailhookCreated',
    mailhookDeleted: 'managementConsole.mailhookDeleted',
    declarationsCreatedUsingThisEmailAutomationWillBeOwnedByTheTargetUser:
      'managementConsole.declarationsCreatedUsingThisEmailAutomationWillBeOwnedByTheTargetUser',
    errorCreatingMailhook: 'managementConsole.errorCreatingMailhook',
    errorDeletingMailhook: 'managementConsole.errorDeletingMailhook',
    addMailhook: 'managementConsole.addMailhook',
    emailPrefix: 'managementConsole.emailPrefix',
    noTargetPrefixesFound: 'managementConsole.noTargetPrefixesFound',
    targetPrefixes: 'managementConsole.targetPrefixes',
    targetUser: 'managementConsole.targetUser',
    mailhookWhitelist: 'managementConsole.mailhookWhitelist',
    invalidEmail: 'managementConsole.invalidEmail',
    emailWhitelisted: 'managementConsole.emailWhitelisted',
    emailRemoved: 'managementConsole.emailRemoved',
    errorWhitelistingEmail: 'managementConsole.errorWhitelistingEmail',
    errorRemovingEmail: 'managementConsole.errorRemovingEmail',
    addEmail: 'managementConsole.addEmail',
    noClient: 'managementConsole.noClient',
    createClient: 'managementConsole.createClient',
    tableAutomation: 'managementConsole.tableAutomation',
    tableAutomations: 'managementConsole.tableAutomations',
    tableAutomationsIntro: 'managementConsole.tableAutomationsIntro',
    tableAutomationsRequiresNewSchema:
      'managementConsole.tableAutomationsRequiresNewSchema',
    tableAutomationsNewSchemaOnlyAlert:
      'managementConsole.tableAutomationsNewSchemaOnlyAlert',
    tableAutomationsEligibleConfigsOnly:
      'managementConsole.tableAutomationsEligibleConfigsOnly',
    createTableAutomationGroup: 'managementConsole.createTableAutomationGroup',
    onlyExcelFilesAreAccepted: 'managementConsole.onlyExcelFilesAreAccepted',
    dropText: 'managementConsole.dropText',
    dropSubtext: 'managementConsole.dropSubtext',
    noTableAutomationGroupsFound:
      'managementConsole.noTableAutomationGroupsFound',
    tableAutomationGroupName: 'managementConsole.tableAutomationGroupName',
    tableAutomationGroupNameRequired:
      'managementConsole.tableAutomationGroupNameRequired',
    enterAName: 'managementConsole.enterAName',
    selectedConfiguration: 'managementConsole.selectedConfiguration',
    templateRequired: 'managementConsole.templateRequired',
    selectATemplate: 'managementConsole.selectATemplate',
    configuration: 'managementConsole.configuration',
    fileToUpload: 'managementConsole.fileToUpload',
    tableAutomationGroupParameters:
      'managementConsole.tableAutomationGroupParameters',
    ruleBuilder: 'managementConsole.ruleBuilder',
    rule: 'managementConsole.rule',
    lineProperty: 'managementConsole.lineProperty',
    column: 'managementConsole.column',
    IS: 'managementConsole.IS',
    IF: 'managementConsole.IF',
    THEN: 'managementConsole.THEN',
    addCondition: 'managementConsole.addCondition',
    setReferenceRows: 'managementConsole.setReferenceRows',
    removeAllRows: 'managementConsole.removeAllRows',
    removeSelectedRows: 'managementConsole.removeSelectedRows',
    addToPayload: 'managementConsole.addToPayload',
    payload: 'managementConsole.payload',
    relations: 'managementConsole.relations',
    thenTheFollowingValuesWillBeApplied:
      'managementConsole.thenTheFollowingValuesWillBeApplied',
    ifTheFollowingConditionsAreTrue:
      'managementConsole.ifTheFollowingConditionsAreTrue',
    validateRules: 'managementConsole.validateRules',
    createTheAutomationGroup: 'managementConsole.createTheAutomationGroup',
    automationGroupRules: 'managementConsole.automationGroupRules',
    areYouSureYouWantToDeleteTheTableAutomationGroup:
      'managementConsole.areYouSureYouWantToDeleteTheTableAutomationGroup',
    tableAutomationGroupRemoveSuccess:
      'managementConsole.tableAutomationGroupRemoveSuccess',
    referenceRows: 'managementConsole.referenceRows',
    tableAutomationGroupCreated:
      'managementConsole.tableAutomationGroupCreated',
    tableAutomationGroupUpdatedSuccessfully:
      'managementConsole.tableAutomationGroupUpdatedSuccessfully',
    tableAutomationsSelectHelperText:
      'managementConsole.tableAutomationsSelectHelperText',
    errorCreatingTableAutomationGroup:
      'managementConsole.errorCreatingTableAutomationGroup',
  },

  account: {
    generalSettings: 'account.generalSettings',
    customsPreFilling: 'account.customsPreFilling',
    settingsHasBeenUpdated: 'account.settingsHasBeenUpdated',
    errorUpdatingSettings: 'account.errorUpdatingSettings',
    resetSettings: 'account.resetSettings',
  },
  store: {
    anErrorOccurred: 'store.anErrorOccurred',
    unableToUpdateBoundingRectangle: 'store.unableToUpdateBoundingRectangle',
    targetExportFieldIsNotEmpty: 'store.targetExportFieldIsNotEmpty',
    targetExportFieldNotFound: 'store.targetExportFieldNotFound',
    unableToCreateColumnSomeCellsAreInvalid:
      'store.unableToCreateColumnSomeCellsAreInvalid',
    unableToCreateColumnTableAndColumnRowsMustBeIdentical:
      'store.unableToCreateColumnTableAndColumnRowsMustBeIdentical',
    cannotDeleteLastRowOfPage: 'store.cannotDeleteLastRowOfPage',
    thereIsAlreadyATableOnThisPage: 'store.thereIsAlreadyATableOnThisPage',
    unableToProjectCellsOntoNewTable: 'store.unableToProjectCellsOntoNewTable',
    unableToProjectEmptyRowOntoNewPage:
      'store.unableToProjectEmptyRowOntoNewPage',
    newTableIsTooSmallToProjectCellsFromExistingTable:
      'store.newTableIsTooSmallToProjectCellsFromExistingTable',
    referenceRowCellsTouchSourceGridEdge:
      'store.referenceRowCellsTouchSourceGridEdge',
    tableHasNoRows: 'store.tableHasNoRows',
    unableToIdentifyTheCurrentRow: 'store.unableToIdentifyTheCurrentRow',
    cannotDragTableCellIntoADifferentRow:
      'store.cannotDragTableCellIntoADifferentRow',
    tableCellTooSmallOrInverted: 'store.tableCellTooSmallOrInverted',
    tableCellCannotGoOutOfItsRowVertically:
      'store.tableCellCannotGoOutOfItsRowVertically',
    tableCellGoesOutOfTableOnTheLeft: 'store.tableCellGoesOutOfTableOnTheLeft',
    tableCellGoesOutOfTableOnTheRight:
      'store.tableCellGoesOutOfTableOnTheRight',
    tableCellGoesOutOfTableOnTheTop: 'store.tableCellGoesOutOfTableOnTheTop',
    tableCellGoesOutOfTableOnTheBottom:
      'store.tableCellGoesOutOfTableOnTheBottom',
    missingMergeColumnsInSourceTable: 'store.missingMergeColumnsInSourceTable',
    mergeKeysNotSpecificEnough: 'store.mergeKeysNotSpecificEnough',
  },
  richText: {
    bold: 'richText.bold',
    italic: 'richText.italic',
    underline: 'richText.underline',
    strikethrough: 'richText.strikethrough',
    subscript: 'richText.subscript',
    superscript: 'richText.superscript',
    textColor: 'richText.textColor',
    highlightColor: 'richText.highlightColor',
    removeFormatting: 'richText.removeFormatting',
    orderedList: 'richText.orderedList',
    bulletedList: 'richText.bulletedList',
    taskList: 'richText.taskList',
    undo: 'richText.undo',
    redo: 'richText.redo',
    heading: 'richText.heading',
    blockquote: 'richText.blockquote',
    code: 'richText.code',
    codeBlock: 'richText.codeBlock',
    horizontalRule: 'richText.horizontalRule',
    addTable: 'richText.addTable',
    editLink: 'richText.editLink',
    textAlign: 'richText.textAlign',
    indent: 'richText.indent',
    unindent: 'richText.unindent',
    fontFamily: 'richText.fontFamily',
    fontSize: 'richText.fontSize',
    imageUpload: 'richText.imageUpload',
    cancelButton: 'richText.cancelButton',
    removeColorButton: 'richText.removeColorButton',
    removeColorButtonTooltipTitle: 'richText.removeColorButtonTooltipTitle',
    empty: 'richText.empty',
    paragraph: 'richText.paragraph',
    left: 'richText.left',
    right: 'richText.right',
    center: 'richText.center',
    justify: 'richText.justify',
  },
  whatsNew: {
    menuTitle: 'whatsNew.menuTitle',
    newBadge: 'whatsNew.newBadge',
    dialogSubtitle: 'whatsNew.dialogSubtitle',
    footerQuestion: 'whatsNew.footerQuestion',
    footerContact: 'whatsNew.footerContact',
    understood: 'whatsNew.understood',
    carouselNewer: 'whatsNew.carouselNewer',
    carouselOlder: 'whatsNew.carouselOlder',
    latest: 'whatsNew.latest',
    releasePager: 'whatsNew.releasePager',
    goToVersion: 'whatsNew.goToVersion',
    versionPill: 'whatsNew.versionPill',
    sectionFeatures: 'whatsNew.sectionFeatures',
    sectionFixes: 'whatsNew.sectionFixes',
    featureCount: 'whatsNew.featureCount',
    featureCount_other: 'whatsNew.featureCount_other',
    fixCount: 'whatsNew.fixCount',
    fixCount_other: 'whatsNew.fixCount_other',
    environmentPrefix: 'whatsNew.environmentPrefix',
    emptyState: 'whatsNew.emptyState',
  },
  productTour: {
    next: 'productTour.next',
    previous: 'productTour.previous',
    finish: 'productTour.finish',
    stepCounter: 'productTour.stepCounter',
    launcher: 'productTour.launcher',
    eyebrow: 'productTour.eyebrow',
    skip: 'productTour.skip',
    coachLabel: 'productTour.coachLabel',
    close: 'productTour.close',
    start: 'productTour.start',
    introStepsCount: 'productTour.introStepsCount',
    goToStep: 'productTour.goToStep',
  },
  notifications: {
    title: 'notifications.title',
    menuTitle: 'notifications.menuTitle',
    markAllRead: 'notifications.markAllRead',
    clearAll: 'notifications.clearAll',
    moreActions: 'notifications.moreActions',
    group_today: 'notifications.group.today',
    group_yesterday: 'notifications.group.yesterday',
    group_earlier: 'notifications.group.earlier',
    unreadCount: 'notifications.unreadCount',
    empty: 'notifications.empty',
    loadMore: 'notifications.loadMore',
    dossier: 'notifications.dossier',
    dossierUnnamed: 'notifications.dossierUnnamed',
    dossierNotFound: 'notifications.dossierNotFound',
    types_declaration_status_changed:
      'notifications.types.declaration_status_changed',
    types_declaration_comment_added:
      'notifications.types.declaration_comment_added',
    types_declaration_sent_by_collaborator:
      'notifications.types.declaration_sent_by_collaborator',
    types_declaration_returned_for_correction:
      'notifications.types.declaration_returned_for_correction',
    types_app_update: 'notifications.types.app_update',
    types_app_update_generic: 'notifications.types.app_update_generic',
    types_unknown: 'notifications.types.unknown',
    trackingMessage_toTreat: 'notifications.trackingMessage.toTreat',
    trackingMessage_exportFailed: 'notifications.trackingMessage.exportFailed',
    trackingMessage_error: 'notifications.trackingMessage.error',
    statusChanged_mareva: 'notifications.statusChanged.mareva',
    status_unknown: 'notifications.status.unknown',
    status_mareva_accepted: 'notifications.status.mareva.accepted',
    status_mareva_processing: 'notifications.status.mareva.processing',
    status_mareva_rejected: 'notifications.status.mareva.rejected',
    systemActorCustoms: 'notifications.systemActorCustoms',
    commentMessage: 'notifications.commentMessage',
    commentMessage_fallback: 'notifications.commentMessage_fallback',
    sentMessage: 'notifications.sentMessage',
    invalidationRequestedMessage: 'notifications.invalidationRequestedMessage',
    invalidationRequestedMessage_fallback:
      'notifications.invalidationRequestedMessage_fallback',
    statusMessage_mareva_accepted: 'notifications.statusMessage.mareva.accepted',
    statusMessage_mareva_processing:
      'notifications.statusMessage.mareva.processing',
    statusMessage_mareva_rejected: 'notifications.statusMessage.mareva.rejected',
  },
  commandBar: {
    searchPlaceholder: 'commandBar.searchPlaceholder',
    sectionOnDeclaration: 'commandBar.sectionOnDeclaration',
    sectionQuickActions: 'commandBar.sectionQuickActions',
    sectionRecents: 'commandBar.sectionRecents',
    sectionActions: 'commandBar.sectionActions',
    sectionDocuments: 'commandBar.sectionDocuments',
    sectionClients: 'commandBar.sectionClients',
    sectionReferentials: 'commandBar.sectionReferentials',
    sectionFlux: 'commandBar.sectionFlux',
    noResults: 'commandBar.noResults',
    recentBadge: 'commandBar.recentBadge',
    footerSelect: 'commandBar.footerSelect',
    footerOpen: 'commandBar.footerOpen',
    footerClose: 'commandBar.footerClose',
    fieldAgency: 'commandBar.fieldAgency',
    fieldConfiguration: 'commandBar.fieldConfiguration',
    actionApplyReferentialDeclaration:
      'commandBar.actionApplyReferentialDeclaration',
    actionRunAutomationDeclaration: 'commandBar.actionRunAutomationDeclaration',
    actionChangeModelDeclaration: 'commandBar.actionChangeModelDeclaration',
    actionDuplicateFolder: 'commandBar.actionDuplicateFolder',
    actionCreateFolder: 'commandBar.actionCreateFolder',
    actionAddReferential: 'commandBar.actionAddReferential',
    actionAddModel: 'commandBar.actionAddModel',
    actionAddClient: 'commandBar.actionAddClient',
    actionCreateAutomation: 'commandBar.actionCreateAutomation',
    actionApplyAutomation: 'commandBar.actionApplyAutomation',
    actionApplyModel: 'commandBar.actionApplyModel',
    actionGoDashboard: 'commandBar.actionGoDashboard',
    actionViewAllDocuments: 'commandBar.actionViewAllDocuments',
    actionOpenSettings: 'commandBar.actionOpenSettings',
    triggerPlaceholder: 'commandBar.triggerPlaceholder',
    triggerTooltip: 'commandBar.triggerTooltip',
  },
  mcpOAuth: {
    title: 'mcpOAuth.title',
    asksAccess: 'mcpOAuth.asksAccess',
    afterConfirm: 'mcpOAuth.afterConfirm',
    allow: 'mcpOAuth.allow',
    deny: 'mcpOAuth.deny',
    invalidRequest: 'mcpOAuth.invalidRequest',
    expired: 'mcpOAuth.expired',
    sessionExpired: 'mcpOAuth.sessionExpired',
    cannotComplete: 'mcpOAuth.cannotComplete',
    invalidRedirect: 'mcpOAuth.invalidRedirect',
  },
  dauSheet: {
    europeanCommunity: 'dauSheet.europeanCommunity',
    numberMark: 'dauSheet.numberMark',
    box1: 'dauSheet.box1',
    boxA: 'dauSheet.boxA',
    clearanceOffice: 'dauSheet.clearanceOffice',
    declarationOffice: 'dauSheet.declarationOffice',
    exportDeclaration: 'dauSheet.exportDeclaration',
    box2: 'dauSheet.box2',
    box3: 'dauSheet.box3',
    box4: 'dauSheet.box4',
    box5: 'dauSheet.box5',
    box6: 'dauSheet.box6',
    box7: 'dauSheet.box7',
    box8: 'dauSheet.box8',
    foreignConsignee: 'dauSheet.foreignConsignee',
    box9: 'dauSheet.box9',
    box10: 'dauSheet.box10',
    box10Sub: 'dauSheet.box10Sub',
    box11: 'dauSheet.box11',
    box11Sub: 'dauSheet.box11Sub',
    box12: 'dauSheet.box12',
    box13: 'dauSheet.box13',
    box14: 'dauSheet.box14',
    representationMode: 'dauSheet.representationMode',
    approvalNumber: 'dauSheet.approvalNumber',
    box15: 'dauSheet.box15',
    box15Code: 'dauSheet.box15Code',
    box17Code: 'dauSheet.box17Code',
    box16: 'dauSheet.box16',
    box17: 'dauSheet.box17',
    box20: 'dauSheet.box20',
    box18: 'dauSheet.box18',
    box19: 'dauSheet.box19',
    box21: 'dauSheet.box21',
    box22: 'dauSheet.box22',
    box23: 'dauSheet.box23',
    box24: 'dauSheet.box24',
    box25: 'dauSheet.box25',
    box25Sub: 'dauSheet.box25Sub',
    box26: 'dauSheet.box26',
    box26Sub: 'dauSheet.box26Sub',
    box27: 'dauSheet.box27',
    box28: 'dauSheet.box28',
    box29: 'dauSheet.box29',
    box30: 'dauSheet.box30',
    box31: 'dauSheet.box31',
    box31Sub: 'dauSheet.box31Sub',
    box31Header: 'dauSheet.box31Header',
    numberAndKind: 'dauSheet.numberAndKind',
    marksAndNumbers: 'dauSheet.marksAndNumbers',
    containerNumber: 'dauSheet.containerNumber',
    box32: 'dauSheet.box32',
    box33: 'dauSheet.box33',
    firstAdditionalCode: 'dauSheet.firstAdditionalCode',
    secondAdditionalCode: 'dauSheet.secondAdditionalCode',
    box34: 'dauSheet.box34',
    box35: 'dauSheet.box35',
    box36: 'dauSheet.box36',
    box37: 'dauSheet.box37',
    box38: 'dauSheet.box38',
    box39: 'dauSheet.box39',
    box40: 'dauSheet.box40',
    box41: 'dauSheet.box41',
    box42: 'dauSheet.box42',
    box43: 'dauSheet.box43',
    additionalInformationCode: 'dauSheet.additionalInformationCode',
    box44: 'dauSheet.box44',
    box44Sub: 'dauSheet.box44Sub',
    nationalAdditionalCodes: 'dauSheet.nationalAdditionalCodes',
    attachedDocuments: 'dauSheet.attachedDocuments',
    box45: 'dauSheet.box45',
    box46: 'dauSheet.box46',
    box47: 'dauSheet.box47',
    box47Sub: 'dauSheet.box47Sub',
    box47Full: 'dauSheet.box47Full',
    totalFirstItem: 'dauSheet.totalFirstItem',
    totalSecondItem: 'dauSheet.totalSecondItem',
    totalThirdItem: 'dauSheet.totalThirdItem',
    box48: 'dauSheet.box48',
    box49: 'dauSheet.box49',
    boxB: 'dauSheet.boxB',
    guaranteedRisk: 'dauSheet.guaranteedRisk',
    totalAmountPayable: 'dauSheet.totalAmountPayable',
    amountUsedEc: 'dauSheet.amountUsedEc',
    guaranteed: 'dauSheet.guaranteed',
    notGuaranteed: 'dauSheet.notGuaranteed',
    controlByOffice: 'dauSheet.controlByOffice',
    stamp: 'dauSheet.stamp',
    controlResult: 'dauSheet.controlResult',
    sealsAffixed: 'dauSheet.sealsAffixed',
    sealMarks: 'dauSheet.sealMarks',
    timeLimit: 'dauSheet.timeLimit',
    signature: 'dauSheet.signature',
    box54: 'dauSheet.box54',
    editionDate: 'dauSheet.editionDate',
    validationDate: 'dauSheet.validationDate',
    declarationStatus: 'dauSheet.declarationStatus',
    procedureType: 'dauSheet.procedureType',
    declarantSignature: 'dauSheet.declarantSignature',
    statusShort: 'dauSheet.statusShort',
    printedOn: 'dauSheet.printedOn',
  },
}
